
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequiref920"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequiref920"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("5TIC4", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return (parcelRequire("6Lfpq")).default; });

var $6Lfpq = parcelRequire("6Lfpq");

});
parcelRegister("6Lfpq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $67ea48e347ad7dcf$export$2e2bcd8739ae039; });
/* personalization-container.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $iSvIT = parcelRequire("iSvIT");

var $aiugz = parcelRequire("aiugz");

var $g9kzu = parcelRequire("g9kzu");

var $5ohHq = parcelRequire("5ohHq");

var $9iWJ8 = parcelRequire("9iWJ8");

var $gAJUc = parcelRequire("gAJUc");

var $kNCWT = parcelRequire("kNCWT");

var $jFQmg = parcelRequire("jFQmg");

var $1mZZG = parcelRequire("1mZZG");

var $bQiYD = parcelRequire("bQiYD");
var $67ea48e347ad7dcf$var$VariantsStatus;
(function(VariantsStatus) {
    VariantsStatus["NO_VARIANT_MATCH"] = "no_variant_match";
    VariantsStatus["VARIANTS_AVAILABLE"] = "variants_available";
    VariantsStatus["FETCHING_SEGMENTS"] = "fetching_segments";
    VariantsStatus["SEGMENT_FETCH_ERROR"] = "segment_fetch_error";
    VariantsStatus["MISSING_USER_SEGMENTS"] = "missing_user_segments";
    VariantsStatus["PERSONALIZATION_DISABLED"] = "personalization_disabled";
    VariantsStatus["NOT_ENROLLED_IN_EXPERIMENT"] = "not_enrolled_in_experiment";
})($67ea48e347ad7dcf$var$VariantsStatus || ($67ea48e347ad7dcf$var$VariantsStatus = {}));
const $67ea48e347ad7dcf$var$VariantSelector = (props)=>{
    return(// this should only be one item, but the SlotWrapper expects an array
    /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).Fragment, {
        children: props.items.map((item, index)=>/*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).Fragment, {
                children: item
            }, index))
    }));
}; // Helper function to render default slot
const $67ea48e347ad7dcf$var$renderDefaultSlot = (variantStatus, setRenderMessage)=>{
    const messages = {
        ["no_variant_match"]: "No variants match. Rendering Default",
        ["missing_user_segments"]: "No User Segments acquired. Rendering Default",
        ["personalization_disabled"]: "Personalization is disabled. Rendering Default",
        ["segment_fetch_error"]: "Error fetching User Segments. Rendering Default",
        ["not_enrolled_in_experiment"]: "User not enrolled in experiment. Rendering Default",
        ["fetching_segments"]: "Fetching User Segments. Temporarily rendering Default",
        // never invoked, but needed to satisfy the type system s
        ["variants_available"]: ""
    };
    setRenderMessage(messages[variantStatus]);
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $aiugz.UniformSlot), {
        name: "default",
        wrapperComponent: $67ea48e347ad7dcf$var$VariantSelector
    });
}; // Helper function to find matching variant index
const $67ea48e347ad7dcf$var$findMatchingVariant = (variantCandidates, personalizationSegmentValues)=>{
    if (!personalizationSegmentValues) return -1;
    return variantCandidates.findIndex((variantCandidate)=>{
        var _variantCandidate_parameters_personalizationSegment, _variantCandidate_parameters;
        // all user segments specified by the Author in the variant (product, job function, domain type, etc.)
        const segments = (_variantCandidate_parameters = variantCandidate.parameters) === null || _variantCandidate_parameters === void 0 ? void 0 : (_variantCandidate_parameters_personalizationSegment = _variantCandidate_parameters["personalizationSegment"]) === null || _variantCandidate_parameters_personalizationSegment === void 0 ? void 0 : _variantCandidate_parameters_personalizationSegment.value; // check if all segments match the user's profile
        return segments.every(({ segmentType: segmentType, value: segmentTargets })=>{
            const userValueForThisSegment = personalizationSegmentValues[segmentType]; // if the user doesn't have a value for this segment, it can't match
            if (!userValueForThisSegment) return false;
             // handle owned products differently, since it's an array of products.
            if (segmentType === (0, $bQiYD.UserSegmentTypes).OWNED_PRODUCTS) // we want to check if any of the user's owned products match one of the author-defined segment's value
            return segmentTargets.some((product)=>userValueForThisSegment.includes(product));
             // for all other single-valued segments, simply check if the user's value
            return segmentTargets.includes(userValueForThisSegment || "");
        });
    });
}; // Helper function to get final personalization values
const $67ea48e347ad7dcf$var$getFinalPersonalizationValues = (userSegments, overrides)=>{
    const finalValues = (0, $6iHNw._)((0, $7Knp0._)({}, userSegments, (overrides === null || overrides === void 0 ? void 0 : overrides.useOverrides) ? overrides : {}), {
        useOverrides: (overrides === null || overrides === void 0 ? void 0 : overrides.useOverrides) || false,
        enrollInExperiment: (overrides === null || overrides === void 0 ? void 0 : overrides.enrollInExperiment) || false
    });
    return finalValues;
};
const $67ea48e347ad7dcf$var$ExperimentallyPersonalizedSection = ({ experimentId: experimentId, setVariantStatus: setVariantStatus, overrides: overrides, setRenderMessage: setRenderMessage, variantComponent: variantComponent })=>{
    const experimentStatus = (0, $9iWJ8.useExperiment)({
        experimentName: experimentId,
        parameterName: "enrolled",
        defaultValue: false,
        options: {
            fireExperimentExposure: true,
            typeGuard: (value)=>typeof value === "boolean"
        },
        targeting: {
            cohort: ()=>true
        },
        metadata: {
            description: "Personalization Experiment - configured in Uniform",
            expectedReleaseDate: "unknown - configured in Uniform",
            expectedRuntime: "unknown - configured in Uniform",
            context: {
                urls: []
            }
        }
    });
    const showTreatment = experimentStatus.type === "enrolled" && experimentStatus.value;
    (0, $iSvIT.useEffect)(()=>{
        if (!showTreatment && !(overrides === null || overrides === void 0 ? void 0 : overrides.enrollInExperiment)) {
            if (setVariantStatus) setVariantStatus("not_enrolled_in_experiment");
        }
    }, [
        showTreatment,
        overrides === null || overrides === void 0 ? void 0 : overrides.enrollInExperiment,
        setVariantStatus
    ]);
    if (!showTreatment && !(overrides === null || overrides === void 0 ? void 0 : overrides.enrollInExperiment)) return $67ea48e347ad7dcf$var$renderDefaultSlot("not_enrolled_in_experiment", setRenderMessage);
    return variantComponent;
}; // Helper function to validate personalization prerequisites
const $67ea48e347ad7dcf$var$validatePersonalizationPrerequisites = (shouldPersonalize, userSegments, userSegmentStatus, error, overrides)=>{
    if (userSegmentStatus !== "complete") return {
        isValid: false,
        status: "fetching_segments"
    };
    if (!shouldPersonalize) return {
        isValid: false,
        status: "personalization_disabled"
    };
    if (!userSegments) return {
        isValid: false,
        status: "missing_user_segments"
    };
    if (error && !(overrides === null || overrides === void 0 ? void 0 : overrides.useOverrides)) return {
        isValid: false,
        status: "segment_fetch_error"
    };
    return {
        isValid: true
    };
}; // Helper function to create variant component
const $67ea48e347ad7dcf$var$createVariantComponent = (chosenVariantIndex)=>/*#__PURE__*/ (0, $loA2J.jsx)((0, $aiugz.UniformSlot), {
        name: "variants",
        wrapperComponent: (slotProps)=>$67ea48e347ad7dcf$var$VariantSelector((0, $6iHNw._)((0, $7Knp0._)({}, slotProps), {
                items: [
                    slotProps.items[chosenVariantIndex]
                ]
            }))
    }); // Helper function to set render message for variant
const $67ea48e347ad7dcf$var$setVariantRenderMessage = (variantCandidates, chosenVariantIndex, overrides, setRenderMessage)=>{
    const variantName = $67ea48e347ad7dcf$var$getCurrentVariantName(variantCandidates, chosenVariantIndex);
    const sourceType = (overrides === null || overrides === void 0 ? void 0 : overrides.useOverrides) ? "Overrides" : "User Segments";
    setRenderMessage(`Rendering "${variantName}" Variant based on ${sourceType}`);
};
const $67ea48e347ad7dcf$var$getCurrentVariantName = (variantCandidates, chosenVariantIndex)=>{
    var _variantCandidates_chosenVariantIndex_parameters_variantName, _variantCandidates_chosenVariantIndex_parameters, _variantCandidates_chosenVariantIndex;
    return ((_variantCandidates_chosenVariantIndex = variantCandidates[chosenVariantIndex]) === null || _variantCandidates_chosenVariantIndex === void 0 ? void 0 : (_variantCandidates_chosenVariantIndex_parameters = _variantCandidates_chosenVariantIndex.parameters) === null || _variantCandidates_chosenVariantIndex_parameters === void 0 ? void 0 : (_variantCandidates_chosenVariantIndex_parameters_variantName = _variantCandidates_chosenVariantIndex_parameters["variantName"]) === null || _variantCandidates_chosenVariantIndex_parameters_variantName === void 0 ? void 0 : _variantCandidates_chosenVariantIndex_parameters_variantName.value) || "unknown";
};
const $67ea48e347ad7dcf$var$PersonalizedSection = (props)=>{
    var _composition_data;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $g9kzu.useAnalyticsEvents)();
    const analyticsClient = (0, $jFQmg.useAnalyticsClient)();
    const [selectedVariantKey, setSelectedVariantKey] = (0, $iSvIT.useState)(null);
    const [variantStatus, setVariantStatus] = (0, $iSvIT.useState)(null);
    const [renderedExperience, setRenderedExperience] = (0, $iSvIT.useState)(null);
    const { data: userSegments, error: error, status: userSegmentStatus } = (0, $bQiYD.useUserSegments)();
    const shouldPersonalize = (0, $gAJUc.checkFeatureFlagGate)((0, $gAJUc.featureFlags).uniformPersonalizationEnabled);
    const composition = (0, $aiugz.useUniformCurrentComposition)();
    const compositionId = composition === null || composition === void 0 ? void 0 : (_composition_data = composition.data) === null || _composition_data === void 0 ? void 0 : _composition_data._id; // Memoize slots to prevent infinite loops
    const variantSlots = (0, $iSvIT.useMemo)(()=>{
        var _props_component_slots;
        var _props_component_slots_variants;
        return (_props_component_slots_variants = (_props_component_slots = props.component.slots) === null || _props_component_slots === void 0 ? void 0 : _props_component_slots["variants"]) !== null && _props_component_slots_variants !== void 0 ? _props_component_slots_variants : [];
    }, [
        props.component.slots
    ]); // Send metrics once when variant changes
    (0, $iSvIT.useEffect)(()=>{
        const validation = $67ea48e347ad7dcf$var$validatePersonalizationPrerequisites(shouldPersonalize, userSegments, userSegmentStatus, error, props.overrides);
        if (!validation.isValid) {
            setSelectedVariantKey("default_experience");
            setVariantStatus(validation.status);
            setRenderedExperience($67ea48e347ad7dcf$var$renderDefaultSlot(validation.status, props.setRenderMessage));
            return;
        } // Process personalization logic
        const personalizationValues = $67ea48e347ad7dcf$var$getFinalPersonalizationValues(userSegments, props.overrides);
        const chosenVariantIndex = $67ea48e347ad7dcf$var$findMatchingVariant(variantSlots, personalizationValues); // Check if variant was found
        if (chosenVariantIndex < 0) {
            setSelectedVariantKey("default_experience");
            setVariantStatus("no_variant_match");
            setRenderedExperience($67ea48e347ad7dcf$var$renderDefaultSlot("no_variant_match", props.setRenderMessage));
            return;
        }
        const variantName = $67ea48e347ad7dcf$var$getCurrentVariantName(variantSlots, chosenVariantIndex);
        setSelectedVariantKey(variantName);
        setVariantStatus("variants_available");
        $67ea48e347ad7dcf$var$setVariantRenderMessage(variantSlots, chosenVariantIndex, props.overrides, props.setRenderMessage);
        const variantComponent = $67ea48e347ad7dcf$var$createVariantComponent(chosenVariantIndex);
        setRenderedExperience(variantComponent); // Handle experimental personalization
        if (props.experimentId) setRenderedExperience(/*#__PURE__*/ (0, $loA2J.jsx)($67ea48e347ad7dcf$var$ExperimentallyPersonalizedSection, {
            containerName: props.containerName,
            setRenderMessage: props.setRenderMessage,
            setVariantStatus: setVariantStatus,
            experimentId: props.experimentId,
            variantComponent: variantComponent,
            overrides: props.overrides,
            component: props.component
        }));
        return;
    }, [
        error,
        props.overrides,
        props.setRenderMessage,
        props.experimentId,
        props.containerName,
        props.component,
        shouldPersonalize,
        userSegmentStatus,
        userSegments,
        variantSlots,
        setVariantStatus
    ]);
    (0, $iSvIT.useEffect)(()=>{
        if (!selectedVariantKey || !variantStatus) return;
        if (analyticsClient) createAnalyticsEvent({
            name: "waePersonalizationVariantRender",
            action: "personalizationVariantRender",
            actionSubject: "uniformPage",
            eventType: "screen",
            source: window.location.pathname,
            attributes: {
                containerName: props.containerName,
                path: window.location.pathname,
                compositionId: compositionId,
                variantName: selectedVariantKey,
                status: variantStatus
            }
        }).fire();
    }, [
        compositionId,
        createAnalyticsEvent,
        selectedVariantKey,
        props.containerName,
        variantStatus,
        analyticsClient
    ]);
    return renderedExperience;
};
const $67ea48e347ad7dcf$var$UniformPersonalizationContainer = (props)=>{
    const isProd = (0, $kNCWT.isProduction)();
    const [overrides, setOverrides] = (0, $iSvIT.useState)({
        useOverrides: false,
        enrollInExperiment: false
    });
    const [renderMessage, setRenderMessage] = (0, $iSvIT.useState)("");
    const [isContainerHovered, setIsContainerHovered] = (0, $iSvIT.useState)(false);
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        onMouseEnter: !isProd ? ()=>setIsContainerHovered(true) : undefined,
        onMouseLeave: !isProd ? ()=>setIsContainerHovered(false) : undefined,
        className: (0, $esG4f.default)([
            "_kqswh2mm _19itv6l3 _2rko1m5y _1yt4u2gc _v564u973 _1qs911pv"
        ]),
        style: {
            "--_1k5ts5z": (0, $43MIc.default)(!isProd && isContainerHovered ? `2px solid ${(0, $5ohHq.wacToken)("color.extended.blue300")}` : "2px solid transparent"),
            "--_1r0zder": (0, $43MIc.default)(!isProd ? (0, $5ohHq.wacToken)("corner.radius.card") : "0"),
            "--_i1pnuw": (0, $43MIc.default)(!isProd ? "border-color 0.2s ease" : "none"),
            "--_hiqpr4": (0, $43MIc.default)(!isProd ? {
                border: `2px solid ${(0, $5ohHq.wacToken)("color.extended.blue300")}`
            } : {})
        },
        children: [
            !isProd && /*#__PURE__*/ (0, $loA2J.jsx)((0, $1mZZG.PersonalizationOverrideControls), {
                values: overrides,
                setValues: setOverrides,
                renderMessage: renderMessage,
                isContainerHovered: isContainerHovered
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)($67ea48e347ad7dcf$var$PersonalizedSection, (0, $6iHNw._)((0, $7Knp0._)({}, props), {
                overrides: overrides,
                setRenderMessage: setRenderMessage,
                experimentId: props.experimentId
            }))
        ]
    });
};
var $67ea48e347ad7dcf$export$2e2bcd8739ae039 = $67ea48e347ad7dcf$var$UniformPersonalizationContainer;

});
parcelRegister("1mZZG", function(module, exports) {

$parcel$export(module.exports, "PersonalizationOverrideControls", function () { return $1acdd970fef71b54$export$3509149ef9c5f46; });
/* personalization-controls.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $iSvIT = parcelRequire("iSvIT");
parcelRequire("fYEXy");
var $53o08 = parcelRequire("53o08");
parcelRequire("9REvE");
var $2m1xf = parcelRequire("2m1xf");

var $9Yq3D = parcelRequire("9Yq3D");

var $5ohHq = parcelRequire("5ohHq");

var $bQiYD = parcelRequire("bQiYD");
const $1acdd970fef71b54$var$JOB_FUNCTION = [
    {
        value: "engineering",
        label: "Engineering"
    },
    {
        value: "product management",
        label: "Product Management"
    },
    {
        value: "design",
        label: "Design"
    },
    {
        value: "data science",
        label: "Data Science"
    },
    {
        value: "marketing",
        label: "Marketing"
    },
    {
        value: "sales",
        label: "Sales"
    },
    {
        value: "human resources",
        label: "Human Resources"
    },
    {
        value: "finance",
        label: "Finance"
    },
    {
        value: "operations",
        label: "Operations"
    },
    {
        value: "legal",
        label: "Legal"
    },
    {
        value: "customer success",
        label: "Customer Success"
    },
    {
        value: "executive",
        label: "Executive"
    },
    {
        value: "other",
        label: "Other"
    },
    {
        value: "information technology",
        label: "Information Technology"
    },
    {
        value: "customer service",
        label: "Customer Service"
    },
    {
        value: "program management",
        label: "Program Management"
    },
    {
        value: "c-suite",
        label: "C-Suite"
    }
];
const $1acdd970fef71b54$var$PRODUCT_OPTIONS = [
    {
        value: "jira",
        label: "Jira"
    },
    {
        value: "confluence",
        label: "Confluence"
    },
    {
        value: "jsm",
        label: "JSM"
    },
    {
        value: "loom",
        label: "Loom"
    },
    {
        value: "jpd",
        label: "JPD"
    },
    {
        value: "rovo",
        label: "Rovo"
    }
];
const $1acdd970fef71b54$var$PersonalizationControlPanel = ({ values: values, handleSelectChange: handleSelectChange })=>{
    var _JOB_FUNCTION_find;
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        className: (0, $esG4f.default)([
            "_1e0c1txw _2lx21bp4 _zulpu2gc"
        ]),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                onClick: (e)=>{
                    const target = e.target;
                    if (target.type === "checkbox") handleSelectChange("enrollInExperiment", target.checked);
                },
                onKeyDown: (e)=>{
                    if (e.key === "Enter" || e.key === " ") {
                        e.preventDefault();
                        handleSelectChange("enrollInExperiment", !values.enrollInExperiment);
                    }
                },
                role: "button",
                tabIndex: 0,
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $53o08.Checkbox), {
                    id: "enrollInExperiment",
                    name: "enrollInExperiment",
                    value: "enrollInExperiment",
                    label: "Enroll in Experiment Treatment?",
                    checked: values.enrollInExperiment
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                onClick: (e)=>{
                    const target = e.target;
                    if (target.type === "checkbox") handleSelectChange("useOverrides", target.checked);
                },
                onKeyDown: (e)=>{
                    if (e.key === "Enter" || e.key === " ") {
                        e.preventDefault();
                        handleSelectChange("useOverrides", !values.useOverrides);
                    }
                },
                role: "button",
                tabIndex: 0,
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $53o08.Checkbox), {
                    id: "useOverrides",
                    name: "useOverrides",
                    value: "useOverrides",
                    label: "Use Overrides?",
                    checked: values.useOverrides
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $2m1xf.DropdownSelector), {
                    name: (0, $bQiYD.UserSegmentTypes).LOGIN_STATUS,
                    id: (0, $bQiYD.UserSegmentTypes).LOGIN_STATUS,
                    label: "Login Status",
                    options: [
                        {
                            value: "loggedIn",
                            label: "Logged In"
                        },
                        {
                            value: "loggedOut",
                            label: "Logged Out"
                        }
                    ],
                    defaultValue: {
                        value: values[(0, $bQiYD.UserSegmentTypes).LOGIN_STATUS] || "",
                        label: values[(0, $bQiYD.UserSegmentTypes).LOGIN_STATUS] === "loggedIn" ? "Logged In" : "Logged Out"
                    },
                    onChangeHandler: (value)=>{
                        handleSelectChange((0, $bQiYD.UserSegmentTypes).LOGIN_STATUS, value);
                    }
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $9Yq3D.TextInput), {
                    id: "geolocation",
                    name: (0, $bQiYD.UserSegmentTypes).GEOLOCATION,
                    label: "Geolocation",
                    placeholder: "e.g. US, UK, AU",
                    value: values[(0, $bQiYD.UserSegmentTypes).GEOLOCATION],
                    onChangeHandler: (value)=>{
                        handleSelectChange((0, $bQiYD.UserSegmentTypes).GEOLOCATION, value);
                    }
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $2m1xf.DropdownSelector), {
                    name: (0, $bQiYD.UserSegmentTypes).JOB_FUNCTION,
                    id: (0, $bQiYD.UserSegmentTypes).JOB_FUNCTION,
                    label: "Job Function",
                    options: $1acdd970fef71b54$var$JOB_FUNCTION.map((entry)=>({
                            value: entry.value,
                            label: entry.label
                        })),
                    defaultValue: {
                        value: values[(0, $bQiYD.UserSegmentTypes).JOB_FUNCTION] || "",
                        label: ((_JOB_FUNCTION_find = $1acdd970fef71b54$var$JOB_FUNCTION.find((e)=>{
                            return e.value === values[(0, $bQiYD.UserSegmentTypes).JOB_FUNCTION];
                        })) === null || _JOB_FUNCTION_find === void 0 ? void 0 : _JOB_FUNCTION_find.label) || "test"
                    },
                    onChangeHandler: (value)=>{
                        handleSelectChange((0, $bQiYD.UserSegmentTypes).JOB_FUNCTION, value);
                    }
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $2m1xf.DropdownSelector), {
                    name: (0, $bQiYD.UserSegmentTypes).DOMAIN_TYPE,
                    id: (0, $bQiYD.UserSegmentTypes).DOMAIN_TYPE,
                    label: "Domain Type",
                    options: [
                        {
                            value: "BUSINESS",
                            label: "Business"
                        },
                        {
                            value: "PERSONAL",
                            label: "Personal"
                        }
                    ],
                    defaultValue: {
                        value: values[(0, $bQiYD.UserSegmentTypes).DOMAIN_TYPE] || "",
                        label: values[(0, $bQiYD.UserSegmentTypes).DOMAIN_TYPE] === "BUSINESS" ? "Business" : "Personal"
                    },
                    onChangeHandler: (value)=>{
                        handleSelectChange((0, $bQiYD.UserSegmentTypes).DOMAIN_TYPE, value);
                    }
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)("label", {
                        htmlFor: (0, $bQiYD.UserSegmentTypes).OWNED_PRODUCTS,
                        className: (0, $esG4f.default)([
                            "_1e0c1ule _syaz5k8o _1wyboqnp _vwz41gnr _6rth1b66 _y3gn1e5h"
                        ]),
                        style: {
                            "--_1ntr8rj": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.dark200"))
                        },
                        children: "Owned Products"
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                        className: (0, $esG4f.default)([
                            "_1e0c1txw _1n261g80 _zulp1b66 _1yt4u2gc _19it1nj5 _2rko1y44 _1tke1ylp _4cvr1h6o"
                        ]),
                        style: {
                            "--_19aes6n": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.dark700"))
                        },
                        children: [
                            {
                                value: "jira-software",
                                label: "Jira"
                            },
                            {
                                value: "confluence",
                                label: "Confluence"
                            },
                            {
                                value: "bitbucket",
                                label: "Bitbucket"
                            },
                            {
                                value: "compass",
                                label: "Compass"
                            },
                            {
                                value: "jira-product-discovery",
                                label: "Jira Product Discovery"
                            },
                            {
                                value: "statuspage",
                                label: "Statuspage"
                            },
                            {
                                value: "loom",
                                label: "Loom"
                            },
                            {
                                value: "compass",
                                label: "Compass"
                            },
                            {
                                value: "rovo.ondemand",
                                label: "Rovo"
                            },
                            {
                                value: "trello",
                                label: "Trello"
                            }
                        ].map((product)=>{
                            var _values_UserSegmentTypes_OWNED_PRODUCTS;
                            const isSelected = Array.isArray(values[(0, $bQiYD.UserSegmentTypes).OWNED_PRODUCTS]) ? (_values_UserSegmentTypes_OWNED_PRODUCTS = values[(0, $bQiYD.UserSegmentTypes).OWNED_PRODUCTS]) === null || _values_UserSegmentTypes_OWNED_PRODUCTS === void 0 ? void 0 : _values_UserSegmentTypes_OWNED_PRODUCTS.includes(product.value) : values[(0, $bQiYD.UserSegmentTypes).OWNED_PRODUCTS] === product.value;
                            return /*#__PURE__*/ (0, $loA2J.jsx)("button", {
                                type: "button",
                                onClick: ()=>{
                                    const currentProducts = Array.isArray(values[(0, $bQiYD.UserSegmentTypes).OWNED_PRODUCTS]) ? values[(0, $bQiYD.UserSegmentTypes).OWNED_PRODUCTS] || [] : values[(0, $bQiYD.UserSegmentTypes).OWNED_PRODUCTS] ? [
                                        values[(0, $bQiYD.UserSegmentTypes).OWNED_PRODUCTS]
                                    ] : [];
                                    let updatedProducts;
                                    if (isSelected) updatedProducts = currentProducts.filter((p)=>p !== product.value);
                                    else updatedProducts = [
                                        ...currentProducts,
                                        product.value
                                    ];
                                    handleSelectChange((0, $bQiYD.UserSegmentTypes).OWNED_PRODUCTS, updatedProducts);
                                },
                                className: (0, $esG4f.default)([
                                    "_1yt418iy _bfhkl9kt _syaz1o9l _19itglyw _2rko1y44 _80omtlke _1wyboxwj _irr31nu1"
                                ]),
                                style: {
                                    "--_3kul7g": (0, $43MIc.default)(isSelected ? (0, $5ohHq.wacToken)("color.extended.blue300") : (0, $5ohHq.wacToken)("color.neutral.light200")),
                                    "--_8buy8y": (0, $43MIc.default)(isSelected ? (0, $5ohHq.wacToken)("color.neutral.light0") : (0, $5ohHq.wacToken)("color.neutral.dark200")),
                                    "--_1pblbmt": (0, $43MIc.default)(isSelected ? (0, $5ohHq.wacToken)("color.extended.blue400") : (0, $5ohHq.wacToken)("color.neutral.light300"))
                                },
                                children: product.label
                            }, product.value);
                        })
                    })
                ]
            }),
            [
                {
                    segmentType: (0, $bQiYD.UserSegmentTypes).FIRST_RECOMMENDATION,
                    label: "First Recommendation",
                    defaultValue: "jira",
                    defaultLabel: "Jira"
                },
                {
                    segmentType: (0, $bQiYD.UserSegmentTypes).SECOND_RECOMMENDATION,
                    label: "Second Recommendation",
                    defaultValue: "confluence",
                    defaultLabel: "Confluence"
                },
                {
                    segmentType: (0, $bQiYD.UserSegmentTypes).THIRD_RECOMMENDATION,
                    label: "Third Recommendation",
                    defaultValue: "jsm",
                    defaultLabel: "JSM"
                },
                {
                    segmentType: (0, $bQiYD.UserSegmentTypes).FOURTH_RECOMMENDATION,
                    label: "Fourth Recommendation",
                    defaultValue: "loom",
                    defaultLabel: "Loom"
                }
            ].map(({ segmentType: segmentType, label: label, defaultValue: defaultValue, defaultLabel: defaultLabel })=>{
                const selectedValue = values[segmentType] || defaultValue;
                const selectedOption = $1acdd970fef71b54$var$PRODUCT_OPTIONS.find((opt)=>opt.value === selectedValue);
                return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $2m1xf.DropdownSelector), {
                        name: segmentType,
                        id: segmentType,
                        label: label,
                        options: $1acdd970fef71b54$var$PRODUCT_OPTIONS,
                        defaultValue: {
                            value: selectedValue,
                            label: (selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.label) || defaultLabel
                        },
                        onChangeHandler: (value)=>{
                            handleSelectChange(segmentType, value);
                        }
                    })
                }, segmentType);
            })
        ]
    });
};
const $1acdd970fef71b54$export$3509149ef9c5f46 = ({ values: values, setValues: setValues, renderMessage: renderMessage, isContainerHovered: isContainerHovered })=>{
    const [isVisible, setIsVisible] = (0, $iSvIT.useState)(false);
    const handleSelectChange = (field, value)=>{
        setValues((0, $6iHNw._)((0, $7Knp0._)({}, values), {
            [field]: value
        }));
    }; // Only show the dog-ear when container is hovered
    if (!isContainerHovered) return null;
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        onMouseEnter: ()=>setIsVisible(true),
        onMouseLeave: ()=>setIsVisible(false),
        onFocus: ()=>setIsVisible(true),
        onBlur: ()=>setIsVisible(false),
        role: "button",
        tabIndex: 0,
        className: (0, $esG4f.default)([
            "_kqswstnw _152t12gs _1e0212gs _1bsb1lmt _4t3i1n85 _1pbyzo7u"
        ]),
        style: {
            "--_6q42yv": (0, $43MIc.default)(isVisible ? "320px" : "auto"),
            "--_1j9tq0n": (0, $43MIc.default)(isVisible ? "400px" : "auto")
        },
        children: [
            /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                title: "Personalization Controls",
                className: (0, $esG4f.default)([
                    "_kqswstnw _152tidpf _1e02idpf _1pby3ced _1bsbckbl _4t3ickbl _80omtlke _v5641hdd _tzy413ze _t9ec13e0"
                ]),
                style: {
                    "--_ymxjy5": (0, $43MIc.default)(isContainerHovered ? 1 : 0),
                    "--_51sge": (0, $43MIc.default)(isContainerHovered ? "scale(1)" : "scale(0.8)")
                },
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                        className: (0, $esG4f.default)([
                            "_kqswstnw _152tidpf _1e02idpf _1bsbckbl _4t3ickbl _bfhk1mxb _2rko1dia _v5641hdd _16qs1s6v _irr3cqtm"
                        ]),
                        style: {
                            "--_9qtbdu": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.extended.blue300")),
                            "--_19sjjnh": (0, $43MIc.default)((0, $5ohHq.wacToken)("corner.radius.card")),
                            "--_1mbq9ci": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.dark800")),
                            "--_r4erkq": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.extended.blue400"))
                        }
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                        className: (0, $esG4f.default)([
                            "_kqswstnw _152t1ssb _1e021ssb _t9ec1ooe _syazcd5j _1wyb7vkz _vwz4kb7n _lcxvglyw _w19j12yu"
                        ]),
                        style: {
                            "--_7zbnls": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light0")),
                            "--_1mbq9ci": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.dark800"))
                        },
                        children: "\uD83D\uDC65"
                    })
                ]
            }),
            isVisible && /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                className: (0, $esG4f.default)([
                    "_kqswstnw _152t1ex1 _1e02ftgi _1bsb1178 _1pby1rya _1yt4pxbi _bfhkcd5j _2rkovwyg _16qsswb1 _19it1nj5"
                ]),
                style: {
                    "--_7zbnls": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light0")),
                    "--_19sjjnh": (0, $43MIc.default)((0, $5ohHq.wacToken)("corner.radius.card")),
                    "--_1mbq9ci": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.dark800")),
                    "--_19aes6n": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.dark700"))
                },
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)("h3", {
                        className: (0, $esG4f.default)([
                            "_18s819a1 _1wybbzd7 _syaz5k8o"
                        ]),
                        style: {
                            "--_1ikmwd8": (0, $43MIc.default)((0, $5ohHq.wacToken)("font.charlie.text")),
                            "--_1ntr8rj": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.dark200"))
                        },
                        children: "Personalization Controls"
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                        className: (0, $esG4f.default)([
                            "_18s8h2s3 _1yt412x7 _1wyboqnp _syazgc2p _bfhkjzbh _2rko1y44 _19itacih"
                        ]),
                        style: {
                            "--_1jncskl": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.dark300")),
                            "--_1bsbd8h": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.extended.yellow100")),
                            "--_1oxqp4m": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.extended.yellow300"))
                        },
                        children: "These controls and the blue border are only visible in pre-production environments"
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)($1acdd970fef71b54$var$PersonalizationControlPanel, {
                        values: values,
                        handleSelectChange: handleSelectChange
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                        className: (0, $esG4f.default)([
                            "_1pfhutpp _1yt4u2gc _bfhk1ybm _syazgc2p"
                        ]),
                        style: {
                            "--_1hkddbi": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.extended.blue100")),
                            "--_1jncskl": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.dark300"))
                        },
                        children: renderMessage
                    })
                ]
            })
        ]
    });
};

});
parcelRegister("fYEXy", function(module, exports) {
$parcel$export(module.exports, "Checkbox", function () { return (parcelRequire("53o08")).Checkbox; });

var $53o08 = parcelRequire("53o08");

});
parcelRegister("53o08", function(module, exports) {

$parcel$export(module.exports, "Checkbox", function () { return $72b2951a2c888331$export$48513f6b9f8ce62d; });
/* checkbox.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
const $72b2951a2c888331$var$textStyle = null;
const $72b2951a2c888331$var$containerStyle = null;
const $72b2951a2c888331$var$checkboxStyle = null;
const $72b2951a2c888331$export$48513f6b9f8ce62d = (props)=>{
    const { id: id, name: name, value: value, label: label, color: color = "light", accentColor: accentColor = "#0065ff", disabled: disabled, testId: testId, checked: checked, indeterminate: indeterminate, className: className } = props;
    const ref = (0, $iSvIT.useRef)(null);
    (0, $iSvIT.useEffect)(()=>{
        if (ref.current) {
            if (indeterminate) ref.current.indeterminate = indeterminate;
            else ref.current.checked = checked || false;
        }
    }, [
        props
    ]);
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        className: (0, $esG4f.default)([
            "_kqswh2mm _1e0c1txw _4cvr1y6m _ca0qyh40 _u5f3idpf _n3tdyh40 _19bvidpf _vwz4bs82",
            className
        ]),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("input", {
                id: id,
                type: "checkbox",
                "data-testid": testId ? testId : id,
                style: {
                    accentColor: accentColor
                },
                ref: ref,
                name: name,
                value: value,
                disabled: disabled || false,
                className: (0, $esG4f.default)([
                    "_s7n4nkob _1bsb7vkz _4t3i7vkz _19pk1y44 _2hwxidpf _otyridpf _18u0idpf _1372tlke _d0altlke _jomr3739 _irr33739"
                ])
            }),
            label && /*#__PURE__*/ (0, $loA2J.jsx)("label", {
                style: {
                    color: color == "dark" ? "#172b4d" : "#5e6c84"
                },
                htmlFor: id,
                className: (0, $esG4f.default)([
                    "_80omtlke _1wyboxwj _k48p1nn1 _ahbqftgi"
                ]),
                children: label
            })
        ]
    });
};

});


parcelRegister("9REvE", function(module, exports) {
$parcel$export(module.exports, "DropdownSelector", function () { return (parcelRequire("2m1xf")).DropdownSelector; });

var $2m1xf = parcelRequire("2m1xf");

});
parcelRegister("2m1xf", function(module, exports) {

$parcel$export(module.exports, "DropdownSelector", function () { return $ca8de50e57748f6a$export$67ffdcf8cfce0fd; });
/* dropdown-selector.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $1K6UN = parcelRequire("1K6UN");
const $ca8de50e57748f6a$var$dropdownSelectorContainerStyle = null;
const $ca8de50e57748f6a$var$labelStyle = null;
const $ca8de50e57748f6a$var$labelStyleSignup = null;
const $ca8de50e57748f6a$export$67ffdcf8cfce0fd = ({ options: options, name: name, id: id, testId: testId, label: label, onChangeHandler: onChangeHandler, defaultValue: defaultValue, cssOverrides: cssOverrides, className: className })=>{
    const [isMenuOpen, setIsMenuOpen] = (0, $iSvIT.useState)(false);
    const elementID = id ? id : `${name}-dropdown`;
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        className: (0, $esG4f.default)([
            "_1e0c116y _2lx21bp4 _1bsb1osq",
            className
        ]),
        children: [
            (cssOverrides === null || cssOverrides === void 0 ? void 0 : cssOverrides.labelStyle) === "signup" && /*#__PURE__*/ (0, $loA2J.jsx)("label", {
                htmlFor: elementID,
                className: (0, $esG4f.default)([
                    "_syazvwuj _vwz41gnr _6rth1b66 _y3gn1e5h _k48pbfng _1wybdlk8"
                ]),
                children: label
            }),
            !(cssOverrides === null || cssOverrides === void 0 ? void 0 : cssOverrides.labelStyle) && /*#__PURE__*/ (0, $loA2J.jsx)("label", {
                htmlFor: elementID,
                className: (0, $esG4f.default)([
                    "_syazvwuj _1wyboqnp _vwz41gnr _6rth1b66 _y3gn1e5h"
                ]),
                children: label
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: "select-dropdown-container",
                "data-testid": testId ? testId : elementID,
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $1K6UN.default), {
                    defaultValue: defaultValue || {
                        label: "Select...",
                        value: ""
                    },
                    options: options,
                    unstyled: true,
                    inputId: elementID,
                    onChange: (selectedOption)=>{
                        onChangeHandler === null || onChangeHandler === void 0 ? void 0 : onChangeHandler((selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.value) || "");
                    },
                    onMenuOpen: ()=>setIsMenuOpen(true),
                    onMenuClose: ()=>setIsMenuOpen(false),
                    styles: {
                        // @ts-ignore
                        container: (provided)=>(0, $7Knp0._)((0, $6iHNw._)((0, $7Knp0._)({}, provided), {
                                appearance: "none",
                                flexDirection: "row",
                                fontSize: "1rem",
                                lineHeight: "1.2",
                                textAlign: "left"
                            }), (cssOverrides || {}).container),
                        // @ts-ignore
                        singleValue: (provided)=>(0, $7Knp0._)((0, $6iHNw._)((0, $7Knp0._)({}, provided), {
                                marginLeft: "var(--ds-space-025, 2px)",
                                marginRight: "var(--ds-space-025, 2px)"
                            }), (cssOverrides || {}).singleValue),
                        // @ts-ignore
                        placeholder: (provided)=>(0, $7Knp0._)((0, $6iHNw._)((0, $7Knp0._)({}, provided), {
                                marginLeft: "var(--ds-space-025, 2px)",
                                marginRight: "var(--ds-space-025, 2px)"
                            }), (cssOverrides || {}).placeholder),
                        // @ts-ignore
                        valueContainer: (provided)=>(0, $7Knp0._)((0, $6iHNw._)((0, $7Knp0._)({}, provided), {
                                paddingLeft: "var(--ds-space-075, 6px)",
                                paddingRight: "var(--ds-space-075, 6px)"
                            }), (cssOverrides || {}).valueContainer),
                        // @ts-ignore
                        menu: (provided)=>(0, $7Knp0._)((0, $6iHNw._)((0, $7Knp0._)({}, provided), {
                                marginTop: "var(--ds-space-050, 4px)",
                                // eslint-disable-next-line local/ensure-wac-token-usage
                                boxShadow: "0px 3px 5px 0px #091E4233",
                                // eslint-disable-next-line local/ensure-wac-token-usage
                                background: "#ffffff",
                                padding: 0,
                                borderRadius: "var(--ds-space-050, 4px)"
                            }), (cssOverrides || {}).menu),
                        // @ts-ignore
                        control: (provided, state)=>(0, $7Knp0._)((0, $6iHNw._)((0, $7Knp0._)({}, provided), {
                                "cursor": "pointer",
                                "backgroundColor": isMenuOpen ? "#253858" : "#FAFBFC",
                                "color": isMenuOpen ? "#ffffff" : "#172B4D",
                                "height": "2.65rem",
                                "border": state.isFocused ? `2px solid #4C9AFF` : `2px solid #dfe1e6`,
                                "borderRadius": "var(--ds-space-050, 4px)",
                                "&:hover": {
                                    background: isMenuOpen ? undefined : "#F4F5F7"
                                }
                            }), (cssOverrides || {}).control),
                        // @ts-ignore
                        dropdownIndicator: (provided, state)=>(0, $7Knp0._)((0, $6iHNw._)((0, $7Knp0._)({}, provided), {
                                transition: "all .2s ease",
                                transform: state.selectProps.menuIsOpen ? "rotate(180deg)" : undefined
                            }), (cssOverrides || {}).dropdownIndicator),
                        // @ts-ignore
                        indicatorsContainer: (provided)=>(0, $7Knp0._)((0, $6iHNw._)((0, $7Knp0._)({}, provided), {
                                paddingTop: "var(--ds-space-075, 6px)",
                                paddingBottom: "var(--ds-space-075, 6px)",
                                paddingLeft: "var(--ds-space-025, 2px)",
                                paddingRight: "var(--ds-space-075, 6px)"
                            }), (cssOverrides || {}).indicatorsContainer),
                        // @ts-ignore
                        option: (provided, state)=>(0, $7Knp0._)((0, $6iHNw._)((0, $7Knp0._)({}, provided), {
                                "cursor": "pointer",
                                "padding": `${"var(--ds-space-100, 8px)"} ${"var(--ds-space-200, 16px)"}`,
                                "whiteSpace": "pre-wrap",
                                "overflowWrap": "break-word",
                                "backgroundColor": state.isSelected ? "#B2D4FF" : state.isFocused ? "#EBECF0" : "#FAFBFC",
                                "color": state.isSelected ? "#0065FF" : "#172B4D",
                                "&:hover": {
                                    background: state.isSelected ? "#B2D4FF" : "#EBECF0"
                                },
                                "&:active": {
                                    // eslint-disable-next-line local/ensure-wac-token-usage
                                    background: "#DFE1E5"
                                }
                            }), (cssOverrides || {}).option),
                        // @ts-ignore
                        input: (provided)=>(0, $7Knp0._)((0, $6iHNw._)((0, $7Knp0._)({}, provided), {
                                color: "transparent"
                            }), (cssOverrides || {}).input)
                    }
                })
            })
        ]
    });
};

});
parcelRegister("1K6UN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $144f737f35443e1b$export$2e2bcd8739ae039; });

var $lVIRl = parcelRequire("lVIRl");

var $fBUaU = parcelRequire("fBUaU");

var $iSvIT = parcelRequire("iSvIT");

var $Xt8rg = parcelRequire("Xt8rg");

var $eaGHY = parcelRequire("eaGHY");

var $gnUvj = parcelRequire("gnUvj");

var $4hU6i = parcelRequire("4hU6i");
parcelRequire("k5N0O");
parcelRequire("9yUBC");
parcelRequire("h57BE");
parcelRequire("aReVA");
parcelRequire("ly09p");
parcelRequire("5guBO");
parcelRequire("8BpI7");
parcelRequire("aGqhc");

parcelRequire("hFz8f");
parcelRequire("5kd3B");
parcelRequire("1K5Eh");
parcelRequire("i5UxU");

parcelRequire("3fOxZ");
var $144f737f35443e1b$var$StateManagedSelect = /*#__PURE__*/ (0, $iSvIT.forwardRef)(function(props, ref) {
    var baseSelectProps = (0, $lVIRl.u)(props);
    return /*#__PURE__*/ $iSvIT.createElement((0, $Xt8rg.S), (0, $fBUaU.default)({
        ref: ref
    }, baseSelectProps));
});
var $144f737f35443e1b$export$2e2bcd8739ae039 = $144f737f35443e1b$var$StateManagedSelect;
var $144f737f35443e1b$export$a7deb1594c5ce10e = function(_ref) {
    var nonce = _ref.nonce, children = _ref.children, cacheKey = _ref.cacheKey;
    var emotionCache = (0, $iSvIT.useMemo)(function() {
        return (0, $gnUvj.default)({
            key: cacheKey,
            nonce: nonce
        });
    }, [
        cacheKey,
        nonce
    ]);
    return /*#__PURE__*/ $iSvIT.createElement((0, $eaGHY.C), {
        value: emotionCache
    }, children);
};

});
parcelRegister("lVIRl", function(module, exports) {

$parcel$export(module.exports, "u", function () { return $ff71b7ff8294e068$export$3b14a55fb2447963; });

var $k5N0O = parcelRequire("k5N0O");

var $9yUBC = parcelRequire("9yUBC");

var $h57BE = parcelRequire("h57BE");

var $iSvIT = parcelRequire("iSvIT");
var $ff71b7ff8294e068$var$_excluded = [
    "defaultInputValue",
    "defaultMenuIsOpen",
    "defaultValue",
    "inputValue",
    "menuIsOpen",
    "onChange",
    "onInputChange",
    "onMenuClose",
    "onMenuOpen",
    "value"
];
function $ff71b7ff8294e068$export$3b14a55fb2447963(_ref) {
    var _ref$defaultInputValu = _ref.defaultInputValue, defaultInputValue = _ref$defaultInputValu === void 0 ? "" : _ref$defaultInputValu, _ref$defaultMenuIsOpe = _ref.defaultMenuIsOpen, defaultMenuIsOpen = _ref$defaultMenuIsOpe === void 0 ? false : _ref$defaultMenuIsOpe, _ref$defaultValue = _ref.defaultValue, defaultValue = _ref$defaultValue === void 0 ? null : _ref$defaultValue, propsInputValue = _ref.inputValue, propsMenuIsOpen = _ref.menuIsOpen, propsOnChange = _ref.onChange, propsOnInputChange = _ref.onInputChange, propsOnMenuClose = _ref.onMenuClose, propsOnMenuOpen = _ref.onMenuOpen, propsValue = _ref.value, restSelectProps = (0, $h57BE.default)(_ref, $ff71b7ff8294e068$var$_excluded);
    var _useState = (0, $iSvIT.useState)(propsInputValue !== undefined ? propsInputValue : defaultInputValue), _useState2 = (0, $9yUBC.default)(_useState, 2), stateInputValue = _useState2[0], setStateInputValue = _useState2[1];
    var _useState3 = (0, $iSvIT.useState)(propsMenuIsOpen !== undefined ? propsMenuIsOpen : defaultMenuIsOpen), _useState4 = (0, $9yUBC.default)(_useState3, 2), stateMenuIsOpen = _useState4[0], setStateMenuIsOpen = _useState4[1];
    var _useState5 = (0, $iSvIT.useState)(propsValue !== undefined ? propsValue : defaultValue), _useState6 = (0, $9yUBC.default)(_useState5, 2), stateValue = _useState6[0], setStateValue = _useState6[1];
    var onChange = (0, $iSvIT.useCallback)(function(value, actionMeta) {
        if (typeof propsOnChange === "function") propsOnChange(value, actionMeta);
        setStateValue(value);
    }, [
        propsOnChange
    ]);
    var onInputChange = (0, $iSvIT.useCallback)(function(value, actionMeta) {
        var newValue;
        if (typeof propsOnInputChange === "function") newValue = propsOnInputChange(value, actionMeta);
        setStateInputValue(newValue !== undefined ? newValue : value);
    }, [
        propsOnInputChange
    ]);
    var onMenuOpen = (0, $iSvIT.useCallback)(function() {
        if (typeof propsOnMenuOpen === "function") propsOnMenuOpen();
        setStateMenuIsOpen(true);
    }, [
        propsOnMenuOpen
    ]);
    var onMenuClose = (0, $iSvIT.useCallback)(function() {
        if (typeof propsOnMenuClose === "function") propsOnMenuClose();
        setStateMenuIsOpen(false);
    }, [
        propsOnMenuClose
    ]);
    var inputValue = propsInputValue !== undefined ? propsInputValue : stateInputValue;
    var menuIsOpen = propsMenuIsOpen !== undefined ? propsMenuIsOpen : stateMenuIsOpen;
    var value = propsValue !== undefined ? propsValue : stateValue;
    return (0, $k5N0O.default)((0, $k5N0O.default)({}, restSelectProps), {}, {
        inputValue: inputValue,
        menuIsOpen: menuIsOpen,
        onChange: onChange,
        onInputChange: onInputChange,
        onMenuClose: onMenuClose,
        onMenuOpen: onMenuOpen,
        value: value
    });
}

});
parcelRegister("k5N0O", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ea0a4b0ecd424301$export$2e2bcd8739ae039; });

var $1K5Eh = parcelRequire("1K5Eh");
function $ea0a4b0ecd424301$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $ea0a4b0ecd424301$export$2e2bcd8739ae039(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $ea0a4b0ecd424301$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $1K5Eh.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $ea0a4b0ecd424301$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}

});
parcelRegister("1K5Eh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $144e78021ed09269$export$2e2bcd8739ae039; });

var $ienzO = parcelRequire("ienzO");
function $144e78021ed09269$export$2e2bcd8739ae039(e, r, t) {
    return (r = (0, $ienzO.default)(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}

});
parcelRegister("ienzO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d45bd29c3cab7e22$export$2e2bcd8739ae039; });

var $hFz8f = parcelRequire("hFz8f");

var $hN9gc = parcelRequire("hN9gc");
function $d45bd29c3cab7e22$export$2e2bcd8739ae039(t) {
    var i = (0, $hN9gc.default)(t, "string");
    return "symbol" == (0, $hFz8f.default)(i) ? i : i + "";
}

});
parcelRegister("hFz8f", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cdd184807c7256a2$export$2e2bcd8739ae039; });
function $cdd184807c7256a2$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $cdd184807c7256a2$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $cdd184807c7256a2$export$2e2bcd8739ae039(o);
}

});

parcelRegister("hN9gc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cf3e32264207fb02$export$2e2bcd8739ae039; });

var $hFz8f = parcelRequire("hFz8f");
function $cf3e32264207fb02$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $hFz8f.default)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $hFz8f.default)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}

});




parcelRegister("9yUBC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6f6332c376dd6780$export$2e2bcd8739ae039; });

var $8mMqI = parcelRequire("8mMqI");

var $cph43 = parcelRequire("cph43");

var $iHw5C = parcelRequire("iHw5C");

var $K3kP2 = parcelRequire("K3kP2");
function $6f6332c376dd6780$export$2e2bcd8739ae039(r, e) {
    return (0, $8mMqI.default)(r) || (0, $cph43.default)(r, e) || (0, $iHw5C.default)(r, e) || (0, $K3kP2.default)();
}

});
parcelRegister("8mMqI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6175f1fa848fa622$export$2e2bcd8739ae039; });
function $6175f1fa848fa622$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return r;
}

});

parcelRegister("cph43", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0254ba0a48c97bf5$export$2e2bcd8739ae039; });
function $0254ba0a48c97bf5$export$2e2bcd8739ae039(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}

});

parcelRegister("iHw5C", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d9d52280c9139c51$export$2e2bcd8739ae039; });

var $6HmTm = parcelRequire("6HmTm");
function $d9d52280c9139c51$export$2e2bcd8739ae039(r, a) {
    if (r) {
        if ("string" == typeof r) return (0, $6HmTm.default)(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? (0, $6HmTm.default)(r, a) : void 0;
    }
}

});
parcelRegister("6HmTm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4e088415cc1df056$export$2e2bcd8739ae039; });
function $4e088415cc1df056$export$2e2bcd8739ae039(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}

});


parcelRegister("K3kP2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $08a6e239054ef01d$export$2e2bcd8739ae039; });
function $08a6e239054ef01d$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("h57BE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c6f8cdc328676ca9$export$2e2bcd8739ae039; });

var $44FMd = parcelRequire("44FMd");
function $c6f8cdc328676ca9$export$2e2bcd8739ae039(e, t) {
    if (null == e) return {};
    var o, r, i = (0, $44FMd.default)(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}

});
parcelRegister("44FMd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2f77f1228a691b81$export$2e2bcd8739ae039; });
function $2f77f1228a691b81$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}

});



parcelRegister("fBUaU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b5d5e2e3743d6f8c$export$2e2bcd8739ae039; });
function $b5d5e2e3743d6f8c$export$2e2bcd8739ae039() {
    return $b5d5e2e3743d6f8c$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $b5d5e2e3743d6f8c$export$2e2bcd8739ae039.apply(null, arguments);
}

});

parcelRegister("Xt8rg", function(module, exports) {

$parcel$export(module.exports, "S", function () { return $0b2c1c6d9ef1aad4$export$25ce5a424b770e84; });

var $fBUaU = parcelRequire("fBUaU");

var $k5N0O = parcelRequire("k5N0O");

var $aReVA = parcelRequire("aReVA");

var $ly09p = parcelRequire("ly09p");

var $5guBO = parcelRequire("5guBO");

var $8BpI7 = parcelRequire("8BpI7");

var $aGqhc = parcelRequire("aGqhc");

var $iSvIT = parcelRequire("iSvIT");

var $4hU6i = parcelRequire("4hU6i");

var $2ZUkg = parcelRequire("2ZUkg");

var $fV0Sg = parcelRequire("fV0Sg");

var $h57BE = parcelRequire("h57BE");
function $0b2c1c6d9ef1aad4$var$_EMOTION_STRINGIFIED_CSS_ERROR__$2() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// Assistive text to describe visual elements. Hidden for sighted users.
var $0b2c1c6d9ef1aad4$var$_ref = {
    name: "7pg0cj-a11yText",
    styles: "label:a11yText;z-index:9999;border:0;clip:rect(1px, 1px, 1px, 1px);height:1px;width:1px;position:absolute;overflow:hidden;padding:0;white-space:nowrap"
};
var $0b2c1c6d9ef1aad4$var$A11yText = function A11yText(props) {
    return (0, $2ZUkg.jsx)("span", (0, $fBUaU.default)({
        css: $0b2c1c6d9ef1aad4$var$_ref
    }, props));
};
var $0b2c1c6d9ef1aad4$var$A11yText$1 = $0b2c1c6d9ef1aad4$var$A11yText;
var $0b2c1c6d9ef1aad4$var$defaultAriaLiveMessages = {
    guidance: function guidance(props) {
        var isSearchable = props.isSearchable, isMulti = props.isMulti, isDisabled = props.isDisabled, tabSelectsValue = props.tabSelectsValue, context = props.context;
        switch(context){
            case "menu":
                return "Use Up and Down to choose options".concat(isDisabled ? "" : ", press Enter to select the currently focused option", ", press Escape to exit the menu").concat(tabSelectsValue ? ", press Tab to select the option and exit the menu" : "", ".");
            case "input":
                return "".concat(props["aria-label"] || "Select", " is focused ").concat(isSearchable ? ",type to refine list" : "", ", press Down to open the menu, ").concat(isMulti ? " press left to focus selected values" : "");
            case "value":
                return "Use left and right to toggle between focused values, press Backspace to remove the currently focused value";
            default:
                return "";
        }
    },
    onChange: function onChange(props) {
        var action = props.action, _props$label = props.label, label = _props$label === void 0 ? "" : _props$label, labels = props.labels, isDisabled = props.isDisabled;
        switch(action){
            case "deselect-option":
            case "pop-value":
            case "remove-value":
                return "option ".concat(label, ", deselected.");
            case "clear":
                return "All selected options have been cleared.";
            case "initial-input-focus":
                return "option".concat(labels.length > 1 ? "s" : "", " ").concat(labels.join(","), ", selected.");
            case "select-option":
                return isDisabled ? "option ".concat(label, " is disabled. Select another option.") : "option ".concat(label, ", selected.");
            default:
                return "";
        }
    },
    onFocus: function onFocus(props) {
        var context = props.context, focused = props.focused, options = props.options, _props$label2 = props.label, label = _props$label2 === void 0 ? "" : _props$label2, selectValue = props.selectValue, isDisabled = props.isDisabled, isSelected = props.isSelected;
        var getArrayIndex = function getArrayIndex(arr, item) {
            return arr && arr.length ? "".concat(arr.indexOf(item) + 1, " of ").concat(arr.length) : "";
        };
        if (context === "value" && selectValue) return "value ".concat(label, " focused, ").concat(getArrayIndex(selectValue, focused), ".");
        if (context === "menu") {
            var disabled = isDisabled ? " disabled" : "";
            var status = "".concat(isSelected ? "selected" : "focused").concat(disabled);
            return "option ".concat(label, " ").concat(status, ", ").concat(getArrayIndex(options, focused), ".");
        }
        return "";
    },
    onFilter: function onFilter(props) {
        var inputValue = props.inputValue, resultsMessage = props.resultsMessage;
        return "".concat(resultsMessage).concat(inputValue ? " for search term " + inputValue : "", ".");
    }
};
var $0b2c1c6d9ef1aad4$var$LiveRegion = function LiveRegion(props) {
    var ariaSelection = props.ariaSelection, focusedOption = props.focusedOption, focusedValue = props.focusedValue, focusableOptions = props.focusableOptions, isFocused = props.isFocused, selectValue = props.selectValue, selectProps = props.selectProps, id = props.id;
    var ariaLiveMessages = selectProps.ariaLiveMessages, getOptionLabel = selectProps.getOptionLabel, inputValue = selectProps.inputValue, isMulti = selectProps.isMulti, isOptionDisabled = selectProps.isOptionDisabled, isSearchable = selectProps.isSearchable, menuIsOpen = selectProps.menuIsOpen, options = selectProps.options, screenReaderStatus = selectProps.screenReaderStatus, tabSelectsValue = selectProps.tabSelectsValue;
    var ariaLabel = selectProps["aria-label"];
    var ariaLive = selectProps["aria-live"];
    // Update aria live message configuration when prop changes
    var messages = (0, $iSvIT.useMemo)(function() {
        return (0, $k5N0O.default)((0, $k5N0O.default)({}, $0b2c1c6d9ef1aad4$var$defaultAriaLiveMessages), ariaLiveMessages || {});
    }, [
        ariaLiveMessages
    ]);
    // Update aria live selected option when prop changes
    var ariaSelected = (0, $iSvIT.useMemo)(function() {
        var message = "";
        if (ariaSelection && messages.onChange) {
            var option = ariaSelection.option, selectedOptions = ariaSelection.options, removedValue = ariaSelection.removedValue, removedValues = ariaSelection.removedValues, value = ariaSelection.value;
            // select-option when !isMulti does not return option so we assume selected option is value
            var asOption = function asOption(val) {
                return !Array.isArray(val) ? val : null;
            };
            // If there is just one item from the action then get its label
            var selected = removedValue || option || asOption(value);
            var label = selected ? getOptionLabel(selected) : "";
            // If there are multiple items from the action then return an array of labels
            var multiSelected = selectedOptions || removedValues || undefined;
            var labels = multiSelected ? multiSelected.map(getOptionLabel) : [];
            var onChangeProps = (0, $k5N0O.default)({
                // multiSelected items are usually items that have already been selected
                // or set by the user as a default value so we assume they are not disabled
                isDisabled: selected && isOptionDisabled(selected, selectValue),
                label: label,
                labels: labels
            }, ariaSelection);
            message = messages.onChange(onChangeProps);
        }
        return message;
    }, [
        ariaSelection,
        messages,
        isOptionDisabled,
        selectValue,
        getOptionLabel
    ]);
    var ariaFocused = (0, $iSvIT.useMemo)(function() {
        var focusMsg = "";
        var focused = focusedOption || focusedValue;
        var isSelected = !!(focusedOption && selectValue && selectValue.includes(focusedOption));
        if (focused && messages.onFocus) {
            var onFocusProps = {
                focused: focused,
                label: getOptionLabel(focused),
                isDisabled: isOptionDisabled(focused, selectValue),
                isSelected: isSelected,
                options: focusableOptions,
                context: focused === focusedOption ? "menu" : "value",
                selectValue: selectValue
            };
            focusMsg = messages.onFocus(onFocusProps);
        }
        return focusMsg;
    }, [
        focusedOption,
        focusedValue,
        getOptionLabel,
        isOptionDisabled,
        messages,
        focusableOptions,
        selectValue
    ]);
    var ariaResults = (0, $iSvIT.useMemo)(function() {
        var resultsMsg = "";
        if (menuIsOpen && options.length && messages.onFilter) {
            var resultsMessage = screenReaderStatus({
                count: focusableOptions.length
            });
            resultsMsg = messages.onFilter({
                inputValue: inputValue,
                resultsMessage: resultsMessage
            });
        }
        return resultsMsg;
    }, [
        focusableOptions,
        inputValue,
        menuIsOpen,
        messages,
        options,
        screenReaderStatus
    ]);
    var ariaGuidance = (0, $iSvIT.useMemo)(function() {
        var guidanceMsg = "";
        if (messages.guidance) {
            var context = focusedValue ? "value" : menuIsOpen ? "menu" : "input";
            guidanceMsg = messages.guidance({
                "aria-label": ariaLabel,
                context: context,
                isDisabled: focusedOption && isOptionDisabled(focusedOption, selectValue),
                isMulti: isMulti,
                isSearchable: isSearchable,
                tabSelectsValue: tabSelectsValue
            });
        }
        return guidanceMsg;
    }, [
        ariaLabel,
        focusedOption,
        focusedValue,
        isMulti,
        isOptionDisabled,
        isSearchable,
        menuIsOpen,
        messages,
        selectValue,
        tabSelectsValue
    ]);
    var ariaContext = "".concat(ariaFocused, " ").concat(ariaResults, " ").concat(ariaGuidance);
    var ScreenReaderText = (0, $2ZUkg.jsx)((0, $iSvIT.Fragment), null, (0, $2ZUkg.jsx)("span", {
        id: "aria-selection"
    }, ariaSelected), (0, $2ZUkg.jsx)("span", {
        id: "aria-context"
    }, ariaContext));
    var isInitialFocus = (ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === "initial-input-focus";
    return (0, $2ZUkg.jsx)((0, $iSvIT.Fragment), null, (0, $2ZUkg.jsx)($0b2c1c6d9ef1aad4$var$A11yText$1, {
        id: id
    }, isInitialFocus && ScreenReaderText), (0, $2ZUkg.jsx)($0b2c1c6d9ef1aad4$var$A11yText$1, {
        "aria-live": ariaLive,
        "aria-atomic": "false",
        "aria-relevant": "additions text"
    }, isFocused && !isInitialFocus && ScreenReaderText));
};
var $0b2c1c6d9ef1aad4$var$LiveRegion$1 = $0b2c1c6d9ef1aad4$var$LiveRegion;
var $0b2c1c6d9ef1aad4$var$diacritics = [
    {
        base: "A",
        letters: "A\u24B6\uFF21\xc0\xc1\xc2\u1EA6\u1EA4\u1EAA\u1EA8\xc3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\xc4\u01DE\u1EA2\xc5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F"
    },
    {
        base: "AA",
        letters: "\uA732"
    },
    {
        base: "AE",
        letters: "\xc6\u01FC\u01E2"
    },
    {
        base: "AO",
        letters: "\uA734"
    },
    {
        base: "AU",
        letters: "\uA736"
    },
    {
        base: "AV",
        letters: "\uA738\uA73A"
    },
    {
        base: "AY",
        letters: "\uA73C"
    },
    {
        base: "B",
        letters: "B\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181"
    },
    {
        base: "C",
        letters: "C\u24B8\uFF23\u0106\u0108\u010A\u010C\xc7\u1E08\u0187\u023B\uA73E"
    },
    {
        base: "D",
        letters: "D\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779"
    },
    {
        base: "DZ",
        letters: "\u01F1\u01C4"
    },
    {
        base: "Dz",
        letters: "\u01F2\u01C5"
    },
    {
        base: "E",
        letters: "E\u24BA\uFF25\xc8\xc9\xca\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\xcb\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E"
    },
    {
        base: "F",
        letters: "F\u24BB\uFF26\u1E1E\u0191\uA77B"
    },
    {
        base: "G",
        letters: "G\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E"
    },
    {
        base: "H",
        letters: "H\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D"
    },
    {
        base: "I",
        letters: "I\u24BE\uFF29\xcc\xcd\xce\u0128\u012A\u012C\u0130\xcf\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197"
    },
    {
        base: "J",
        letters: "J\u24BF\uFF2A\u0134\u0248"
    },
    {
        base: "K",
        letters: "K\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2"
    },
    {
        base: "L",
        letters: "L\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780"
    },
    {
        base: "LJ",
        letters: "\u01C7"
    },
    {
        base: "Lj",
        letters: "\u01C8"
    },
    {
        base: "M",
        letters: "M\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C"
    },
    {
        base: "N",
        letters: "N\u24C3\uFF2E\u01F8\u0143\xd1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4"
    },
    {
        base: "NJ",
        letters: "\u01CA"
    },
    {
        base: "Nj",
        letters: "\u01CB"
    },
    {
        base: "O",
        letters: "O\u24C4\uFF2F\xd2\xd3\xd4\u1ED2\u1ED0\u1ED6\u1ED4\xd5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\xd6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\xd8\u01FE\u0186\u019F\uA74A\uA74C"
    },
    {
        base: "OI",
        letters: "\u01A2"
    },
    {
        base: "OO",
        letters: "\uA74E"
    },
    {
        base: "OU",
        letters: "\u0222"
    },
    {
        base: "P",
        letters: "P\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754"
    },
    {
        base: "Q",
        letters: "Q\u24C6\uFF31\uA756\uA758\u024A"
    },
    {
        base: "R",
        letters: "R\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782"
    },
    {
        base: "S",
        letters: "S\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784"
    },
    {
        base: "T",
        letters: "T\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786"
    },
    {
        base: "TZ",
        letters: "\uA728"
    },
    {
        base: "U",
        letters: "U\u24CA\uFF35\xd9\xda\xdb\u0168\u1E78\u016A\u1E7A\u016C\xdc\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244"
    },
    {
        base: "V",
        letters: "V\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245"
    },
    {
        base: "VY",
        letters: "\uA760"
    },
    {
        base: "W",
        letters: "W\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72"
    },
    {
        base: "X",
        letters: "X\u24CD\uFF38\u1E8A\u1E8C"
    },
    {
        base: "Y",
        letters: "Y\u24CE\uFF39\u1EF2\xdd\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE"
    },
    {
        base: "Z",
        letters: "Z\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762"
    },
    {
        base: "a",
        letters: "a\u24D0\uFF41\u1E9A\xe0\xe1\xe2\u1EA7\u1EA5\u1EAB\u1EA9\xe3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\xe4\u01DF\u1EA3\xe5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250"
    },
    {
        base: "aa",
        letters: "\uA733"
    },
    {
        base: "ae",
        letters: "\xe6\u01FD\u01E3"
    },
    {
        base: "ao",
        letters: "\uA735"
    },
    {
        base: "au",
        letters: "\uA737"
    },
    {
        base: "av",
        letters: "\uA739\uA73B"
    },
    {
        base: "ay",
        letters: "\uA73D"
    },
    {
        base: "b",
        letters: "b\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253"
    },
    {
        base: "c",
        letters: "c\u24D2\uFF43\u0107\u0109\u010B\u010D\xe7\u1E09\u0188\u023C\uA73F\u2184"
    },
    {
        base: "d",
        letters: "d\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A"
    },
    {
        base: "dz",
        letters: "\u01F3\u01C6"
    },
    {
        base: "e",
        letters: "e\u24D4\uFF45\xe8\xe9\xea\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\xeb\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD"
    },
    {
        base: "f",
        letters: "f\u24D5\uFF46\u1E1F\u0192\uA77C"
    },
    {
        base: "g",
        letters: "g\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F"
    },
    {
        base: "h",
        letters: "h\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265"
    },
    {
        base: "hv",
        letters: "\u0195"
    },
    {
        base: "i",
        letters: "i\u24D8\uFF49\xec\xed\xee\u0129\u012B\u012D\xef\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131"
    },
    {
        base: "j",
        letters: "j\u24D9\uFF4A\u0135\u01F0\u0249"
    },
    {
        base: "k",
        letters: "k\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3"
    },
    {
        base: "l",
        letters: "l\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747"
    },
    {
        base: "lj",
        letters: "\u01C9"
    },
    {
        base: "m",
        letters: "m\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F"
    },
    {
        base: "n",
        letters: "n\u24DD\uFF4E\u01F9\u0144\xf1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5"
    },
    {
        base: "nj",
        letters: "\u01CC"
    },
    {
        base: "o",
        letters: "o\u24DE\uFF4F\xf2\xf3\xf4\u1ED3\u1ED1\u1ED7\u1ED5\xf5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\xf6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\xf8\u01FF\u0254\uA74B\uA74D\u0275"
    },
    {
        base: "oi",
        letters: "\u01A3"
    },
    {
        base: "ou",
        letters: "\u0223"
    },
    {
        base: "oo",
        letters: "\uA74F"
    },
    {
        base: "p",
        letters: "p\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755"
    },
    {
        base: "q",
        letters: "q\u24E0\uFF51\u024B\uA757\uA759"
    },
    {
        base: "r",
        letters: "r\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783"
    },
    {
        base: "s",
        letters: "s\u24E2\uFF53\xdf\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B"
    },
    {
        base: "t",
        letters: "t\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787"
    },
    {
        base: "tz",
        letters: "\uA729"
    },
    {
        base: "u",
        letters: "u\u24E4\uFF55\xf9\xfa\xfb\u0169\u1E79\u016B\u1E7B\u016D\xfc\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289"
    },
    {
        base: "v",
        letters: "v\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C"
    },
    {
        base: "vy",
        letters: "\uA761"
    },
    {
        base: "w",
        letters: "w\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73"
    },
    {
        base: "x",
        letters: "x\u24E7\uFF58\u1E8B\u1E8D"
    },
    {
        base: "y",
        letters: "y\u24E8\uFF59\u1EF3\xfd\u0177\u1EF9\u0233\u1E8F\xff\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF"
    },
    {
        base: "z",
        letters: "z\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763"
    }
];
var $0b2c1c6d9ef1aad4$var$anyDiacritic = new RegExp("[" + $0b2c1c6d9ef1aad4$var$diacritics.map(function(d) {
    return d.letters;
}).join("") + "]", "g");
var $0b2c1c6d9ef1aad4$var$diacriticToBase = {};
for(var $0b2c1c6d9ef1aad4$var$i = 0; $0b2c1c6d9ef1aad4$var$i < $0b2c1c6d9ef1aad4$var$diacritics.length; $0b2c1c6d9ef1aad4$var$i++){
    var $0b2c1c6d9ef1aad4$var$diacritic = $0b2c1c6d9ef1aad4$var$diacritics[$0b2c1c6d9ef1aad4$var$i];
    for(var $0b2c1c6d9ef1aad4$var$j = 0; $0b2c1c6d9ef1aad4$var$j < $0b2c1c6d9ef1aad4$var$diacritic.letters.length; $0b2c1c6d9ef1aad4$var$j++)$0b2c1c6d9ef1aad4$var$diacriticToBase[$0b2c1c6d9ef1aad4$var$diacritic.letters[$0b2c1c6d9ef1aad4$var$j]] = $0b2c1c6d9ef1aad4$var$diacritic.base;
}
var $0b2c1c6d9ef1aad4$var$stripDiacritics = function stripDiacritics(str) {
    return str.replace($0b2c1c6d9ef1aad4$var$anyDiacritic, function(match) {
        return $0b2c1c6d9ef1aad4$var$diacriticToBase[match];
    });
};
var $0b2c1c6d9ef1aad4$var$memoizedStripDiacriticsForInput = (0, $fV0Sg.default)($0b2c1c6d9ef1aad4$var$stripDiacritics);
var $0b2c1c6d9ef1aad4$var$trimString = function trimString(str) {
    return str.replace(/^\s+|\s+$/g, "");
};
var $0b2c1c6d9ef1aad4$var$defaultStringify = function defaultStringify(option) {
    return "".concat(option.label, " ").concat(option.value);
};
var $0b2c1c6d9ef1aad4$export$db3b6bfb95261072 = function createFilter(config) {
    return function(option, rawInput) {
        // eslint-disable-next-line no-underscore-dangle
        if (option.data.__isNew__) return true;
        var _ignoreCase$ignoreAcc = (0, $k5N0O.default)({
            ignoreCase: true,
            ignoreAccents: true,
            stringify: $0b2c1c6d9ef1aad4$var$defaultStringify,
            trim: true,
            matchFrom: "any"
        }, config), ignoreCase = _ignoreCase$ignoreAcc.ignoreCase, ignoreAccents = _ignoreCase$ignoreAcc.ignoreAccents, stringify = _ignoreCase$ignoreAcc.stringify, trim = _ignoreCase$ignoreAcc.trim, matchFrom = _ignoreCase$ignoreAcc.matchFrom;
        var input = trim ? $0b2c1c6d9ef1aad4$var$trimString(rawInput) : rawInput;
        var candidate = trim ? $0b2c1c6d9ef1aad4$var$trimString(stringify(option)) : stringify(option);
        if (ignoreCase) {
            input = input.toLowerCase();
            candidate = candidate.toLowerCase();
        }
        if (ignoreAccents) {
            input = $0b2c1c6d9ef1aad4$var$memoizedStripDiacriticsForInput(input);
            candidate = $0b2c1c6d9ef1aad4$var$stripDiacritics(candidate);
        }
        return matchFrom === "start" ? candidate.substr(0, input.length) === input : candidate.indexOf(input) > -1;
    };
};
var $0b2c1c6d9ef1aad4$var$_excluded = [
    "innerRef"
];
function $0b2c1c6d9ef1aad4$var$DummyInput(_ref) {
    var innerRef = _ref.innerRef, props = (0, $h57BE.default)(_ref, $0b2c1c6d9ef1aad4$var$_excluded);
    // Remove animation props not meant for HTML elements
    var filteredProps = (0, $4hU6i.r)(props, "onExited", "in", "enter", "exit", "appear");
    return (0, $2ZUkg.jsx)("input", (0, $fBUaU.default)({
        ref: innerRef
    }, filteredProps, {
        css: /*#__PURE__*/ (0, $2ZUkg.css)({
            label: "dummyInput",
            // get rid of any default styles
            background: 0,
            border: 0,
            // important! this hides the flashing cursor
            caretColor: "transparent",
            fontSize: "inherit",
            gridArea: "1 / 1 / 2 / 3",
            outline: 0,
            padding: 0,
            // important! without `width` browsers won't allow focus
            width: 1,
            // remove cursor on desktop
            color: "transparent",
            // remove cursor on mobile whilst maintaining "scroll into view" behaviour
            left: -100,
            opacity: 0,
            position: "relative",
            transform: "scale(.01)"
        }, "", "")
    }));
}
var $0b2c1c6d9ef1aad4$var$cancelScroll = function cancelScroll(event) {
    if (event.cancelable) event.preventDefault();
    event.stopPropagation();
};
function $0b2c1c6d9ef1aad4$var$useScrollCapture(_ref) {
    var isEnabled = _ref.isEnabled, onBottomArrive = _ref.onBottomArrive, onBottomLeave = _ref.onBottomLeave, onTopArrive = _ref.onTopArrive, onTopLeave = _ref.onTopLeave;
    var isBottom = (0, $iSvIT.useRef)(false);
    var isTop = (0, $iSvIT.useRef)(false);
    var touchStart = (0, $iSvIT.useRef)(0);
    var scrollTarget = (0, $iSvIT.useRef)(null);
    var handleEventDelta = (0, $iSvIT.useCallback)(function(event, delta) {
        if (scrollTarget.current === null) return;
        var _scrollTarget$current = scrollTarget.current, scrollTop = _scrollTarget$current.scrollTop, scrollHeight = _scrollTarget$current.scrollHeight, clientHeight = _scrollTarget$current.clientHeight;
        var target = scrollTarget.current;
        var isDeltaPositive = delta > 0;
        var availableScroll = scrollHeight - clientHeight - scrollTop;
        var shouldCancelScroll = false;
        // reset bottom/top flags
        if (availableScroll > delta && isBottom.current) {
            if (onBottomLeave) onBottomLeave(event);
            isBottom.current = false;
        }
        if (isDeltaPositive && isTop.current) {
            if (onTopLeave) onTopLeave(event);
            isTop.current = false;
        }
        // bottom limit
        if (isDeltaPositive && delta > availableScroll) {
            if (onBottomArrive && !isBottom.current) onBottomArrive(event);
            target.scrollTop = scrollHeight;
            shouldCancelScroll = true;
            isBottom.current = true;
        // top limit
        } else if (!isDeltaPositive && -delta > scrollTop) {
            if (onTopArrive && !isTop.current) onTopArrive(event);
            target.scrollTop = 0;
            shouldCancelScroll = true;
            isTop.current = true;
        }
        // cancel scroll
        if (shouldCancelScroll) $0b2c1c6d9ef1aad4$var$cancelScroll(event);
    }, [
        onBottomArrive,
        onBottomLeave,
        onTopArrive,
        onTopLeave
    ]);
    var onWheel = (0, $iSvIT.useCallback)(function(event) {
        handleEventDelta(event, event.deltaY);
    }, [
        handleEventDelta
    ]);
    var onTouchStart = (0, $iSvIT.useCallback)(function(event) {
        // set touch start so we can calculate touchmove delta
        touchStart.current = event.changedTouches[0].clientY;
    }, []);
    var onTouchMove = (0, $iSvIT.useCallback)(function(event) {
        var deltaY = touchStart.current - event.changedTouches[0].clientY;
        handleEventDelta(event, deltaY);
    }, [
        handleEventDelta
    ]);
    var startListening = (0, $iSvIT.useCallback)(function(el) {
        // bail early if no element is available to attach to
        if (!el) return;
        var notPassive = (0, $4hU6i.s) ? {
            passive: false
        } : false;
        el.addEventListener("wheel", onWheel, notPassive);
        el.addEventListener("touchstart", onTouchStart, notPassive);
        el.addEventListener("touchmove", onTouchMove, notPassive);
    }, [
        onTouchMove,
        onTouchStart,
        onWheel
    ]);
    var stopListening = (0, $iSvIT.useCallback)(function(el) {
        // bail early if no element is available to detach from
        if (!el) return;
        el.removeEventListener("wheel", onWheel, false);
        el.removeEventListener("touchstart", onTouchStart, false);
        el.removeEventListener("touchmove", onTouchMove, false);
    }, [
        onTouchMove,
        onTouchStart,
        onWheel
    ]);
    (0, $iSvIT.useEffect)(function() {
        if (!isEnabled) return;
        var element = scrollTarget.current;
        startListening(element);
        return function() {
            stopListening(element);
        };
    }, [
        isEnabled,
        startListening,
        stopListening
    ]);
    return function(element) {
        scrollTarget.current = element;
    };
}
var $0b2c1c6d9ef1aad4$var$STYLE_KEYS = [
    "boxSizing",
    "height",
    "overflow",
    "paddingRight",
    "position"
];
var $0b2c1c6d9ef1aad4$var$LOCK_STYLES = {
    boxSizing: "border-box",
    // account for possible declaration `width: 100%;` on body
    overflow: "hidden",
    position: "relative",
    height: "100%"
};
function $0b2c1c6d9ef1aad4$var$preventTouchMove(e) {
    e.preventDefault();
}
function $0b2c1c6d9ef1aad4$var$allowTouchMove(e) {
    e.stopPropagation();
}
function $0b2c1c6d9ef1aad4$var$preventInertiaScroll() {
    var top = this.scrollTop;
    var totalScroll = this.scrollHeight;
    var currentScroll = top + this.offsetHeight;
    if (top === 0) this.scrollTop = 1;
    else if (currentScroll === totalScroll) this.scrollTop = top - 1;
}
// `ontouchstart` check works on most browsers
// `maxTouchPoints` works on IE10/11 and Surface
function $0b2c1c6d9ef1aad4$var$isTouchDevice() {
    return "ontouchstart" in window || navigator.maxTouchPoints;
}
var $0b2c1c6d9ef1aad4$var$canUseDOM = !!(typeof window !== "undefined" && window.document && window.document.createElement);
var $0b2c1c6d9ef1aad4$var$activeScrollLocks = 0;
var $0b2c1c6d9ef1aad4$var$listenerOptions = {
    capture: false,
    passive: false
};
function $0b2c1c6d9ef1aad4$var$useScrollLock(_ref) {
    var isEnabled = _ref.isEnabled, _ref$accountForScroll = _ref.accountForScrollbars, accountForScrollbars = _ref$accountForScroll === void 0 ? true : _ref$accountForScroll;
    var originalStyles = (0, $iSvIT.useRef)({});
    var scrollTarget = (0, $iSvIT.useRef)(null);
    var addScrollLock = (0, $iSvIT.useCallback)(function(touchScrollTarget) {
        if (!$0b2c1c6d9ef1aad4$var$canUseDOM) return;
        var target = document.body;
        var targetStyle = target && target.style;
        if (accountForScrollbars) // store any styles already applied to the body
        $0b2c1c6d9ef1aad4$var$STYLE_KEYS.forEach(function(key) {
            var val = targetStyle && targetStyle[key];
            originalStyles.current[key] = val;
        });
        // apply the lock styles and padding if this is the first scroll lock
        if (accountForScrollbars && $0b2c1c6d9ef1aad4$var$activeScrollLocks < 1) {
            var currentPadding = parseInt(originalStyles.current.paddingRight, 10) || 0;
            var clientWidth = document.body ? document.body.clientWidth : 0;
            var adjustedPadding = window.innerWidth - clientWidth + currentPadding || 0;
            Object.keys($0b2c1c6d9ef1aad4$var$LOCK_STYLES).forEach(function(key) {
                var val = $0b2c1c6d9ef1aad4$var$LOCK_STYLES[key];
                if (targetStyle) targetStyle[key] = val;
            });
            if (targetStyle) targetStyle.paddingRight = "".concat(adjustedPadding, "px");
        }
        // account for touch devices
        if (target && $0b2c1c6d9ef1aad4$var$isTouchDevice()) {
            // Mobile Safari ignores { overflow: hidden } declaration on the body.
            target.addEventListener("touchmove", $0b2c1c6d9ef1aad4$var$preventTouchMove, $0b2c1c6d9ef1aad4$var$listenerOptions);
            // Allow scroll on provided target
            if (touchScrollTarget) {
                touchScrollTarget.addEventListener("touchstart", $0b2c1c6d9ef1aad4$var$preventInertiaScroll, $0b2c1c6d9ef1aad4$var$listenerOptions);
                touchScrollTarget.addEventListener("touchmove", $0b2c1c6d9ef1aad4$var$allowTouchMove, $0b2c1c6d9ef1aad4$var$listenerOptions);
            }
        }
        // increment active scroll locks
        $0b2c1c6d9ef1aad4$var$activeScrollLocks += 1;
    }, [
        accountForScrollbars
    ]);
    var removeScrollLock = (0, $iSvIT.useCallback)(function(touchScrollTarget) {
        if (!$0b2c1c6d9ef1aad4$var$canUseDOM) return;
        var target = document.body;
        var targetStyle = target && target.style;
        // safely decrement active scroll locks
        $0b2c1c6d9ef1aad4$var$activeScrollLocks = Math.max($0b2c1c6d9ef1aad4$var$activeScrollLocks - 1, 0);
        // reapply original body styles, if any
        if (accountForScrollbars && $0b2c1c6d9ef1aad4$var$activeScrollLocks < 1) $0b2c1c6d9ef1aad4$var$STYLE_KEYS.forEach(function(key) {
            var val = originalStyles.current[key];
            if (targetStyle) targetStyle[key] = val;
        });
        // remove touch listeners
        if (target && $0b2c1c6d9ef1aad4$var$isTouchDevice()) {
            target.removeEventListener("touchmove", $0b2c1c6d9ef1aad4$var$preventTouchMove, $0b2c1c6d9ef1aad4$var$listenerOptions);
            if (touchScrollTarget) {
                touchScrollTarget.removeEventListener("touchstart", $0b2c1c6d9ef1aad4$var$preventInertiaScroll, $0b2c1c6d9ef1aad4$var$listenerOptions);
                touchScrollTarget.removeEventListener("touchmove", $0b2c1c6d9ef1aad4$var$allowTouchMove, $0b2c1c6d9ef1aad4$var$listenerOptions);
            }
        }
    }, [
        accountForScrollbars
    ]);
    (0, $iSvIT.useEffect)(function() {
        if (!isEnabled) return;
        var element = scrollTarget.current;
        addScrollLock(element);
        return function() {
            removeScrollLock(element);
        };
    }, [
        isEnabled,
        addScrollLock,
        removeScrollLock
    ]);
    return function(element) {
        scrollTarget.current = element;
    };
}
function $0b2c1c6d9ef1aad4$var$_EMOTION_STRINGIFIED_CSS_ERROR__$1() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $0b2c1c6d9ef1aad4$var$blurSelectInput = function blurSelectInput(event) {
    var element = event.target;
    return element.ownerDocument.activeElement && element.ownerDocument.activeElement.blur();
};
var $0b2c1c6d9ef1aad4$var$_ref2$1 = {
    name: "1kfdb0e",
    styles: "position:fixed;left:0;bottom:0;right:0;top:0"
};
function $0b2c1c6d9ef1aad4$var$ScrollManager(_ref) {
    var children = _ref.children, lockEnabled = _ref.lockEnabled, _ref$captureEnabled = _ref.captureEnabled, captureEnabled = _ref$captureEnabled === void 0 ? true : _ref$captureEnabled, onBottomArrive = _ref.onBottomArrive, onBottomLeave = _ref.onBottomLeave, onTopArrive = _ref.onTopArrive, onTopLeave = _ref.onTopLeave;
    var setScrollCaptureTarget = $0b2c1c6d9ef1aad4$var$useScrollCapture({
        isEnabled: captureEnabled,
        onBottomArrive: onBottomArrive,
        onBottomLeave: onBottomLeave,
        onTopArrive: onTopArrive,
        onTopLeave: onTopLeave
    });
    var setScrollLockTarget = $0b2c1c6d9ef1aad4$var$useScrollLock({
        isEnabled: lockEnabled
    });
    var targetRef = function targetRef(element) {
        setScrollCaptureTarget(element);
        setScrollLockTarget(element);
    };
    return (0, $2ZUkg.jsx)((0, $iSvIT.Fragment), null, lockEnabled && (0, $2ZUkg.jsx)("div", {
        onClick: $0b2c1c6d9ef1aad4$var$blurSelectInput,
        css: $0b2c1c6d9ef1aad4$var$_ref2$1
    }), children(targetRef));
}
function $0b2c1c6d9ef1aad4$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $0b2c1c6d9ef1aad4$var$_ref2 = {
    name: "1a0ro4n-requiredInput",
    styles: "label:requiredInput;opacity:0;pointer-events:none;position:absolute;bottom:0;left:0;right:0;width:100%"
};
var $0b2c1c6d9ef1aad4$var$RequiredInput = function RequiredInput(_ref) {
    var name = _ref.name, onFocus = _ref.onFocus;
    return (0, $2ZUkg.jsx)("input", {
        required: true,
        name: name,
        tabIndex: -1,
        "aria-hidden": "true",
        onFocus: onFocus,
        css: $0b2c1c6d9ef1aad4$var$_ref2,
        value: "",
        onChange: function onChange() {}
    });
};
var $0b2c1c6d9ef1aad4$var$RequiredInput$1 = $0b2c1c6d9ef1aad4$var$RequiredInput;
var $0b2c1c6d9ef1aad4$var$formatGroupLabel = function formatGroupLabel(group) {
    return group.label;
};
var $0b2c1c6d9ef1aad4$export$8b22cf2602fb60ce = function getOptionLabel(option) {
    return option.label;
};
var $0b2c1c6d9ef1aad4$export$39b482c5e57630a8 = function getOptionValue(option) {
    return option.value;
};
var $0b2c1c6d9ef1aad4$var$isOptionDisabled = function isOptionDisabled(option) {
    return !!option.isDisabled;
};
var $0b2c1c6d9ef1aad4$var$defaultStyles = {
    clearIndicator: (0, $4hU6i.a),
    container: (0, $4hU6i.b),
    control: (0, $4hU6i.d),
    dropdownIndicator: (0, $4hU6i.e),
    group: (0, $4hU6i.g),
    groupHeading: (0, $4hU6i.f),
    indicatorsContainer: (0, $4hU6i.i),
    indicatorSeparator: (0, $4hU6i.h),
    input: (0, $4hU6i.j),
    loadingIndicator: (0, $4hU6i.l),
    loadingMessage: (0, $4hU6i.k),
    menu: (0, $4hU6i.m),
    menuList: (0, $4hU6i.n),
    menuPortal: (0, $4hU6i.o),
    multiValue: (0, $4hU6i.p),
    multiValueLabel: (0, $4hU6i.q),
    multiValueRemove: (0, $4hU6i.t),
    noOptionsMessage: (0, $4hU6i.u),
    option: (0, $4hU6i.v),
    placeholder: (0, $4hU6i.w),
    singleValue: (0, $4hU6i.x),
    valueContainer: (0, $4hU6i.y)
};
// Merge Utility
// Allows consumers to extend a base Select with additional styles
function $0b2c1c6d9ef1aad4$export$953cecd6e717a553(source) {
    var target = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    // initialize with source styles
    var styles = (0, $k5N0O.default)({}, source);
    // massage in target styles
    Object.keys(target).forEach(function(keyAsString) {
        var key = keyAsString;
        if (source[key]) styles[key] = function(rsCss, props) {
            return target[key](source[key](rsCss, props), props);
        };
        else styles[key] = target[key];
    });
    return styles;
}
var $0b2c1c6d9ef1aad4$var$colors = {
    primary: "#2684FF",
    primary75: "#4C9AFF",
    primary50: "#B2D4FF",
    primary25: "#DEEBFF",
    danger: "#DE350B",
    dangerLight: "#FFBDAD",
    neutral0: "hsl(0, 0%, 100%)",
    neutral5: "hsl(0, 0%, 95%)",
    neutral10: "hsl(0, 0%, 90%)",
    neutral20: "hsl(0, 0%, 80%)",
    neutral30: "hsl(0, 0%, 70%)",
    neutral40: "hsl(0, 0%, 60%)",
    neutral50: "hsl(0, 0%, 50%)",
    neutral60: "hsl(0, 0%, 40%)",
    neutral70: "hsl(0, 0%, 30%)",
    neutral80: "hsl(0, 0%, 20%)",
    neutral90: "hsl(0, 0%, 10%)"
};
var $0b2c1c6d9ef1aad4$var$borderRadius = 4;
// Used to calculate consistent margin/padding on elements
var $0b2c1c6d9ef1aad4$var$baseUnit = 4;
// The minimum height of the control
var $0b2c1c6d9ef1aad4$var$controlHeight = 38;
// The amount of space between the control and menu */
var $0b2c1c6d9ef1aad4$var$menuGutter = $0b2c1c6d9ef1aad4$var$baseUnit * 2;
var $0b2c1c6d9ef1aad4$var$spacing = {
    baseUnit: $0b2c1c6d9ef1aad4$var$baseUnit,
    controlHeight: $0b2c1c6d9ef1aad4$var$controlHeight,
    menuGutter: $0b2c1c6d9ef1aad4$var$menuGutter
};
var $0b2c1c6d9ef1aad4$export$4368d992c4eafac0 = {
    borderRadius: $0b2c1c6d9ef1aad4$var$borderRadius,
    colors: $0b2c1c6d9ef1aad4$var$colors,
    spacing: $0b2c1c6d9ef1aad4$var$spacing
};
var $0b2c1c6d9ef1aad4$export$407448d2b89b1813 = {
    "aria-live": "polite",
    backspaceRemovesValue: true,
    blurInputOnSelect: (0, $4hU6i.z)(),
    captureMenuScroll: !(0, $4hU6i.z)(),
    classNames: {},
    closeMenuOnSelect: true,
    closeMenuOnScroll: false,
    components: {},
    controlShouldRenderValue: true,
    escapeClearsValue: false,
    filterOption: $0b2c1c6d9ef1aad4$export$db3b6bfb95261072(),
    formatGroupLabel: $0b2c1c6d9ef1aad4$var$formatGroupLabel,
    getOptionLabel: $0b2c1c6d9ef1aad4$export$8b22cf2602fb60ce,
    getOptionValue: $0b2c1c6d9ef1aad4$export$39b482c5e57630a8,
    isDisabled: false,
    isLoading: false,
    isMulti: false,
    isRtl: false,
    isSearchable: true,
    isOptionDisabled: $0b2c1c6d9ef1aad4$var$isOptionDisabled,
    loadingMessage: function loadingMessage() {
        return "Loading...";
    },
    maxMenuHeight: 300,
    minMenuHeight: 140,
    menuIsOpen: false,
    menuPlacement: "bottom",
    menuPosition: "absolute",
    menuShouldBlockScroll: false,
    menuShouldScrollIntoView: !(0, $4hU6i.A)(),
    noOptionsMessage: function noOptionsMessage() {
        return "No options";
    },
    openMenuOnFocus: false,
    openMenuOnClick: true,
    options: [],
    pageSize: 5,
    placeholder: "Select...",
    screenReaderStatus: function screenReaderStatus(_ref) {
        var count = _ref.count;
        return "".concat(count, " result").concat(count !== 1 ? "s" : "", " available");
    },
    styles: {},
    tabIndex: 0,
    tabSelectsValue: true,
    unstyled: false
};
function $0b2c1c6d9ef1aad4$var$toCategorizedOption(props, option, selectValue, index) {
    var isDisabled = $0b2c1c6d9ef1aad4$var$_isOptionDisabled(props, option, selectValue);
    var isSelected = $0b2c1c6d9ef1aad4$var$_isOptionSelected(props, option, selectValue);
    var label = $0b2c1c6d9ef1aad4$var$getOptionLabel(props, option);
    var value = $0b2c1c6d9ef1aad4$var$getOptionValue(props, option);
    return {
        type: "option",
        data: option,
        isDisabled: isDisabled,
        isSelected: isSelected,
        label: label,
        value: value,
        index: index
    };
}
function $0b2c1c6d9ef1aad4$var$buildCategorizedOptions(props, selectValue) {
    return props.options.map(function(groupOrOption, groupOrOptionIndex) {
        if ("options" in groupOrOption) {
            var categorizedOptions = groupOrOption.options.map(function(option, optionIndex) {
                return $0b2c1c6d9ef1aad4$var$toCategorizedOption(props, option, selectValue, optionIndex);
            }).filter(function(categorizedOption) {
                return $0b2c1c6d9ef1aad4$var$isFocusable(props, categorizedOption);
            });
            return categorizedOptions.length > 0 ? {
                type: "group",
                data: groupOrOption,
                options: categorizedOptions,
                index: groupOrOptionIndex
            } : undefined;
        }
        var categorizedOption = $0b2c1c6d9ef1aad4$var$toCategorizedOption(props, groupOrOption, selectValue, groupOrOptionIndex);
        return $0b2c1c6d9ef1aad4$var$isFocusable(props, categorizedOption) ? categorizedOption : undefined;
    }).filter((0, $4hU6i.K));
}
function $0b2c1c6d9ef1aad4$var$buildFocusableOptionsFromCategorizedOptions(categorizedOptions) {
    return categorizedOptions.reduce(function(optionsAccumulator, categorizedOption) {
        if (categorizedOption.type === "group") optionsAccumulator.push.apply(optionsAccumulator, (0, $aGqhc.default)(categorizedOption.options.map(function(option) {
            return option.data;
        })));
        else optionsAccumulator.push(categorizedOption.data);
        return optionsAccumulator;
    }, []);
}
function $0b2c1c6d9ef1aad4$var$buildFocusableOptions(props, selectValue) {
    return $0b2c1c6d9ef1aad4$var$buildFocusableOptionsFromCategorizedOptions($0b2c1c6d9ef1aad4$var$buildCategorizedOptions(props, selectValue));
}
function $0b2c1c6d9ef1aad4$var$isFocusable(props, categorizedOption) {
    var _props$inputValue = props.inputValue, inputValue = _props$inputValue === void 0 ? "" : _props$inputValue;
    var data = categorizedOption.data, isSelected = categorizedOption.isSelected, label = categorizedOption.label, value = categorizedOption.value;
    return (!$0b2c1c6d9ef1aad4$var$shouldHideSelectedOptions(props) || !isSelected) && $0b2c1c6d9ef1aad4$var$_filterOption(props, {
        label: label,
        value: value,
        data: data
    }, inputValue);
}
function $0b2c1c6d9ef1aad4$var$getNextFocusedValue(state, nextSelectValue) {
    var focusedValue = state.focusedValue, lastSelectValue = state.selectValue;
    var lastFocusedIndex = lastSelectValue.indexOf(focusedValue);
    if (lastFocusedIndex > -1) {
        var nextFocusedIndex = nextSelectValue.indexOf(focusedValue);
        if (nextFocusedIndex > -1) // the focused value is still in the selectValue, return it
        return focusedValue;
        else if (lastFocusedIndex < nextSelectValue.length) // the focusedValue is not present in the next selectValue array by
        // reference, so return the new value at the same index
        return nextSelectValue[lastFocusedIndex];
    }
    return null;
}
function $0b2c1c6d9ef1aad4$var$getNextFocusedOption(state, options) {
    var lastFocusedOption = state.focusedOption;
    return lastFocusedOption && options.indexOf(lastFocusedOption) > -1 ? lastFocusedOption : options[0];
}
var $0b2c1c6d9ef1aad4$var$getOptionLabel = function getOptionLabel(props, data) {
    return props.getOptionLabel(data);
};
var $0b2c1c6d9ef1aad4$var$getOptionValue = function getOptionValue(props, data) {
    return props.getOptionValue(data);
};
function $0b2c1c6d9ef1aad4$var$_isOptionDisabled(props, option, selectValue) {
    return typeof props.isOptionDisabled === "function" ? props.isOptionDisabled(option, selectValue) : false;
}
function $0b2c1c6d9ef1aad4$var$_isOptionSelected(props, option, selectValue) {
    if (selectValue.indexOf(option) > -1) return true;
    if (typeof props.isOptionSelected === "function") return props.isOptionSelected(option, selectValue);
    var candidate = $0b2c1c6d9ef1aad4$var$getOptionValue(props, option);
    return selectValue.some(function(i) {
        return $0b2c1c6d9ef1aad4$var$getOptionValue(props, i) === candidate;
    });
}
function $0b2c1c6d9ef1aad4$var$_filterOption(props, option, inputValue) {
    return props.filterOption ? props.filterOption(option, inputValue) : true;
}
var $0b2c1c6d9ef1aad4$var$shouldHideSelectedOptions = function shouldHideSelectedOptions(props) {
    var hideSelectedOptions = props.hideSelectedOptions, isMulti = props.isMulti;
    if (hideSelectedOptions === undefined) return isMulti;
    return hideSelectedOptions;
};
var $0b2c1c6d9ef1aad4$var$instanceId = 1;
var $0b2c1c6d9ef1aad4$export$25ce5a424b770e84 = /*#__PURE__*/ function(_Component) {
    (0, $5guBO.default)(Select, _Component);
    var _super = (0, $8BpI7.default)(Select);
    // Misc. Instance Properties
    // ------------------------------
    // TODO
    // Refs
    // ------------------------------
    // Lifecycle
    // ------------------------------
    function Select(_props) {
        var _this;
        (0, $aReVA.default)(this, Select);
        _this = _super.call(this, _props);
        _this.state = {
            ariaSelection: null,
            focusedOption: null,
            focusedValue: null,
            inputIsHidden: false,
            isFocused: false,
            selectValue: [],
            clearFocusValueOnUpdate: false,
            prevWasFocused: false,
            inputIsHiddenAfterUpdate: undefined,
            prevProps: undefined
        };
        _this.blockOptionHover = false;
        _this.isComposing = false;
        _this.commonProps = void 0;
        _this.initialTouchX = 0;
        _this.initialTouchY = 0;
        _this.instancePrefix = "";
        _this.openAfterFocus = false;
        _this.scrollToFocusedOptionOnUpdate = false;
        _this.userIsDragging = void 0;
        _this.controlRef = null;
        _this.getControlRef = function(ref) {
            _this.controlRef = ref;
        };
        _this.focusedOptionRef = null;
        _this.getFocusedOptionRef = function(ref) {
            _this.focusedOptionRef = ref;
        };
        _this.menuListRef = null;
        _this.getMenuListRef = function(ref) {
            _this.menuListRef = ref;
        };
        _this.inputRef = null;
        _this.getInputRef = function(ref) {
            _this.inputRef = ref;
        };
        _this.focus = _this.focusInput;
        _this.blur = _this.blurInput;
        _this.onChange = function(newValue, actionMeta) {
            var _this$props = _this.props, onChange = _this$props.onChange, name = _this$props.name;
            actionMeta.name = name;
            _this.ariaOnChange(newValue, actionMeta);
            onChange(newValue, actionMeta);
        };
        _this.setValue = function(newValue, action, option) {
            var _this$props2 = _this.props, closeMenuOnSelect = _this$props2.closeMenuOnSelect, isMulti = _this$props2.isMulti, inputValue = _this$props2.inputValue;
            _this.onInputChange("", {
                action: "set-value",
                prevInputValue: inputValue
            });
            if (closeMenuOnSelect) {
                _this.setState({
                    inputIsHiddenAfterUpdate: !isMulti
                });
                _this.onMenuClose();
            }
            // when the select value should change, we should reset focusedValue
            _this.setState({
                clearFocusValueOnUpdate: true
            });
            _this.onChange(newValue, {
                action: action,
                option: option
            });
        };
        _this.selectOption = function(newValue) {
            var _this$props3 = _this.props, blurInputOnSelect = _this$props3.blurInputOnSelect, isMulti = _this$props3.isMulti, name = _this$props3.name;
            var selectValue = _this.state.selectValue;
            var deselected = isMulti && _this.isOptionSelected(newValue, selectValue);
            var isDisabled = _this.isOptionDisabled(newValue, selectValue);
            if (deselected) {
                var candidate = _this.getOptionValue(newValue);
                _this.setValue((0, $4hU6i.B)(selectValue.filter(function(i) {
                    return _this.getOptionValue(i) !== candidate;
                })), "deselect-option", newValue);
            } else if (!isDisabled) {
                // Select option if option is not disabled
                if (isMulti) _this.setValue((0, $4hU6i.B)([].concat((0, $aGqhc.default)(selectValue), [
                    newValue
                ])), "select-option", newValue);
                else _this.setValue((0, $4hU6i.C)(newValue), "select-option");
            } else {
                _this.ariaOnChange((0, $4hU6i.C)(newValue), {
                    action: "select-option",
                    option: newValue,
                    name: name
                });
                return;
            }
            if (blurInputOnSelect) _this.blurInput();
        };
        _this.removeValue = function(removedValue) {
            var isMulti = _this.props.isMulti;
            var selectValue = _this.state.selectValue;
            var candidate = _this.getOptionValue(removedValue);
            var newValueArray = selectValue.filter(function(i) {
                return _this.getOptionValue(i) !== candidate;
            });
            var newValue = (0, $4hU6i.D)(isMulti, newValueArray, newValueArray[0] || null);
            _this.onChange(newValue, {
                action: "remove-value",
                removedValue: removedValue
            });
            _this.focusInput();
        };
        _this.clearValue = function() {
            var selectValue = _this.state.selectValue;
            _this.onChange((0, $4hU6i.D)(_this.props.isMulti, [], null), {
                action: "clear",
                removedValues: selectValue
            });
        };
        _this.popValue = function() {
            var isMulti = _this.props.isMulti;
            var selectValue = _this.state.selectValue;
            var lastSelectedValue = selectValue[selectValue.length - 1];
            var newValueArray = selectValue.slice(0, selectValue.length - 1);
            var newValue = (0, $4hU6i.D)(isMulti, newValueArray, newValueArray[0] || null);
            _this.onChange(newValue, {
                action: "pop-value",
                removedValue: lastSelectedValue
            });
        };
        _this.getValue = function() {
            return _this.state.selectValue;
        };
        _this.cx = function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            return (0, $4hU6i.E).apply(void 0, [
                _this.props.classNamePrefix
            ].concat(args));
        };
        _this.getOptionLabel = function(data) {
            return $0b2c1c6d9ef1aad4$var$getOptionLabel(_this.props, data);
        };
        _this.getOptionValue = function(data) {
            return $0b2c1c6d9ef1aad4$var$getOptionValue(_this.props, data);
        };
        _this.getStyles = function(key, props) {
            var unstyled = _this.props.unstyled;
            var base = $0b2c1c6d9ef1aad4$var$defaultStyles[key](props, unstyled);
            base.boxSizing = "border-box";
            var custom = _this.props.styles[key];
            return custom ? custom(base, props) : base;
        };
        _this.getClassNames = function(key, props) {
            var _this$props$className, _this$props$className2;
            return (_this$props$className = (_this$props$className2 = _this.props.classNames)[key]) === null || _this$props$className === void 0 ? void 0 : _this$props$className.call(_this$props$className2, props);
        };
        _this.getElementId = function(element) {
            return "".concat(_this.instancePrefix, "-").concat(element);
        };
        _this.getComponents = function() {
            return (0, $4hU6i.F)(_this.props);
        };
        _this.buildCategorizedOptions = function() {
            return $0b2c1c6d9ef1aad4$var$buildCategorizedOptions(_this.props, _this.state.selectValue);
        };
        _this.getCategorizedOptions = function() {
            return _this.props.menuIsOpen ? _this.buildCategorizedOptions() : [];
        };
        _this.buildFocusableOptions = function() {
            return $0b2c1c6d9ef1aad4$var$buildFocusableOptionsFromCategorizedOptions(_this.buildCategorizedOptions());
        };
        _this.getFocusableOptions = function() {
            return _this.props.menuIsOpen ? _this.buildFocusableOptions() : [];
        };
        _this.ariaOnChange = function(value, actionMeta) {
            _this.setState({
                ariaSelection: (0, $k5N0O.default)({
                    value: value
                }, actionMeta)
            });
        };
        _this.onMenuMouseDown = function(event) {
            if (event.button !== 0) return;
            event.stopPropagation();
            event.preventDefault();
            _this.focusInput();
        };
        _this.onMenuMouseMove = function(event) {
            _this.blockOptionHover = false;
        };
        _this.onControlMouseDown = function(event) {
            // Event captured by dropdown indicator
            if (event.defaultPrevented) return;
            var openMenuOnClick = _this.props.openMenuOnClick;
            if (!_this.state.isFocused) {
                if (openMenuOnClick) _this.openAfterFocus = true;
                _this.focusInput();
            } else if (!_this.props.menuIsOpen) {
                if (openMenuOnClick) _this.openMenu("first");
            } else if (event.target.tagName !== "INPUT" && event.target.tagName !== "TEXTAREA") _this.onMenuClose();
            if (event.target.tagName !== "INPUT" && event.target.tagName !== "TEXTAREA") event.preventDefault();
        };
        _this.onDropdownIndicatorMouseDown = function(event) {
            // ignore mouse events that weren't triggered by the primary button
            if (event && event.type === "mousedown" && event.button !== 0) return;
            if (_this.props.isDisabled) return;
            var _this$props4 = _this.props, isMulti = _this$props4.isMulti, menuIsOpen = _this$props4.menuIsOpen;
            _this.focusInput();
            if (menuIsOpen) {
                _this.setState({
                    inputIsHiddenAfterUpdate: !isMulti
                });
                _this.onMenuClose();
            } else _this.openMenu("first");
            event.preventDefault();
        };
        _this.onClearIndicatorMouseDown = function(event) {
            // ignore mouse events that weren't triggered by the primary button
            if (event && event.type === "mousedown" && event.button !== 0) return;
            _this.clearValue();
            event.preventDefault();
            _this.openAfterFocus = false;
            if (event.type === "touchend") _this.focusInput();
            else setTimeout(function() {
                return _this.focusInput();
            });
        };
        _this.onScroll = function(event) {
            if (typeof _this.props.closeMenuOnScroll === "boolean") {
                if (event.target instanceof HTMLElement && (0, $4hU6i.G)(event.target)) _this.props.onMenuClose();
            } else if (typeof _this.props.closeMenuOnScroll === "function") {
                if (_this.props.closeMenuOnScroll(event)) _this.props.onMenuClose();
            }
        };
        _this.onCompositionStart = function() {
            _this.isComposing = true;
        };
        _this.onCompositionEnd = function() {
            _this.isComposing = false;
        };
        _this.onTouchStart = function(_ref2) {
            var touches = _ref2.touches;
            var touch = touches && touches.item(0);
            if (!touch) return;
            _this.initialTouchX = touch.clientX;
            _this.initialTouchY = touch.clientY;
            _this.userIsDragging = false;
        };
        _this.onTouchMove = function(_ref3) {
            var touches = _ref3.touches;
            var touch = touches && touches.item(0);
            if (!touch) return;
            var deltaX = Math.abs(touch.clientX - _this.initialTouchX);
            var deltaY = Math.abs(touch.clientY - _this.initialTouchY);
            var moveThreshold = 5;
            _this.userIsDragging = deltaX > moveThreshold || deltaY > moveThreshold;
        };
        _this.onTouchEnd = function(event) {
            if (_this.userIsDragging) return;
            // close the menu if the user taps outside
            // we're checking on event.target here instead of event.currentTarget, because we want to assert information
            // on events on child elements, not the document (which we've attached this handler to).
            if (_this.controlRef && !_this.controlRef.contains(event.target) && _this.menuListRef && !_this.menuListRef.contains(event.target)) _this.blurInput();
            // reset move vars
            _this.initialTouchX = 0;
            _this.initialTouchY = 0;
        };
        _this.onControlTouchEnd = function(event) {
            if (_this.userIsDragging) return;
            _this.onControlMouseDown(event);
        };
        _this.onClearIndicatorTouchEnd = function(event) {
            if (_this.userIsDragging) return;
            _this.onClearIndicatorMouseDown(event);
        };
        _this.onDropdownIndicatorTouchEnd = function(event) {
            if (_this.userIsDragging) return;
            _this.onDropdownIndicatorMouseDown(event);
        };
        _this.handleInputChange = function(event) {
            var prevInputValue = _this.props.inputValue;
            var inputValue = event.currentTarget.value;
            _this.setState({
                inputIsHiddenAfterUpdate: false
            });
            _this.onInputChange(inputValue, {
                action: "input-change",
                prevInputValue: prevInputValue
            });
            if (!_this.props.menuIsOpen) _this.onMenuOpen();
        };
        _this.onInputFocus = function(event) {
            if (_this.props.onFocus) _this.props.onFocus(event);
            _this.setState({
                inputIsHiddenAfterUpdate: false,
                isFocused: true
            });
            if (_this.openAfterFocus || _this.props.openMenuOnFocus) _this.openMenu("first");
            _this.openAfterFocus = false;
        };
        _this.onInputBlur = function(event) {
            var prevInputValue = _this.props.inputValue;
            if (_this.menuListRef && _this.menuListRef.contains(document.activeElement)) {
                _this.inputRef.focus();
                return;
            }
            if (_this.props.onBlur) _this.props.onBlur(event);
            _this.onInputChange("", {
                action: "input-blur",
                prevInputValue: prevInputValue
            });
            _this.onMenuClose();
            _this.setState({
                focusedValue: null,
                isFocused: false
            });
        };
        _this.onOptionHover = function(focusedOption) {
            if (_this.blockOptionHover || _this.state.focusedOption === focusedOption) return;
            _this.setState({
                focusedOption: focusedOption
            });
        };
        _this.shouldHideSelectedOptions = function() {
            return $0b2c1c6d9ef1aad4$var$shouldHideSelectedOptions(_this.props);
        };
        _this.onValueInputFocus = function(e) {
            e.preventDefault();
            e.stopPropagation();
            _this.focus();
        };
        _this.onKeyDown = function(event) {
            var _this$props5 = _this.props, isMulti = _this$props5.isMulti, backspaceRemovesValue = _this$props5.backspaceRemovesValue, escapeClearsValue = _this$props5.escapeClearsValue, inputValue = _this$props5.inputValue, isClearable = _this$props5.isClearable, isDisabled = _this$props5.isDisabled, menuIsOpen = _this$props5.menuIsOpen, onKeyDown = _this$props5.onKeyDown, tabSelectsValue = _this$props5.tabSelectsValue, openMenuOnFocus = _this$props5.openMenuOnFocus;
            var _this$state = _this.state, focusedOption = _this$state.focusedOption, focusedValue = _this$state.focusedValue, selectValue = _this$state.selectValue;
            if (isDisabled) return;
            if (typeof onKeyDown === "function") {
                onKeyDown(event);
                if (event.defaultPrevented) return;
            }
            // Block option hover events when the user has just pressed a key
            _this.blockOptionHover = true;
            switch(event.key){
                case "ArrowLeft":
                    if (!isMulti || inputValue) return;
                    _this.focusValue("previous");
                    break;
                case "ArrowRight":
                    if (!isMulti || inputValue) return;
                    _this.focusValue("next");
                    break;
                case "Delete":
                case "Backspace":
                    if (inputValue) return;
                    if (focusedValue) _this.removeValue(focusedValue);
                    else {
                        if (!backspaceRemovesValue) return;
                        if (isMulti) _this.popValue();
                        else if (isClearable) _this.clearValue();
                    }
                    break;
                case "Tab":
                    if (_this.isComposing) return;
                    if (event.shiftKey || !menuIsOpen || !tabSelectsValue || !focusedOption || // don't capture the event if the menu opens on focus and the focused
                    // option is already selected; it breaks the flow of navigation
                    openMenuOnFocus && _this.isOptionSelected(focusedOption, selectValue)) return;
                    _this.selectOption(focusedOption);
                    break;
                case "Enter":
                    if (event.keyCode === 229) break;
                    if (menuIsOpen) {
                        if (!focusedOption) return;
                        if (_this.isComposing) return;
                        _this.selectOption(focusedOption);
                        break;
                    }
                    return;
                case "Escape":
                    if (menuIsOpen) {
                        _this.setState({
                            inputIsHiddenAfterUpdate: false
                        });
                        _this.onInputChange("", {
                            action: "menu-close",
                            prevInputValue: inputValue
                        });
                        _this.onMenuClose();
                    } else if (isClearable && escapeClearsValue) _this.clearValue();
                    break;
                case " ":
                    // space
                    if (inputValue) return;
                    if (!menuIsOpen) {
                        _this.openMenu("first");
                        break;
                    }
                    if (!focusedOption) return;
                    _this.selectOption(focusedOption);
                    break;
                case "ArrowUp":
                    if (menuIsOpen) _this.focusOption("up");
                    else _this.openMenu("last");
                    break;
                case "ArrowDown":
                    if (menuIsOpen) _this.focusOption("down");
                    else _this.openMenu("first");
                    break;
                case "PageUp":
                    if (!menuIsOpen) return;
                    _this.focusOption("pageup");
                    break;
                case "PageDown":
                    if (!menuIsOpen) return;
                    _this.focusOption("pagedown");
                    break;
                case "Home":
                    if (!menuIsOpen) return;
                    _this.focusOption("first");
                    break;
                case "End":
                    if (!menuIsOpen) return;
                    _this.focusOption("last");
                    break;
                default:
                    return;
            }
            event.preventDefault();
        };
        _this.instancePrefix = "react-select-" + (_this.props.instanceId || ++$0b2c1c6d9ef1aad4$var$instanceId);
        _this.state.selectValue = (0, $4hU6i.H)(_props.value);
        // Set focusedOption if menuIsOpen is set on init (e.g. defaultMenuIsOpen)
        if (_props.menuIsOpen && _this.state.selectValue.length) {
            var focusableOptions = _this.buildFocusableOptions();
            var optionIndex = focusableOptions.indexOf(_this.state.selectValue[0]);
            _this.state.focusedOption = focusableOptions[optionIndex];
        }
        return _this;
    }
    (0, $ly09p.default)(Select, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.startListeningComposition();
                this.startListeningToTouch();
                if (this.props.closeMenuOnScroll && document && document.addEventListener) // Listen to all scroll events, and filter them out inside of 'onScroll'
                document.addEventListener("scroll", this.onScroll, true);
                if (this.props.autoFocus) this.focusInput();
                // Scroll focusedOption into view if menuIsOpen is set on mount (e.g. defaultMenuIsOpen)
                if (this.props.menuIsOpen && this.state.focusedOption && this.menuListRef && this.focusedOptionRef) (0, $4hU6i.I)(this.menuListRef, this.focusedOptionRef);
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps) {
                var _this$props6 = this.props, isDisabled = _this$props6.isDisabled, menuIsOpen = _this$props6.menuIsOpen;
                var isFocused = this.state.isFocused;
                if (// ensure focus is restored correctly when the control becomes enabled
                isFocused && !isDisabled && prevProps.isDisabled || // ensure focus is on the Input when the menu opens
                isFocused && menuIsOpen && !prevProps.menuIsOpen) this.focusInput();
                if (isFocused && isDisabled && !prevProps.isDisabled) // ensure select state gets blurred in case Select is programmatically disabled while focused
                // eslint-disable-next-line react/no-did-update-set-state
                this.setState({
                    isFocused: false
                }, this.onMenuClose);
                else if (!isFocused && !isDisabled && prevProps.isDisabled && this.inputRef === document.activeElement) // ensure select state gets focused in case Select is programatically re-enabled while focused (Firefox)
                // eslint-disable-next-line react/no-did-update-set-state
                this.setState({
                    isFocused: true
                });
                // scroll the focused option into view if necessary
                if (this.menuListRef && this.focusedOptionRef && this.scrollToFocusedOptionOnUpdate) {
                    (0, $4hU6i.I)(this.menuListRef, this.focusedOptionRef);
                    this.scrollToFocusedOptionOnUpdate = false;
                }
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.stopListeningComposition();
                this.stopListeningToTouch();
                document.removeEventListener("scroll", this.onScroll, true);
            }
        },
        {
            key: "onMenuOpen",
            value: function onMenuOpen() {
                this.props.onMenuOpen();
            }
        },
        {
            key: "onMenuClose",
            value: function onMenuClose() {
                this.onInputChange("", {
                    action: "menu-close",
                    prevInputValue: this.props.inputValue
                });
                this.props.onMenuClose();
            }
        },
        {
            key: "onInputChange",
            value: function onInputChange(newValue, actionMeta) {
                this.props.onInputChange(newValue, actionMeta);
            }
        },
        {
            key: "focusInput",
            value: function focusInput() {
                if (!this.inputRef) return;
                this.inputRef.focus();
            }
        },
        {
            key: "blurInput",
            value: function blurInput() {
                if (!this.inputRef) return;
                this.inputRef.blur();
            }
        },
        {
            key: "openMenu",
            value: function openMenu(focusOption) {
                var _this2 = this;
                var _this$state2 = this.state, selectValue = _this$state2.selectValue, isFocused = _this$state2.isFocused;
                var focusableOptions = this.buildFocusableOptions();
                var openAtIndex = focusOption === "first" ? 0 : focusableOptions.length - 1;
                if (!this.props.isMulti) {
                    var selectedIndex = focusableOptions.indexOf(selectValue[0]);
                    if (selectedIndex > -1) openAtIndex = selectedIndex;
                }
                // only scroll if the menu isn't already open
                this.scrollToFocusedOptionOnUpdate = !(isFocused && this.menuListRef);
                this.setState({
                    inputIsHiddenAfterUpdate: false,
                    focusedValue: null,
                    focusedOption: focusableOptions[openAtIndex]
                }, function() {
                    return _this2.onMenuOpen();
                });
            }
        },
        {
            key: "focusValue",
            value: function focusValue(direction) {
                var _this$state3 = this.state, selectValue = _this$state3.selectValue, focusedValue = _this$state3.focusedValue;
                // Only multiselects support value focusing
                if (!this.props.isMulti) return;
                this.setState({
                    focusedOption: null
                });
                var focusedIndex = selectValue.indexOf(focusedValue);
                if (!focusedValue) focusedIndex = -1;
                var lastIndex = selectValue.length - 1;
                var nextFocus = -1;
                if (!selectValue.length) return;
                switch(direction){
                    case "previous":
                        if (focusedIndex === 0) // don't cycle from the start to the end
                        nextFocus = 0;
                        else if (focusedIndex === -1) // if nothing is focused, focus the last value first
                        nextFocus = lastIndex;
                        else nextFocus = focusedIndex - 1;
                        break;
                    case "next":
                        if (focusedIndex > -1 && focusedIndex < lastIndex) nextFocus = focusedIndex + 1;
                        break;
                }
                this.setState({
                    inputIsHidden: nextFocus !== -1,
                    focusedValue: selectValue[nextFocus]
                });
            }
        },
        {
            key: "focusOption",
            value: function focusOption() {
                var direction = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "first";
                var pageSize = this.props.pageSize;
                var focusedOption = this.state.focusedOption;
                var options = this.getFocusableOptions();
                if (!options.length) return;
                var nextFocus = 0; // handles 'first'
                var focusedIndex = options.indexOf(focusedOption);
                if (!focusedOption) focusedIndex = -1;
                if (direction === "up") nextFocus = focusedIndex > 0 ? focusedIndex - 1 : options.length - 1;
                else if (direction === "down") nextFocus = (focusedIndex + 1) % options.length;
                else if (direction === "pageup") {
                    nextFocus = focusedIndex - pageSize;
                    if (nextFocus < 0) nextFocus = 0;
                } else if (direction === "pagedown") {
                    nextFocus = focusedIndex + pageSize;
                    if (nextFocus > options.length - 1) nextFocus = options.length - 1;
                } else if (direction === "last") nextFocus = options.length - 1;
                this.scrollToFocusedOptionOnUpdate = true;
                this.setState({
                    focusedOption: options[nextFocus],
                    focusedValue: null
                });
            }
        },
        {
            key: "getTheme",
            value: // ==============================
            // Getters
            // ==============================
            function getTheme() {
                // Use the default theme if there are no customisations.
                if (!this.props.theme) return $0b2c1c6d9ef1aad4$export$4368d992c4eafac0;
                // If the theme prop is a function, assume the function
                // knows how to merge the passed-in default theme with
                // its own modifications.
                if (typeof this.props.theme === "function") return this.props.theme($0b2c1c6d9ef1aad4$export$4368d992c4eafac0);
                // Otherwise, if a plain theme object was passed in,
                // overlay it with the default theme.
                return (0, $k5N0O.default)((0, $k5N0O.default)({}, $0b2c1c6d9ef1aad4$export$4368d992c4eafac0), this.props.theme);
            }
        },
        {
            key: "getCommonProps",
            value: function getCommonProps() {
                var clearValue = this.clearValue, cx = this.cx, getStyles = this.getStyles, getClassNames = this.getClassNames, getValue = this.getValue, selectOption = this.selectOption, setValue = this.setValue, props = this.props;
                var isMulti = props.isMulti, isRtl = props.isRtl, options = props.options;
                var hasValue = this.hasValue();
                return {
                    clearValue: clearValue,
                    cx: cx,
                    getStyles: getStyles,
                    getClassNames: getClassNames,
                    getValue: getValue,
                    hasValue: hasValue,
                    isMulti: isMulti,
                    isRtl: isRtl,
                    options: options,
                    selectOption: selectOption,
                    selectProps: props,
                    setValue: setValue,
                    theme: this.getTheme()
                };
            }
        },
        {
            key: "hasValue",
            value: function hasValue() {
                var selectValue = this.state.selectValue;
                return selectValue.length > 0;
            }
        },
        {
            key: "hasOptions",
            value: function hasOptions() {
                return !!this.getFocusableOptions().length;
            }
        },
        {
            key: "isClearable",
            value: function isClearable() {
                var _this$props7 = this.props, isClearable = _this$props7.isClearable, isMulti = _this$props7.isMulti;
                // single select, by default, IS NOT clearable
                // multi select, by default, IS clearable
                if (isClearable === undefined) return isMulti;
                return isClearable;
            }
        },
        {
            key: "isOptionDisabled",
            value: function isOptionDisabled(option, selectValue) {
                return $0b2c1c6d9ef1aad4$var$_isOptionDisabled(this.props, option, selectValue);
            }
        },
        {
            key: "isOptionSelected",
            value: function isOptionSelected(option, selectValue) {
                return $0b2c1c6d9ef1aad4$var$_isOptionSelected(this.props, option, selectValue);
            }
        },
        {
            key: "filterOption",
            value: function filterOption(option, inputValue) {
                return $0b2c1c6d9ef1aad4$var$_filterOption(this.props, option, inputValue);
            }
        },
        {
            key: "formatOptionLabel",
            value: function formatOptionLabel(data, context) {
                if (typeof this.props.formatOptionLabel === "function") {
                    var _inputValue = this.props.inputValue;
                    var _selectValue = this.state.selectValue;
                    return this.props.formatOptionLabel(data, {
                        context: context,
                        inputValue: _inputValue,
                        selectValue: _selectValue
                    });
                } else return this.getOptionLabel(data);
            }
        },
        {
            key: "formatGroupLabel",
            value: function formatGroupLabel(data) {
                return this.props.formatGroupLabel(data);
            }
        },
        {
            key: "startListeningComposition",
            value: // ==============================
            // Composition Handlers
            // ==============================
            function startListeningComposition() {
                if (document && document.addEventListener) {
                    document.addEventListener("compositionstart", this.onCompositionStart, false);
                    document.addEventListener("compositionend", this.onCompositionEnd, false);
                }
            }
        },
        {
            key: "stopListeningComposition",
            value: function stopListeningComposition() {
                if (document && document.removeEventListener) {
                    document.removeEventListener("compositionstart", this.onCompositionStart);
                    document.removeEventListener("compositionend", this.onCompositionEnd);
                }
            }
        },
        {
            key: "startListeningToTouch",
            value: // ==============================
            // Touch Handlers
            // ==============================
            function startListeningToTouch() {
                if (document && document.addEventListener) {
                    document.addEventListener("touchstart", this.onTouchStart, false);
                    document.addEventListener("touchmove", this.onTouchMove, false);
                    document.addEventListener("touchend", this.onTouchEnd, false);
                }
            }
        },
        {
            key: "stopListeningToTouch",
            value: function stopListeningToTouch() {
                if (document && document.removeEventListener) {
                    document.removeEventListener("touchstart", this.onTouchStart);
                    document.removeEventListener("touchmove", this.onTouchMove);
                    document.removeEventListener("touchend", this.onTouchEnd);
                }
            }
        },
        {
            key: "renderInput",
            value: // ==============================
            // Renderers
            // ==============================
            function renderInput() {
                var _this$props8 = this.props, isDisabled = _this$props8.isDisabled, isSearchable = _this$props8.isSearchable, inputId = _this$props8.inputId, inputValue = _this$props8.inputValue, tabIndex = _this$props8.tabIndex, form = _this$props8.form, menuIsOpen = _this$props8.menuIsOpen, required = _this$props8.required;
                var _this$getComponents = this.getComponents(), Input = _this$getComponents.Input;
                var _this$state4 = this.state, inputIsHidden = _this$state4.inputIsHidden, ariaSelection = _this$state4.ariaSelection;
                var commonProps = this.commonProps;
                var id = inputId || this.getElementId("input");
                // aria attributes makes the JSX "noisy", separated for clarity
                var ariaAttributes = (0, $k5N0O.default)((0, $k5N0O.default)((0, $k5N0O.default)({
                    "aria-autocomplete": "list",
                    "aria-expanded": menuIsOpen,
                    "aria-haspopup": true,
                    "aria-errormessage": this.props["aria-errormessage"],
                    "aria-invalid": this.props["aria-invalid"],
                    "aria-label": this.props["aria-label"],
                    "aria-labelledby": this.props["aria-labelledby"],
                    "aria-required": required,
                    role: "combobox"
                }, menuIsOpen && {
                    "aria-controls": this.getElementId("listbox"),
                    "aria-owns": this.getElementId("listbox")
                }), !isSearchable && {
                    "aria-readonly": true
                }), this.hasValue() ? (ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === "initial-input-focus" && {
                    "aria-describedby": this.getElementId("live-region")
                } : {
                    "aria-describedby": this.getElementId("placeholder")
                });
                if (!isSearchable) // use a dummy input to maintain focus/blur functionality
                return /*#__PURE__*/ $iSvIT.createElement($0b2c1c6d9ef1aad4$var$DummyInput, (0, $fBUaU.default)({
                    id: id,
                    innerRef: this.getInputRef,
                    onBlur: this.onInputBlur,
                    onChange: (0, $4hU6i.J),
                    onFocus: this.onInputFocus,
                    disabled: isDisabled,
                    tabIndex: tabIndex,
                    inputMode: "none",
                    form: form,
                    value: ""
                }, ariaAttributes));
                return /*#__PURE__*/ $iSvIT.createElement(Input, (0, $fBUaU.default)({}, commonProps, {
                    autoCapitalize: "none",
                    autoComplete: "off",
                    autoCorrect: "off",
                    id: id,
                    innerRef: this.getInputRef,
                    isDisabled: isDisabled,
                    isHidden: inputIsHidden,
                    onBlur: this.onInputBlur,
                    onChange: this.handleInputChange,
                    onFocus: this.onInputFocus,
                    spellCheck: "false",
                    tabIndex: tabIndex,
                    form: form,
                    type: "text",
                    value: inputValue
                }, ariaAttributes));
            }
        },
        {
            key: "renderPlaceholderOrValue",
            value: function renderPlaceholderOrValue() {
                var _this3 = this;
                var _this$getComponents2 = this.getComponents(), MultiValue = _this$getComponents2.MultiValue, MultiValueContainer = _this$getComponents2.MultiValueContainer, MultiValueLabel = _this$getComponents2.MultiValueLabel, MultiValueRemove = _this$getComponents2.MultiValueRemove, SingleValue = _this$getComponents2.SingleValue, Placeholder = _this$getComponents2.Placeholder;
                var commonProps = this.commonProps;
                var _this$props9 = this.props, controlShouldRenderValue = _this$props9.controlShouldRenderValue, isDisabled = _this$props9.isDisabled, isMulti = _this$props9.isMulti, inputValue = _this$props9.inputValue, placeholder = _this$props9.placeholder;
                var _this$state5 = this.state, selectValue = _this$state5.selectValue, focusedValue = _this$state5.focusedValue, isFocused = _this$state5.isFocused;
                if (!this.hasValue() || !controlShouldRenderValue) return inputValue ? null : /*#__PURE__*/ $iSvIT.createElement(Placeholder, (0, $fBUaU.default)({}, commonProps, {
                    key: "placeholder",
                    isDisabled: isDisabled,
                    isFocused: isFocused,
                    innerProps: {
                        id: this.getElementId("placeholder")
                    }
                }), placeholder);
                if (isMulti) return selectValue.map(function(opt, index) {
                    var isOptionFocused = opt === focusedValue;
                    var key = "".concat(_this3.getOptionLabel(opt), "-").concat(_this3.getOptionValue(opt));
                    return /*#__PURE__*/ $iSvIT.createElement(MultiValue, (0, $fBUaU.default)({}, commonProps, {
                        components: {
                            Container: MultiValueContainer,
                            Label: MultiValueLabel,
                            Remove: MultiValueRemove
                        },
                        isFocused: isOptionFocused,
                        isDisabled: isDisabled,
                        key: key,
                        index: index,
                        removeProps: {
                            onClick: function onClick() {
                                return _this3.removeValue(opt);
                            },
                            onTouchEnd: function onTouchEnd() {
                                return _this3.removeValue(opt);
                            },
                            onMouseDown: function onMouseDown(e) {
                                e.preventDefault();
                            }
                        },
                        data: opt
                    }), _this3.formatOptionLabel(opt, "value"));
                });
                if (inputValue) return null;
                var singleValue = selectValue[0];
                return /*#__PURE__*/ $iSvIT.createElement(SingleValue, (0, $fBUaU.default)({}, commonProps, {
                    data: singleValue,
                    isDisabled: isDisabled
                }), this.formatOptionLabel(singleValue, "value"));
            }
        },
        {
            key: "renderClearIndicator",
            value: function renderClearIndicator() {
                var _this$getComponents3 = this.getComponents(), ClearIndicator = _this$getComponents3.ClearIndicator;
                var commonProps = this.commonProps;
                var _this$props10 = this.props, isDisabled = _this$props10.isDisabled, isLoading = _this$props10.isLoading;
                var isFocused = this.state.isFocused;
                if (!this.isClearable() || !ClearIndicator || isDisabled || !this.hasValue() || isLoading) return null;
                var innerProps = {
                    onMouseDown: this.onClearIndicatorMouseDown,
                    onTouchEnd: this.onClearIndicatorTouchEnd,
                    "aria-hidden": "true"
                };
                return /*#__PURE__*/ $iSvIT.createElement(ClearIndicator, (0, $fBUaU.default)({}, commonProps, {
                    innerProps: innerProps,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderLoadingIndicator",
            value: function renderLoadingIndicator() {
                var _this$getComponents4 = this.getComponents(), LoadingIndicator = _this$getComponents4.LoadingIndicator;
                var commonProps = this.commonProps;
                var _this$props11 = this.props, isDisabled = _this$props11.isDisabled, isLoading = _this$props11.isLoading;
                var isFocused = this.state.isFocused;
                if (!LoadingIndicator || !isLoading) return null;
                var innerProps = {
                    "aria-hidden": "true"
                };
                return /*#__PURE__*/ $iSvIT.createElement(LoadingIndicator, (0, $fBUaU.default)({}, commonProps, {
                    innerProps: innerProps,
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderIndicatorSeparator",
            value: function renderIndicatorSeparator() {
                var _this$getComponents5 = this.getComponents(), DropdownIndicator = _this$getComponents5.DropdownIndicator, IndicatorSeparator = _this$getComponents5.IndicatorSeparator;
                // separator doesn't make sense without the dropdown indicator
                if (!DropdownIndicator || !IndicatorSeparator) return null;
                var commonProps = this.commonProps;
                var isDisabled = this.props.isDisabled;
                var isFocused = this.state.isFocused;
                return /*#__PURE__*/ $iSvIT.createElement(IndicatorSeparator, (0, $fBUaU.default)({}, commonProps, {
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderDropdownIndicator",
            value: function renderDropdownIndicator() {
                var _this$getComponents6 = this.getComponents(), DropdownIndicator = _this$getComponents6.DropdownIndicator;
                if (!DropdownIndicator) return null;
                var commonProps = this.commonProps;
                var isDisabled = this.props.isDisabled;
                var isFocused = this.state.isFocused;
                var innerProps = {
                    onMouseDown: this.onDropdownIndicatorMouseDown,
                    onTouchEnd: this.onDropdownIndicatorTouchEnd,
                    "aria-hidden": "true"
                };
                return /*#__PURE__*/ $iSvIT.createElement(DropdownIndicator, (0, $fBUaU.default)({}, commonProps, {
                    innerProps: innerProps,
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderMenu",
            value: function renderMenu() {
                var _this4 = this;
                var _this$getComponents7 = this.getComponents(), Group = _this$getComponents7.Group, GroupHeading = _this$getComponents7.GroupHeading, Menu = _this$getComponents7.Menu, MenuList = _this$getComponents7.MenuList, MenuPortal = _this$getComponents7.MenuPortal, LoadingMessage = _this$getComponents7.LoadingMessage, NoOptionsMessage = _this$getComponents7.NoOptionsMessage, Option = _this$getComponents7.Option;
                var commonProps = this.commonProps;
                var focusedOption = this.state.focusedOption;
                var _this$props12 = this.props, captureMenuScroll = _this$props12.captureMenuScroll, inputValue = _this$props12.inputValue, isLoading = _this$props12.isLoading, loadingMessage = _this$props12.loadingMessage, minMenuHeight = _this$props12.minMenuHeight, maxMenuHeight = _this$props12.maxMenuHeight, menuIsOpen = _this$props12.menuIsOpen, menuPlacement = _this$props12.menuPlacement, menuPosition = _this$props12.menuPosition, menuPortalTarget = _this$props12.menuPortalTarget, menuShouldBlockScroll = _this$props12.menuShouldBlockScroll, menuShouldScrollIntoView = _this$props12.menuShouldScrollIntoView, noOptionsMessage = _this$props12.noOptionsMessage, onMenuScrollToTop = _this$props12.onMenuScrollToTop, onMenuScrollToBottom = _this$props12.onMenuScrollToBottom;
                if (!menuIsOpen) return null;
                // TODO: Internal Option Type here
                var render = function render(props, id) {
                    var type = props.type, data = props.data, isDisabled = props.isDisabled, isSelected = props.isSelected, label = props.label, value = props.value;
                    var isFocused = focusedOption === data;
                    var onHover = isDisabled ? undefined : function() {
                        return _this4.onOptionHover(data);
                    };
                    var onSelect = isDisabled ? undefined : function() {
                        return _this4.selectOption(data);
                    };
                    var optionId = "".concat(_this4.getElementId("option"), "-").concat(id);
                    var innerProps = {
                        id: optionId,
                        onClick: onSelect,
                        onMouseMove: onHover,
                        onMouseOver: onHover,
                        tabIndex: -1
                    };
                    return /*#__PURE__*/ $iSvIT.createElement(Option, (0, $fBUaU.default)({}, commonProps, {
                        innerProps: innerProps,
                        data: data,
                        isDisabled: isDisabled,
                        isSelected: isSelected,
                        key: optionId,
                        label: label,
                        type: type,
                        value: value,
                        isFocused: isFocused,
                        innerRef: isFocused ? _this4.getFocusedOptionRef : undefined
                    }), _this4.formatOptionLabel(props.data, "menu"));
                };
                var menuUI;
                if (this.hasOptions()) menuUI = this.getCategorizedOptions().map(function(item) {
                    if (item.type === "group") {
                        var _data = item.data, options = item.options, groupIndex = item.index;
                        var groupId = "".concat(_this4.getElementId("group"), "-").concat(groupIndex);
                        var headingId = "".concat(groupId, "-heading");
                        return /*#__PURE__*/ $iSvIT.createElement(Group, (0, $fBUaU.default)({}, commonProps, {
                            key: groupId,
                            data: _data,
                            options: options,
                            Heading: GroupHeading,
                            headingProps: {
                                id: headingId,
                                data: item.data
                            },
                            label: _this4.formatGroupLabel(item.data)
                        }), item.options.map(function(option) {
                            return render(option, "".concat(groupIndex, "-").concat(option.index));
                        }));
                    } else if (item.type === "option") return render(item, "".concat(item.index));
                });
                else if (isLoading) {
                    var message = loadingMessage({
                        inputValue: inputValue
                    });
                    if (message === null) return null;
                    menuUI = /*#__PURE__*/ $iSvIT.createElement(LoadingMessage, commonProps, message);
                } else {
                    var _message = noOptionsMessage({
                        inputValue: inputValue
                    });
                    if (_message === null) return null;
                    menuUI = /*#__PURE__*/ $iSvIT.createElement(NoOptionsMessage, commonProps, _message);
                }
                var menuPlacementProps = {
                    minMenuHeight: minMenuHeight,
                    maxMenuHeight: maxMenuHeight,
                    menuPlacement: menuPlacement,
                    menuPosition: menuPosition,
                    menuShouldScrollIntoView: menuShouldScrollIntoView
                };
                var menuElement = /*#__PURE__*/ $iSvIT.createElement((0, $4hU6i.M), (0, $fBUaU.default)({}, commonProps, menuPlacementProps), function(_ref4) {
                    var ref = _ref4.ref, _ref4$placerProps = _ref4.placerProps, placement = _ref4$placerProps.placement, maxHeight = _ref4$placerProps.maxHeight;
                    return /*#__PURE__*/ $iSvIT.createElement(Menu, (0, $fBUaU.default)({}, commonProps, menuPlacementProps, {
                        innerRef: ref,
                        innerProps: {
                            onMouseDown: _this4.onMenuMouseDown,
                            onMouseMove: _this4.onMenuMouseMove,
                            id: _this4.getElementId("listbox")
                        },
                        isLoading: isLoading,
                        placement: placement
                    }), /*#__PURE__*/ $iSvIT.createElement($0b2c1c6d9ef1aad4$var$ScrollManager, {
                        captureEnabled: captureMenuScroll,
                        onTopArrive: onMenuScrollToTop,
                        onBottomArrive: onMenuScrollToBottom,
                        lockEnabled: menuShouldBlockScroll
                    }, function(scrollTargetRef) {
                        return /*#__PURE__*/ $iSvIT.createElement(MenuList, (0, $fBUaU.default)({}, commonProps, {
                            innerRef: function innerRef(instance) {
                                _this4.getMenuListRef(instance);
                                scrollTargetRef(instance);
                            },
                            isLoading: isLoading,
                            maxHeight: maxHeight,
                            focusedOption: focusedOption
                        }), menuUI);
                    }));
                });
                // positioning behaviour is almost identical for portalled and fixed,
                // so we use the same component. the actual portalling logic is forked
                // within the component based on `menuPosition`
                return menuPortalTarget || menuPosition === "fixed" ? /*#__PURE__*/ $iSvIT.createElement(MenuPortal, (0, $fBUaU.default)({}, commonProps, {
                    appendTo: menuPortalTarget,
                    controlElement: this.controlRef,
                    menuPlacement: menuPlacement,
                    menuPosition: menuPosition
                }), menuElement) : menuElement;
            }
        },
        {
            key: "renderFormField",
            value: function renderFormField() {
                var _this5 = this;
                var _this$props13 = this.props, delimiter = _this$props13.delimiter, isDisabled = _this$props13.isDisabled, isMulti = _this$props13.isMulti, name = _this$props13.name, required = _this$props13.required;
                var selectValue = this.state.selectValue;
                if (required && !this.hasValue() && !isDisabled) return /*#__PURE__*/ $iSvIT.createElement($0b2c1c6d9ef1aad4$var$RequiredInput$1, {
                    name: name,
                    onFocus: this.onValueInputFocus
                });
                if (!name || isDisabled) return;
                if (isMulti) {
                    if (delimiter) {
                        var value = selectValue.map(function(opt) {
                            return _this5.getOptionValue(opt);
                        }).join(delimiter);
                        return /*#__PURE__*/ $iSvIT.createElement("input", {
                            name: name,
                            type: "hidden",
                            value: value
                        });
                    } else {
                        var input = selectValue.length > 0 ? selectValue.map(function(opt, i) {
                            return /*#__PURE__*/ $iSvIT.createElement("input", {
                                key: "i-".concat(i),
                                name: name,
                                type: "hidden",
                                value: _this5.getOptionValue(opt)
                            });
                        }) : /*#__PURE__*/ $iSvIT.createElement("input", {
                            name: name,
                            type: "hidden",
                            value: ""
                        });
                        return /*#__PURE__*/ $iSvIT.createElement("div", null, input);
                    }
                } else {
                    var _value = selectValue[0] ? this.getOptionValue(selectValue[0]) : "";
                    return /*#__PURE__*/ $iSvIT.createElement("input", {
                        name: name,
                        type: "hidden",
                        value: _value
                    });
                }
            }
        },
        {
            key: "renderLiveRegion",
            value: function renderLiveRegion() {
                var commonProps = this.commonProps;
                var _this$state6 = this.state, ariaSelection = _this$state6.ariaSelection, focusedOption = _this$state6.focusedOption, focusedValue = _this$state6.focusedValue, isFocused = _this$state6.isFocused, selectValue = _this$state6.selectValue;
                var focusableOptions = this.getFocusableOptions();
                return /*#__PURE__*/ $iSvIT.createElement($0b2c1c6d9ef1aad4$var$LiveRegion$1, (0, $fBUaU.default)({}, commonProps, {
                    id: this.getElementId("live-region"),
                    ariaSelection: ariaSelection,
                    focusedOption: focusedOption,
                    focusedValue: focusedValue,
                    isFocused: isFocused,
                    selectValue: selectValue,
                    focusableOptions: focusableOptions
                }));
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$getComponents8 = this.getComponents(), Control = _this$getComponents8.Control, IndicatorsContainer = _this$getComponents8.IndicatorsContainer, SelectContainer = _this$getComponents8.SelectContainer, ValueContainer = _this$getComponents8.ValueContainer;
                var _this$props14 = this.props, className = _this$props14.className, id = _this$props14.id, isDisabled = _this$props14.isDisabled, menuIsOpen = _this$props14.menuIsOpen;
                var isFocused = this.state.isFocused;
                var commonProps = this.commonProps = this.getCommonProps();
                return /*#__PURE__*/ $iSvIT.createElement(SelectContainer, (0, $fBUaU.default)({}, commonProps, {
                    className: className,
                    innerProps: {
                        id: id,
                        onKeyDown: this.onKeyDown
                    },
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }), this.renderLiveRegion(), /*#__PURE__*/ $iSvIT.createElement(Control, (0, $fBUaU.default)({}, commonProps, {
                    innerRef: this.getControlRef,
                    innerProps: {
                        onMouseDown: this.onControlMouseDown,
                        onTouchEnd: this.onControlTouchEnd
                    },
                    isDisabled: isDisabled,
                    isFocused: isFocused,
                    menuIsOpen: menuIsOpen
                }), /*#__PURE__*/ $iSvIT.createElement(ValueContainer, (0, $fBUaU.default)({}, commonProps, {
                    isDisabled: isDisabled
                }), this.renderPlaceholderOrValue(), this.renderInput()), /*#__PURE__*/ $iSvIT.createElement(IndicatorsContainer, (0, $fBUaU.default)({}, commonProps, {
                    isDisabled: isDisabled
                }), this.renderClearIndicator(), this.renderLoadingIndicator(), this.renderIndicatorSeparator(), this.renderDropdownIndicator())), this.renderMenu(), this.renderFormField());
            }
        }
    ], [
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(props, state) {
                var prevProps = state.prevProps, clearFocusValueOnUpdate = state.clearFocusValueOnUpdate, inputIsHiddenAfterUpdate = state.inputIsHiddenAfterUpdate, ariaSelection = state.ariaSelection, isFocused = state.isFocused, prevWasFocused = state.prevWasFocused;
                var options = props.options, value = props.value, menuIsOpen = props.menuIsOpen, inputValue = props.inputValue, isMulti = props.isMulti;
                var selectValue = (0, $4hU6i.H)(value);
                var newMenuOptionsState = {};
                if (prevProps && (value !== prevProps.value || options !== prevProps.options || menuIsOpen !== prevProps.menuIsOpen || inputValue !== prevProps.inputValue)) {
                    var focusableOptions = menuIsOpen ? $0b2c1c6d9ef1aad4$var$buildFocusableOptions(props, selectValue) : [];
                    var focusedValue = clearFocusValueOnUpdate ? $0b2c1c6d9ef1aad4$var$getNextFocusedValue(state, selectValue) : null;
                    var focusedOption = $0b2c1c6d9ef1aad4$var$getNextFocusedOption(state, focusableOptions);
                    newMenuOptionsState = {
                        selectValue: selectValue,
                        focusedOption: focusedOption,
                        focusedValue: focusedValue,
                        clearFocusValueOnUpdate: false
                    };
                }
                // some updates should toggle the state of the input visibility
                var newInputIsHiddenState = inputIsHiddenAfterUpdate != null && props !== prevProps ? {
                    inputIsHidden: inputIsHiddenAfterUpdate,
                    inputIsHiddenAfterUpdate: undefined
                } : {};
                var newAriaSelection = ariaSelection;
                var hasKeptFocus = isFocused && prevWasFocused;
                if (isFocused && !hasKeptFocus) {
                    // If `value` or `defaultValue` props are not empty then announce them
                    // when the Select is initially focused
                    newAriaSelection = {
                        value: (0, $4hU6i.D)(isMulti, selectValue, selectValue[0] || null),
                        options: selectValue,
                        action: "initial-input-focus"
                    };
                    hasKeptFocus = !prevWasFocused;
                }
                // If the 'initial-input-focus' action has been set already
                // then reset the ariaSelection to null
                if ((ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === "initial-input-focus") newAriaSelection = null;
                return (0, $k5N0O.default)((0, $k5N0O.default)((0, $k5N0O.default)({}, newMenuOptionsState), newInputIsHiddenState), {}, {
                    prevProps: props,
                    ariaSelection: newAriaSelection,
                    prevWasFocused: hasKeptFocus
                });
            }
        }
    ]);
    return Select;
}((0, $iSvIT.Component));
$0b2c1c6d9ef1aad4$export$25ce5a424b770e84.defaultProps = $0b2c1c6d9ef1aad4$export$407448d2b89b1813;

});
parcelRegister("aReVA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7e7a6ef5f4648094$export$2e2bcd8739ae039; });
function $7e7a6ef5f4648094$export$2e2bcd8739ae039(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}

});

parcelRegister("ly09p", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fafce3e1044e60b5$export$2e2bcd8739ae039; });

var $ienzO = parcelRequire("ienzO");
function $fafce3e1044e60b5$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, (0, $ienzO.default)(o.key), o);
    }
}
function $fafce3e1044e60b5$export$2e2bcd8739ae039(e, r, t) {
    return r && $fafce3e1044e60b5$var$_defineProperties(e.prototype, r), t && $fafce3e1044e60b5$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}

});

parcelRegister("5guBO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3d5630a2b7f4f662$export$2e2bcd8739ae039; });

var $6Zycf = parcelRequire("6Zycf");
function $3d5630a2b7f4f662$export$2e2bcd8739ae039(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(t, "prototype", {
        writable: !1
    }), e && (0, $6Zycf.default)(t, e);
}

});
parcelRegister("6Zycf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5172f74813dc4d15$export$2e2bcd8739ae039; });
function $5172f74813dc4d15$export$2e2bcd8739ae039(t, e) {
    return $5172f74813dc4d15$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $5172f74813dc4d15$export$2e2bcd8739ae039(t, e);
}

});


parcelRegister("8BpI7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6435b9048ce6c65b$export$2e2bcd8739ae039; });

var $h1rf5 = parcelRequire("h1rf5");

var $h19K0 = parcelRequire("h19K0");

var $2j9Ex = parcelRequire("2j9Ex");
function $6435b9048ce6c65b$export$2e2bcd8739ae039(t) {
    var r = (0, $h19K0.default)();
    return function() {
        var e, o = (0, $h1rf5.default)(t);
        if (r) {
            var s = (0, $h1rf5.default)(this).constructor;
            e = Reflect.construct(o, arguments, s);
        } else e = o.apply(this, arguments);
        return (0, $2j9Ex.default)(this, e);
    };
}

});
parcelRegister("h1rf5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c647a9713f19d997$export$2e2bcd8739ae039; });
function $c647a9713f19d997$export$2e2bcd8739ae039(t) {
    return $c647a9713f19d997$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, $c647a9713f19d997$export$2e2bcd8739ae039(t);
}

});

parcelRegister("h19K0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c63a16071b585dfa$export$2e2bcd8739ae039; });
function $c63a16071b585dfa$export$2e2bcd8739ae039() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($c63a16071b585dfa$export$2e2bcd8739ae039 = function _isNativeReflectConstruct() {
        return !!t;
    })();
}

});

parcelRegister("2j9Ex", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1ae4d7f45fe314a8$export$2e2bcd8739ae039; });

var $hFz8f = parcelRequire("hFz8f");

var $1L5sO = parcelRequire("1L5sO");
function $1ae4d7f45fe314a8$export$2e2bcd8739ae039(t, e) {
    if (e && ("object" == (0, $hFz8f.default)(e) || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return (0, $1L5sO.default)(t);
}

});
parcelRegister("1L5sO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $147e6b36ac0d6910$export$2e2bcd8739ae039; });
function $147e6b36ac0d6910$export$2e2bcd8739ae039(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}

});



parcelRegister("aGqhc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7c723597d5be111e$export$2e2bcd8739ae039; });

var $k6qnI = parcelRequire("k6qnI");

var $7qH2x = parcelRequire("7qH2x");

var $iHw5C = parcelRequire("iHw5C");

var $dNonQ = parcelRequire("dNonQ");
function $7c723597d5be111e$export$2e2bcd8739ae039(r) {
    return (0, $k6qnI.default)(r) || (0, $7qH2x.default)(r) || (0, $iHw5C.default)(r) || (0, $dNonQ.default)();
}

});
parcelRegister("k6qnI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ea28d4ffd0784ba2$export$2e2bcd8739ae039; });

var $6HmTm = parcelRequire("6HmTm");
function $ea28d4ffd0784ba2$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return (0, $6HmTm.default)(r);
}

});

parcelRegister("7qH2x", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $568c58f66325839e$export$2e2bcd8739ae039; });
function $568c58f66325839e$export$2e2bcd8739ae039(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}

});

parcelRegister("dNonQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a0b2c40c090a0537$export$2e2bcd8739ae039; });
function $a0b2c40c090a0537$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("4hU6i", function(module, exports) {

$parcel$export(module.exports, "J", function () { return $31f4445e1a7a95b7$export$b4171a6734a65d42; });
$parcel$export(module.exports, "E", function () { return $31f4445e1a7a95b7$export$a9c23c6ac3fc3eca; });
$parcel$export(module.exports, "H", function () { return $31f4445e1a7a95b7$export$7f8ddf7c7c20b3cd; });
$parcel$export(module.exports, "G", function () { return $31f4445e1a7a95b7$export$2329c99376c9d0a4; });
$parcel$export(module.exports, "I", function () { return $31f4445e1a7a95b7$export$9bb611d729802a56; });
$parcel$export(module.exports, "z", function () { return $31f4445e1a7a95b7$export$df995fae86a55f06; });
$parcel$export(module.exports, "A", function () { return $31f4445e1a7a95b7$export$ebd11618f299a286; });
$parcel$export(module.exports, "s", function () { return $31f4445e1a7a95b7$export$2408f22a0fab9ae5; });
$parcel$export(module.exports, "K", function () { return $31f4445e1a7a95b7$export$3466f893ebf79586; });
$parcel$export(module.exports, "D", function () { return $31f4445e1a7a95b7$export$96f57966bedc81b4; });
$parcel$export(module.exports, "C", function () { return $31f4445e1a7a95b7$export$e7094788287c5e9b; });
$parcel$export(module.exports, "B", function () { return $31f4445e1a7a95b7$export$ef35774e6d314e91; });
$parcel$export(module.exports, "r", function () { return $31f4445e1a7a95b7$export$43caf9889c228507; });
$parcel$export(module.exports, "m", function () { return $31f4445e1a7a95b7$export$953cecd6e717a553; });
$parcel$export(module.exports, "M", function () { return $31f4445e1a7a95b7$export$3a1a48c8f6ef640e; });
$parcel$export(module.exports, "n", function () { return $31f4445e1a7a95b7$export$7ccc53e8f1e7dfc5; });
$parcel$export(module.exports, "u", function () { return $31f4445e1a7a95b7$export$3b14a55fb2447963; });
$parcel$export(module.exports, "k", function () { return $31f4445e1a7a95b7$export$342063e11d6c3cad; });
$parcel$export(module.exports, "o", function () { return $31f4445e1a7a95b7$export$ae1af26003f05816; });
$parcel$export(module.exports, "b", function () { return $31f4445e1a7a95b7$export$8b22cf2602fb60ce; });
$parcel$export(module.exports, "y", function () { return $31f4445e1a7a95b7$export$4a5767248b18ef41; });
$parcel$export(module.exports, "i", function () { return $31f4445e1a7a95b7$export$23f2a1d2818174ef; });
$parcel$export(module.exports, "e", function () { return $31f4445e1a7a95b7$export$f1e1789686576879; });
$parcel$export(module.exports, "a", function () { return $31f4445e1a7a95b7$export$407448d2b89b1813; });
$parcel$export(module.exports, "h", function () { return $31f4445e1a7a95b7$export$dda1d9f60106f0e9; });
$parcel$export(module.exports, "l", function () { return $31f4445e1a7a95b7$export$882b5998b3b9117c; });
$parcel$export(module.exports, "d", function () { return $31f4445e1a7a95b7$export$4368d992c4eafac0; });
$parcel$export(module.exports, "g", function () { return $31f4445e1a7a95b7$export$39b482c5e57630a8; });
$parcel$export(module.exports, "f", function () { return $31f4445e1a7a95b7$export$2d1720544b23b823; });
$parcel$export(module.exports, "j", function () { return $31f4445e1a7a95b7$export$35e795649ee09318; });
$parcel$export(module.exports, "p", function () { return $31f4445e1a7a95b7$export$ffb5f4729a158638; });
$parcel$export(module.exports, "q", function () { return $31f4445e1a7a95b7$export$9e5f44173e64f162; });
$parcel$export(module.exports, "t", function () { return $31f4445e1a7a95b7$export$625550452a3fa3ec; });
$parcel$export(module.exports, "v", function () { return $31f4445e1a7a95b7$export$90a7f3efeed30595; });
$parcel$export(module.exports, "w", function () { return $31f4445e1a7a95b7$export$efccba1c4a2ef57b; });
$parcel$export(module.exports, "x", function () { return $31f4445e1a7a95b7$export$d141bba7fdc215a3; });
$parcel$export(module.exports, "c", function () { return $31f4445e1a7a95b7$export$db3b6bfb95261072; });
$parcel$export(module.exports, "F", function () { return $31f4445e1a7a95b7$export$d66501df72047452; });

var $k5N0O = parcelRequire("k5N0O");

var $fBUaU = parcelRequire("fBUaU");

var $2ZUkg = parcelRequire("2ZUkg");

var $9yUBC = parcelRequire("9yUBC");

var $h57BE = parcelRequire("h57BE");

var $hFz8f = parcelRequire("hFz8f");

var $5kd3B = parcelRequire("5kd3B");

var $1K5Eh = parcelRequire("1K5Eh");

var $iSvIT = parcelRequire("iSvIT");

var $i5UxU = parcelRequire("i5UxU");

var $24DUy = parcelRequire("24DUy");

var $3fOxZ = parcelRequire("3fOxZ");
var $31f4445e1a7a95b7$var$_excluded$4 = [
    "className",
    "clearValue",
    "cx",
    "getStyles",
    "getClassNames",
    "getValue",
    "hasValue",
    "isMulti",
    "isRtl",
    "options",
    "selectOption",
    "selectProps",
    "setValue",
    "theme"
];
// ==============================
// NO OP
// ==============================
var $31f4445e1a7a95b7$export$b4171a6734a65d42 = function noop() {};
// ==============================
// Class Name Prefixer
// ==============================
/**
 String representation of component state for styling with class names.

 Expects an array of strings OR a string/object pair:
 - className(['comp', 'comp-arg', 'comp-arg-2'])
   @returns 'react-select__comp react-select__comp-arg react-select__comp-arg-2'
 - className('comp', { some: true, state: false })
   @returns 'react-select__comp react-select__comp--some'
*/ function $31f4445e1a7a95b7$var$applyPrefixToName(prefix, name) {
    if (!name) return prefix;
    else if (name[0] === "-") return prefix + name;
    else return prefix + "__" + name;
}
function $31f4445e1a7a95b7$export$a9c23c6ac3fc3eca(prefix, state) {
    for(var _len = arguments.length, classNameList = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)classNameList[_key - 2] = arguments[_key];
    var arr = [].concat(classNameList);
    if (state && prefix) {
        for(var key in state)if (state.hasOwnProperty(key) && state[key]) arr.push("".concat($31f4445e1a7a95b7$var$applyPrefixToName(prefix, key)));
    }
    return arr.filter(function(i) {
        return i;
    }).map(function(i) {
        return String(i).trim();
    }).join(" ");
}
// ==============================
// Clean Value
// ==============================
var $31f4445e1a7a95b7$export$7f8ddf7c7c20b3cd = function cleanValue(value) {
    if ($31f4445e1a7a95b7$var$isArray(value)) return value.filter(Boolean);
    if ((0, $hFz8f.default)(value) === "object" && value !== null) return [
        value
    ];
    return [];
};
// ==============================
// Clean Common Props
// ==============================
var $31f4445e1a7a95b7$var$cleanCommonProps = function cleanCommonProps(props) {
    //className
    props.className;
    props.clearValue;
    props.cx;
    props.getStyles;
    props.getClassNames;
    props.getValue;
    props.hasValue;
    props.isMulti;
    props.isRtl;
    props.options;
    props.selectOption;
    props.selectProps;
    props.setValue;
    props.theme;
    var innerProps = (0, $h57BE.default)(props, $31f4445e1a7a95b7$var$_excluded$4);
    return (0, $k5N0O.default)({}, innerProps);
};
// ==============================
// Get Style Props
// ==============================
var $31f4445e1a7a95b7$var$getStyleProps = function getStyleProps(props, name, classNamesState) {
    var cx = props.cx, getStyles = props.getStyles, getClassNames = props.getClassNames, className = props.className;
    return {
        css: getStyles(name, props),
        className: cx(classNamesState !== null && classNamesState !== void 0 ? classNamesState : {}, getClassNames(name, props), className)
    };
};
// ==============================
// Handle Input Change
// ==============================
function $31f4445e1a7a95b7$export$61196ced6d74a310(inputValue, actionMeta, onInputChange) {
    if (onInputChange) {
        var _newValue = onInputChange(inputValue, actionMeta);
        if (typeof _newValue === "string") return _newValue;
    }
    return inputValue;
}
// ==============================
// Scroll Helpers
// ==============================
function $31f4445e1a7a95b7$export$2329c99376c9d0a4(el) {
    return [
        document.documentElement,
        document.body,
        window
    ].indexOf(el) > -1;
}
// Normalized Scroll Top
// ------------------------------
function $31f4445e1a7a95b7$var$normalizedHeight(el) {
    if ($31f4445e1a7a95b7$export$2329c99376c9d0a4(el)) return window.innerHeight;
    return el.clientHeight;
}
// Normalized scrollTo & scrollTop
// ------------------------------
function $31f4445e1a7a95b7$var$getScrollTop(el) {
    if ($31f4445e1a7a95b7$export$2329c99376c9d0a4(el)) return window.pageYOffset;
    return el.scrollTop;
}
function $31f4445e1a7a95b7$var$scrollTo(el, top) {
    // with a scroll distance, we perform scroll on the element
    if ($31f4445e1a7a95b7$export$2329c99376c9d0a4(el)) {
        window.scrollTo(0, top);
        return;
    }
    el.scrollTop = top;
}
// Get Scroll Parent
// ------------------------------
function $31f4445e1a7a95b7$var$getScrollParent(element) {
    var style = getComputedStyle(element);
    var excludeStaticParent = style.position === "absolute";
    var overflowRx = /(auto|scroll)/;
    if (style.position === "fixed") return document.documentElement;
    for(var parent = element; parent = parent.parentElement;){
        style = getComputedStyle(parent);
        if (excludeStaticParent && style.position === "static") continue;
        if (overflowRx.test(style.overflow + style.overflowY + style.overflowX)) return parent;
    }
    return document.documentElement;
}
// Animated Scroll To
// ------------------------------
/**
  @param t: time (elapsed)
  @param b: initial value
  @param c: amount of change
  @param d: duration
*/ function $31f4445e1a7a95b7$var$easeOutCubic(t, b, c, d) {
    return c * ((t = t / d - 1) * t * t + 1) + b;
}
function $31f4445e1a7a95b7$var$animatedScrollTo(element, to) {
    var duration = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 200;
    var callback = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : $31f4445e1a7a95b7$export$b4171a6734a65d42;
    var start = $31f4445e1a7a95b7$var$getScrollTop(element);
    var change = to - start;
    var increment = 10;
    var currentTime = 0;
    function animateScroll() {
        currentTime += increment;
        var val = $31f4445e1a7a95b7$var$easeOutCubic(currentTime, start, change, duration);
        $31f4445e1a7a95b7$var$scrollTo(element, val);
        if (currentTime < duration) window.requestAnimationFrame(animateScroll);
        else callback(element);
    }
    animateScroll();
}
// Scroll Into View
// ------------------------------
function $31f4445e1a7a95b7$export$9bb611d729802a56(menuEl, focusedEl) {
    var menuRect = menuEl.getBoundingClientRect();
    var focusedRect = focusedEl.getBoundingClientRect();
    var overScroll = focusedEl.offsetHeight / 3;
    if (focusedRect.bottom + overScroll > menuRect.bottom) $31f4445e1a7a95b7$var$scrollTo(menuEl, Math.min(focusedEl.offsetTop + focusedEl.clientHeight - menuEl.offsetHeight + overScroll, menuEl.scrollHeight));
    else if (focusedRect.top - overScroll < menuRect.top) $31f4445e1a7a95b7$var$scrollTo(menuEl, Math.max(focusedEl.offsetTop - overScroll, 0));
}
// ==============================
// Get bounding client object
// ==============================
// cannot get keys using array notation with DOMRect
function $31f4445e1a7a95b7$var$getBoundingClientObj(element) {
    var rect = element.getBoundingClientRect();
    return {
        bottom: rect.bottom,
        height: rect.height,
        left: rect.left,
        right: rect.right,
        top: rect.top,
        width: rect.width
    };
}
// ==============================
// Touch Capability Detector
// ==============================
function $31f4445e1a7a95b7$export$df995fae86a55f06() {
    try {
        document.createEvent("TouchEvent");
        return true;
    } catch (e) {
        return false;
    }
}
// ==============================
// Mobile Device Detector
// ==============================
function $31f4445e1a7a95b7$export$ebd11618f299a286() {
    try {
        return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    } catch (e) {
        return false;
    }
}
// ==============================
// Passive Event Detector
// ==============================
// https://github.com/rafgraph/detect-it/blob/main/src/index.ts#L19-L36
var $31f4445e1a7a95b7$var$passiveOptionAccessed = false;
var $31f4445e1a7a95b7$var$options = {
    get passive () {
        return $31f4445e1a7a95b7$var$passiveOptionAccessed = true;
    }
};
// check for SSR
var $31f4445e1a7a95b7$var$w = typeof window !== "undefined" ? window : {};
if ($31f4445e1a7a95b7$var$w.addEventListener && $31f4445e1a7a95b7$var$w.removeEventListener) {
    $31f4445e1a7a95b7$var$w.addEventListener("p", $31f4445e1a7a95b7$export$b4171a6734a65d42, $31f4445e1a7a95b7$var$options);
    $31f4445e1a7a95b7$var$w.removeEventListener("p", $31f4445e1a7a95b7$export$b4171a6734a65d42, false);
}
var $31f4445e1a7a95b7$export$2408f22a0fab9ae5 = $31f4445e1a7a95b7$var$passiveOptionAccessed;
function $31f4445e1a7a95b7$export$3466f893ebf79586(item) {
    return item != null;
}
function $31f4445e1a7a95b7$var$isArray(arg) {
    return Array.isArray(arg);
}
function $31f4445e1a7a95b7$export$96f57966bedc81b4(isMulti, multiValue, singleValue) {
    return isMulti ? multiValue : singleValue;
}
function $31f4445e1a7a95b7$export$e7094788287c5e9b(singleValue) {
    return singleValue;
}
function $31f4445e1a7a95b7$export$ef35774e6d314e91(multiValue) {
    return multiValue;
}
var $31f4445e1a7a95b7$export$43caf9889c228507 = function removeProps(propsObj) {
    for(var _len2 = arguments.length, properties = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)properties[_key2 - 1] = arguments[_key2];
    var propsMap = Object.entries(propsObj).filter(function(_ref) {
        var _ref2 = (0, $9yUBC.default)(_ref, 1), key = _ref2[0];
        return !properties.includes(key);
    });
    return propsMap.reduce(function(newProps, _ref3) {
        var _ref4 = (0, $9yUBC.default)(_ref3, 2), key = _ref4[0], val = _ref4[1];
        newProps[key] = val;
        return newProps;
    }, {});
};
var $31f4445e1a7a95b7$var$_excluded$3 = [
    "children",
    "innerProps"
], $31f4445e1a7a95b7$var$_excluded2$1 = [
    "children",
    "innerProps"
];
function $31f4445e1a7a95b7$var$getMenuPlacement(_ref) {
    var preferredMaxHeight = _ref.maxHeight, menuEl = _ref.menuEl, minHeight = _ref.minHeight, preferredPlacement = _ref.placement, shouldScroll = _ref.shouldScroll, isFixedPosition = _ref.isFixedPosition, controlHeight = _ref.controlHeight;
    var scrollParent = $31f4445e1a7a95b7$var$getScrollParent(menuEl);
    var defaultState = {
        placement: "bottom",
        maxHeight: preferredMaxHeight
    };
    // something went wrong, return default state
    if (!menuEl || !menuEl.offsetParent) return defaultState;
    // we can't trust `scrollParent.scrollHeight` --> it may increase when
    // the menu is rendered
    var _scrollParent$getBoun = scrollParent.getBoundingClientRect(), scrollHeight = _scrollParent$getBoun.height;
    var _menuEl$getBoundingCl = menuEl.getBoundingClientRect(), menuBottom = _menuEl$getBoundingCl.bottom, menuHeight = _menuEl$getBoundingCl.height, menuTop = _menuEl$getBoundingCl.top;
    var _menuEl$offsetParent$ = menuEl.offsetParent.getBoundingClientRect(), containerTop = _menuEl$offsetParent$.top;
    var viewHeight = isFixedPosition ? window.innerHeight : $31f4445e1a7a95b7$var$normalizedHeight(scrollParent);
    var scrollTop = $31f4445e1a7a95b7$var$getScrollTop(scrollParent);
    var marginBottom = parseInt(getComputedStyle(menuEl).marginBottom, 10);
    var marginTop = parseInt(getComputedStyle(menuEl).marginTop, 10);
    var viewSpaceAbove = containerTop - marginTop;
    var viewSpaceBelow = viewHeight - menuTop;
    var scrollSpaceAbove = viewSpaceAbove + scrollTop;
    var scrollSpaceBelow = scrollHeight - scrollTop - menuTop;
    var scrollDown = menuBottom - viewHeight + scrollTop + marginBottom;
    var scrollUp = scrollTop + menuTop - marginTop;
    var scrollDuration = 160;
    switch(preferredPlacement){
        case "auto":
        case "bottom":
            // 1: the menu will fit, do nothing
            if (viewSpaceBelow >= menuHeight) return {
                placement: "bottom",
                maxHeight: preferredMaxHeight
            };
            // 2: the menu will fit, if scrolled
            if (scrollSpaceBelow >= menuHeight && !isFixedPosition) {
                if (shouldScroll) $31f4445e1a7a95b7$var$animatedScrollTo(scrollParent, scrollDown, scrollDuration);
                return {
                    placement: "bottom",
                    maxHeight: preferredMaxHeight
                };
            }
            // 3: the menu will fit, if constrained
            if (!isFixedPosition && scrollSpaceBelow >= minHeight || isFixedPosition && viewSpaceBelow >= minHeight) {
                if (shouldScroll) $31f4445e1a7a95b7$var$animatedScrollTo(scrollParent, scrollDown, scrollDuration);
                // we want to provide as much of the menu as possible to the user,
                // so give them whatever is available below rather than the minHeight.
                var constrainedHeight = isFixedPosition ? viewSpaceBelow - marginBottom : scrollSpaceBelow - marginBottom;
                return {
                    placement: "bottom",
                    maxHeight: constrainedHeight
                };
            }
            // 4. Forked beviour when there isn't enough space below
            // AUTO: flip the menu, render above
            if (preferredPlacement === "auto" || isFixedPosition) {
                // may need to be constrained after flipping
                var _constrainedHeight = preferredMaxHeight;
                var spaceAbove = isFixedPosition ? viewSpaceAbove : scrollSpaceAbove;
                if (spaceAbove >= minHeight) _constrainedHeight = Math.min(spaceAbove - marginBottom - controlHeight, preferredMaxHeight);
                return {
                    placement: "top",
                    maxHeight: _constrainedHeight
                };
            }
            // BOTTOM: allow browser to increase scrollable area and immediately set scroll
            if (preferredPlacement === "bottom") {
                if (shouldScroll) $31f4445e1a7a95b7$var$scrollTo(scrollParent, scrollDown);
                return {
                    placement: "bottom",
                    maxHeight: preferredMaxHeight
                };
            }
            break;
        case "top":
            // 1: the menu will fit, do nothing
            if (viewSpaceAbove >= menuHeight) return {
                placement: "top",
                maxHeight: preferredMaxHeight
            };
            // 2: the menu will fit, if scrolled
            if (scrollSpaceAbove >= menuHeight && !isFixedPosition) {
                if (shouldScroll) $31f4445e1a7a95b7$var$animatedScrollTo(scrollParent, scrollUp, scrollDuration);
                return {
                    placement: "top",
                    maxHeight: preferredMaxHeight
                };
            }
            // 3: the menu will fit, if constrained
            if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) {
                var _constrainedHeight2 = preferredMaxHeight;
                // we want to provide as much of the menu as possible to the user,
                // so give them whatever is available below rather than the minHeight.
                if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) _constrainedHeight2 = isFixedPosition ? viewSpaceAbove - marginTop : scrollSpaceAbove - marginTop;
                if (shouldScroll) $31f4445e1a7a95b7$var$animatedScrollTo(scrollParent, scrollUp, scrollDuration);
                return {
                    placement: "top",
                    maxHeight: _constrainedHeight2
                };
            }
            // 4. not enough space, the browser WILL NOT increase scrollable area when
            // absolutely positioned element rendered above the viewport (only below).
            // Flip the menu, render below
            return {
                placement: "bottom",
                maxHeight: preferredMaxHeight
            };
        default:
            throw new Error('Invalid placement provided "'.concat(preferredPlacement, '".'));
    }
    return defaultState;
}
// Menu Component
// ------------------------------
function $31f4445e1a7a95b7$var$alignToControl(placement) {
    var placementToCSSProp = {
        bottom: "top",
        top: "bottom"
    };
    return placement ? placementToCSSProp[placement] : "bottom";
}
var $31f4445e1a7a95b7$var$coercePlacement = function coercePlacement(p) {
    return p === "auto" ? "bottom" : p;
};
var $31f4445e1a7a95b7$export$953cecd6e717a553 = function menuCSS(_ref2, unstyled) {
    var _objectSpread2;
    var placement = _ref2.placement, _ref2$theme = _ref2.theme, borderRadius = _ref2$theme.borderRadius, spacing = _ref2$theme.spacing, colors = _ref2$theme.colors;
    return (0, $k5N0O.default)((_objectSpread2 = {
        label: "menu"
    }, (0, $1K5Eh.default)(_objectSpread2, $31f4445e1a7a95b7$var$alignToControl(placement), "100%"), (0, $1K5Eh.default)(_objectSpread2, "position", "absolute"), (0, $1K5Eh.default)(_objectSpread2, "width", "100%"), (0, $1K5Eh.default)(_objectSpread2, "zIndex", 1), _objectSpread2), unstyled ? {} : {
        backgroundColor: colors.neutral0,
        borderRadius: borderRadius,
        boxShadow: "0 0 0 1px hsla(0, 0%, 0%, 0.1), 0 4px 11px hsla(0, 0%, 0%, 0.1)",
        marginBottom: spacing.menuGutter,
        marginTop: spacing.menuGutter
    });
};
var $31f4445e1a7a95b7$var$PortalPlacementContext = /*#__PURE__*/ (0, $iSvIT.createContext)(null);
// NOTE: internal only
var $31f4445e1a7a95b7$export$3a1a48c8f6ef640e = function MenuPlacer(props) {
    var children = props.children, minMenuHeight = props.minMenuHeight, maxMenuHeight = props.maxMenuHeight, menuPlacement = props.menuPlacement, menuPosition = props.menuPosition, menuShouldScrollIntoView = props.menuShouldScrollIntoView, theme = props.theme;
    var _ref3 = (0, $iSvIT.useContext)($31f4445e1a7a95b7$var$PortalPlacementContext) || {}, setPortalPlacement = _ref3.setPortalPlacement;
    var ref = (0, $iSvIT.useRef)(null);
    var _useState = (0, $iSvIT.useState)(maxMenuHeight), _useState2 = (0, $9yUBC.default)(_useState, 2), maxHeight = _useState2[0], setMaxHeight = _useState2[1];
    var _useState3 = (0, $iSvIT.useState)(null), _useState4 = (0, $9yUBC.default)(_useState3, 2), placement = _useState4[0], setPlacement = _useState4[1];
    var controlHeight = theme.spacing.controlHeight;
    (0, $3fOxZ.default)(function() {
        var menuEl = ref.current;
        if (!menuEl) return;
        // DO NOT scroll if position is fixed
        var isFixedPosition = menuPosition === "fixed";
        var shouldScroll = menuShouldScrollIntoView && !isFixedPosition;
        var state = $31f4445e1a7a95b7$var$getMenuPlacement({
            maxHeight: maxMenuHeight,
            menuEl: menuEl,
            minHeight: minMenuHeight,
            placement: menuPlacement,
            shouldScroll: shouldScroll,
            isFixedPosition: isFixedPosition,
            controlHeight: controlHeight
        });
        setMaxHeight(state.maxHeight);
        setPlacement(state.placement);
        setPortalPlacement === null || setPortalPlacement === void 0 || setPortalPlacement(state.placement);
    }, [
        maxMenuHeight,
        menuPlacement,
        menuPosition,
        menuShouldScrollIntoView,
        minMenuHeight,
        setPortalPlacement,
        controlHeight
    ]);
    return children({
        ref: ref,
        placerProps: (0, $k5N0O.default)((0, $k5N0O.default)({}, props), {}, {
            placement: placement || $31f4445e1a7a95b7$var$coercePlacement(menuPlacement),
            maxHeight: maxHeight
        })
    });
};
var $31f4445e1a7a95b7$var$Menu = function Menu(props) {
    var children = props.children, innerRef = props.innerRef, innerProps = props.innerProps;
    return (0, $2ZUkg.jsx)("div", (0, $fBUaU.default)({}, $31f4445e1a7a95b7$var$getStyleProps(props, "menu", {
        menu: true
    }), {
        ref: innerRef
    }, innerProps), children);
};
var $31f4445e1a7a95b7$var$Menu$1 = $31f4445e1a7a95b7$var$Menu;
// ==============================
// Menu List
// ==============================
var $31f4445e1a7a95b7$export$7ccc53e8f1e7dfc5 = function menuListCSS(_ref4, unstyled) {
    var maxHeight = _ref4.maxHeight, baseUnit = _ref4.theme.spacing.baseUnit;
    return (0, $k5N0O.default)({
        maxHeight: maxHeight,
        overflowY: "auto",
        position: "relative",
        // required for offset[Height, Top] > keyboard scroll
        WebkitOverflowScrolling: "touch"
    }, unstyled ? {} : {
        paddingBottom: baseUnit,
        paddingTop: baseUnit
    });
};
var $31f4445e1a7a95b7$var$MenuList = function MenuList(props) {
    var children = props.children, innerProps = props.innerProps, innerRef = props.innerRef, isMulti = props.isMulti;
    return (0, $2ZUkg.jsx)("div", (0, $fBUaU.default)({}, $31f4445e1a7a95b7$var$getStyleProps(props, "menuList", {
        "menu-list": true,
        "menu-list--is-multi": isMulti
    }), {
        ref: innerRef
    }, innerProps), children);
};
// ==============================
// Menu Notices
// ==============================
var $31f4445e1a7a95b7$var$noticeCSS = function noticeCSS(_ref5, unstyled) {
    var _ref5$theme = _ref5.theme, baseUnit = _ref5$theme.spacing.baseUnit, colors = _ref5$theme.colors;
    return (0, $k5N0O.default)({
        textAlign: "center"
    }, unstyled ? {} : {
        color: colors.neutral40,
        padding: "".concat(baseUnit * 2, "px ").concat(baseUnit * 3, "px")
    });
};
var $31f4445e1a7a95b7$export$3b14a55fb2447963 = $31f4445e1a7a95b7$var$noticeCSS;
var $31f4445e1a7a95b7$export$342063e11d6c3cad = $31f4445e1a7a95b7$var$noticeCSS;
var $31f4445e1a7a95b7$var$NoOptionsMessage = function NoOptionsMessage(_ref6) {
    var _ref6$children = _ref6.children, children = _ref6$children === void 0 ? "No options" : _ref6$children, innerProps = _ref6.innerProps, restProps = (0, $h57BE.default)(_ref6, $31f4445e1a7a95b7$var$_excluded$3);
    return (0, $2ZUkg.jsx)("div", (0, $fBUaU.default)({}, $31f4445e1a7a95b7$var$getStyleProps((0, $k5N0O.default)((0, $k5N0O.default)({}, restProps), {}, {
        children: children,
        innerProps: innerProps
    }), "noOptionsMessage", {
        "menu-notice": true,
        "menu-notice--no-options": true
    }), innerProps), children);
};
var $31f4445e1a7a95b7$var$LoadingMessage = function LoadingMessage(_ref7) {
    var _ref7$children = _ref7.children, children = _ref7$children === void 0 ? "Loading..." : _ref7$children, innerProps = _ref7.innerProps, restProps = (0, $h57BE.default)(_ref7, $31f4445e1a7a95b7$var$_excluded2$1);
    return (0, $2ZUkg.jsx)("div", (0, $fBUaU.default)({}, $31f4445e1a7a95b7$var$getStyleProps((0, $k5N0O.default)((0, $k5N0O.default)({}, restProps), {}, {
        children: children,
        innerProps: innerProps
    }), "loadingMessage", {
        "menu-notice": true,
        "menu-notice--loading": true
    }), innerProps), children);
};
// ==============================
// Menu Portal
// ==============================
var $31f4445e1a7a95b7$export$ae1af26003f05816 = function menuPortalCSS(_ref8) {
    var rect = _ref8.rect, offset = _ref8.offset, position = _ref8.position;
    return {
        left: rect.left,
        position: position,
        top: offset,
        width: rect.width,
        zIndex: 1
    };
};
var $31f4445e1a7a95b7$var$MenuPortal = function MenuPortal(props) {
    var appendTo = props.appendTo, children = props.children, controlElement = props.controlElement, innerProps = props.innerProps, menuPlacement = props.menuPlacement, menuPosition = props.menuPosition;
    var menuPortalRef = (0, $iSvIT.useRef)(null);
    var cleanupRef = (0, $iSvIT.useRef)(null);
    var _useState5 = (0, $iSvIT.useState)($31f4445e1a7a95b7$var$coercePlacement(menuPlacement)), _useState6 = (0, $9yUBC.default)(_useState5, 2), placement = _useState6[0], setPortalPlacement = _useState6[1];
    var portalPlacementContext = (0, $iSvIT.useMemo)(function() {
        return {
            setPortalPlacement: setPortalPlacement
        };
    }, []);
    var _useState7 = (0, $iSvIT.useState)(null), _useState8 = (0, $9yUBC.default)(_useState7, 2), computedPosition = _useState8[0], setComputedPosition = _useState8[1];
    var updateComputedPosition = (0, $iSvIT.useCallback)(function() {
        if (!controlElement) return;
        var rect = $31f4445e1a7a95b7$var$getBoundingClientObj(controlElement);
        var scrollDistance = menuPosition === "fixed" ? 0 : window.pageYOffset;
        var offset = rect[placement] + scrollDistance;
        if (offset !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.offset) || rect.left !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.left) || rect.width !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.width)) setComputedPosition({
            offset: offset,
            rect: rect
        });
    }, [
        controlElement,
        menuPosition,
        placement,
        computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.offset,
        computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.left,
        computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.width
    ]);
    (0, $3fOxZ.default)(function() {
        updateComputedPosition();
    }, [
        updateComputedPosition
    ]);
    var runAutoUpdate = (0, $iSvIT.useCallback)(function() {
        if (typeof cleanupRef.current === "function") {
            cleanupRef.current();
            cleanupRef.current = null;
        }
        if (controlElement && menuPortalRef.current) cleanupRef.current = (0, $24DUy.autoUpdate)(controlElement, menuPortalRef.current, updateComputedPosition, {
            elementResize: "ResizeObserver" in window
        });
    }, [
        controlElement,
        updateComputedPosition
    ]);
    (0, $3fOxZ.default)(function() {
        runAutoUpdate();
    }, [
        runAutoUpdate
    ]);
    var setMenuPortalElement = (0, $iSvIT.useCallback)(function(menuPortalElement) {
        menuPortalRef.current = menuPortalElement;
        runAutoUpdate();
    }, [
        runAutoUpdate
    ]);
    // bail early if required elements aren't present
    if (!appendTo && menuPosition !== "fixed" || !computedPosition) return null;
    // same wrapper element whether fixed or portalled
    var menuWrapper = (0, $2ZUkg.jsx)("div", (0, $fBUaU.default)({
        ref: setMenuPortalElement
    }, $31f4445e1a7a95b7$var$getStyleProps((0, $k5N0O.default)((0, $k5N0O.default)({}, props), {}, {
        offset: computedPosition.offset,
        position: menuPosition,
        rect: computedPosition.rect
    }), "menuPortal", {
        "menu-portal": true
    }), innerProps), children);
    return (0, $2ZUkg.jsx)($31f4445e1a7a95b7$var$PortalPlacementContext.Provider, {
        value: portalPlacementContext
    }, appendTo ? /*#__PURE__*/ (0, $i5UxU.createPortal)(menuWrapper, appendTo) : menuWrapper);
};
// ==============================
// Root Container
// ==============================
var $31f4445e1a7a95b7$export$8b22cf2602fb60ce = function containerCSS(_ref) {
    var isDisabled = _ref.isDisabled, isRtl = _ref.isRtl;
    return {
        label: "container",
        direction: isRtl ? "rtl" : undefined,
        pointerEvents: isDisabled ? "none" : undefined,
        // cancel mouse events when disabled
        position: "relative"
    };
};
var $31f4445e1a7a95b7$var$SelectContainer = function SelectContainer(props) {
    var children = props.children, innerProps = props.innerProps, isDisabled = props.isDisabled, isRtl = props.isRtl;
    return (0, $2ZUkg.jsx)("div", (0, $fBUaU.default)({}, $31f4445e1a7a95b7$var$getStyleProps(props, "container", {
        "--is-disabled": isDisabled,
        "--is-rtl": isRtl
    }), innerProps), children);
};
// ==============================
// Value Container
// ==============================
var $31f4445e1a7a95b7$export$4a5767248b18ef41 = function valueContainerCSS(_ref2, unstyled) {
    var spacing = _ref2.theme.spacing, isMulti = _ref2.isMulti, hasValue = _ref2.hasValue, controlShouldRenderValue = _ref2.selectProps.controlShouldRenderValue;
    return (0, $k5N0O.default)({
        alignItems: "center",
        display: isMulti && hasValue && controlShouldRenderValue ? "flex" : "grid",
        flex: 1,
        flexWrap: "wrap",
        WebkitOverflowScrolling: "touch",
        position: "relative",
        overflow: "hidden"
    }, unstyled ? {} : {
        padding: "".concat(spacing.baseUnit / 2, "px ").concat(spacing.baseUnit * 2, "px")
    });
};
var $31f4445e1a7a95b7$var$ValueContainer = function ValueContainer(props) {
    var children = props.children, innerProps = props.innerProps, isMulti = props.isMulti, hasValue = props.hasValue;
    return (0, $2ZUkg.jsx)("div", (0, $fBUaU.default)({}, $31f4445e1a7a95b7$var$getStyleProps(props, "valueContainer", {
        "value-container": true,
        "value-container--is-multi": isMulti,
        "value-container--has-value": hasValue
    }), innerProps), children);
};
// ==============================
// Indicator Container
// ==============================
var $31f4445e1a7a95b7$export$23f2a1d2818174ef = function indicatorsContainerCSS() {
    return {
        alignItems: "center",
        alignSelf: "stretch",
        display: "flex",
        flexShrink: 0
    };
};
var $31f4445e1a7a95b7$var$IndicatorsContainer = function IndicatorsContainer(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, $2ZUkg.jsx)("div", (0, $fBUaU.default)({}, $31f4445e1a7a95b7$var$getStyleProps(props, "indicatorsContainer", {
        indicators: true
    }), innerProps), children);
};
var $31f4445e1a7a95b7$var$_templateObject;
var $31f4445e1a7a95b7$var$_excluded$2 = [
    "size"
], $31f4445e1a7a95b7$var$_excluded2 = [
    "innerProps",
    "isRtl",
    "size"
];
function $31f4445e1a7a95b7$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// ==============================
// Dropdown & Clear Icons
// ==============================
var $31f4445e1a7a95b7$var$_ref2 = {
    name: "8mmkcg",
    styles: "display:inline-block;fill:currentColor;line-height:1;stroke:currentColor;stroke-width:0"
};
var $31f4445e1a7a95b7$var$Svg = function Svg(_ref) {
    var size = _ref.size, props = (0, $h57BE.default)(_ref, $31f4445e1a7a95b7$var$_excluded$2);
    return (0, $2ZUkg.jsx)("svg", (0, $fBUaU.default)({
        height: size,
        width: size,
        viewBox: "0 0 20 20",
        "aria-hidden": "true",
        focusable: "false",
        css: $31f4445e1a7a95b7$var$_ref2
    }, props));
};
var $31f4445e1a7a95b7$var$CrossIcon = function CrossIcon(props) {
    return (0, $2ZUkg.jsx)($31f4445e1a7a95b7$var$Svg, (0, $fBUaU.default)({
        size: 20
    }, props), (0, $2ZUkg.jsx)("path", {
        d: "M14.348 14.849c-0.469 0.469-1.229 0.469-1.697 0l-2.651-3.030-2.651 3.029c-0.469 0.469-1.229 0.469-1.697 0-0.469-0.469-0.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-0.469-0.469-0.469-1.228 0-1.697s1.228-0.469 1.697 0l2.652 3.031 2.651-3.031c0.469-0.469 1.228-0.469 1.697 0s0.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c0.469 0.469 0.469 1.229 0 1.698z"
    }));
};
var $31f4445e1a7a95b7$var$DownChevron = function DownChevron(props) {
    return (0, $2ZUkg.jsx)($31f4445e1a7a95b7$var$Svg, (0, $fBUaU.default)({
        size: 20
    }, props), (0, $2ZUkg.jsx)("path", {
        d: "M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"
    }));
};
// ==============================
// Dropdown & Clear Buttons
// ==============================
var $31f4445e1a7a95b7$var$baseCSS = function baseCSS(_ref3, unstyled) {
    var isFocused = _ref3.isFocused, _ref3$theme = _ref3.theme, baseUnit = _ref3$theme.spacing.baseUnit, colors = _ref3$theme.colors;
    return (0, $k5N0O.default)({
        label: "indicatorContainer",
        display: "flex",
        transition: "color 150ms"
    }, unstyled ? {} : {
        color: isFocused ? colors.neutral60 : colors.neutral20,
        padding: baseUnit * 2,
        ":hover": {
            color: isFocused ? colors.neutral80 : colors.neutral40
        }
    });
};
var $31f4445e1a7a95b7$export$f1e1789686576879 = $31f4445e1a7a95b7$var$baseCSS;
var $31f4445e1a7a95b7$var$DropdownIndicator = function DropdownIndicator(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, $2ZUkg.jsx)("div", (0, $fBUaU.default)({}, $31f4445e1a7a95b7$var$getStyleProps(props, "dropdownIndicator", {
        indicator: true,
        "dropdown-indicator": true
    }), innerProps), children || (0, $2ZUkg.jsx)($31f4445e1a7a95b7$var$DownChevron, null));
};
var $31f4445e1a7a95b7$export$407448d2b89b1813 = $31f4445e1a7a95b7$var$baseCSS;
var $31f4445e1a7a95b7$var$ClearIndicator = function ClearIndicator(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, $2ZUkg.jsx)("div", (0, $fBUaU.default)({}, $31f4445e1a7a95b7$var$getStyleProps(props, "clearIndicator", {
        indicator: true,
        "clear-indicator": true
    }), innerProps), children || (0, $2ZUkg.jsx)($31f4445e1a7a95b7$var$CrossIcon, null));
};
// ==============================
// Separator
// ==============================
var $31f4445e1a7a95b7$export$dda1d9f60106f0e9 = function indicatorSeparatorCSS(_ref4, unstyled) {
    var isDisabled = _ref4.isDisabled, _ref4$theme = _ref4.theme, baseUnit = _ref4$theme.spacing.baseUnit, colors = _ref4$theme.colors;
    return (0, $k5N0O.default)({
        label: "indicatorSeparator",
        alignSelf: "stretch",
        width: 1
    }, unstyled ? {} : {
        backgroundColor: isDisabled ? colors.neutral10 : colors.neutral20,
        marginBottom: baseUnit * 2,
        marginTop: baseUnit * 2
    });
};
var $31f4445e1a7a95b7$var$IndicatorSeparator = function IndicatorSeparator(props) {
    var innerProps = props.innerProps;
    return (0, $2ZUkg.jsx)("span", (0, $fBUaU.default)({}, innerProps, $31f4445e1a7a95b7$var$getStyleProps(props, "indicatorSeparator", {
        "indicator-separator": true
    })));
};
// ==============================
// Loading
// ==============================
var $31f4445e1a7a95b7$var$loadingDotAnimations = (0, $2ZUkg.keyframes)($31f4445e1a7a95b7$var$_templateObject || ($31f4445e1a7a95b7$var$_templateObject = (0, $5kd3B.default)([
    "\n  0%, 80%, 100% { opacity: 0; }\n  40% { opacity: 1; }\n"
])));
var $31f4445e1a7a95b7$export$882b5998b3b9117c = function loadingIndicatorCSS(_ref5, unstyled) {
    var isFocused = _ref5.isFocused, size = _ref5.size, _ref5$theme = _ref5.theme, colors = _ref5$theme.colors, baseUnit = _ref5$theme.spacing.baseUnit;
    return (0, $k5N0O.default)({
        label: "loadingIndicator",
        display: "flex",
        transition: "color 150ms",
        alignSelf: "center",
        fontSize: size,
        lineHeight: 1,
        marginRight: size,
        textAlign: "center",
        verticalAlign: "middle"
    }, unstyled ? {} : {
        color: isFocused ? colors.neutral60 : colors.neutral20,
        padding: baseUnit * 2
    });
};
var $31f4445e1a7a95b7$var$LoadingDot = function LoadingDot(_ref6) {
    var delay = _ref6.delay, offset = _ref6.offset;
    return (0, $2ZUkg.jsx)("span", {
        css: /*#__PURE__*/ (0, $2ZUkg.css)({
            animation: "".concat($31f4445e1a7a95b7$var$loadingDotAnimations, " 1s ease-in-out ").concat(delay, "ms infinite;"),
            backgroundColor: "currentColor",
            borderRadius: "1em",
            display: "inline-block",
            marginLeft: offset ? "1em" : undefined,
            height: "1em",
            verticalAlign: "top",
            width: "1em"
        }, "", "")
    });
};
var $31f4445e1a7a95b7$var$LoadingIndicator = function LoadingIndicator(_ref7) {
    var innerProps = _ref7.innerProps, isRtl = _ref7.isRtl, _ref7$size = _ref7.size, size = _ref7$size === void 0 ? 4 : _ref7$size, restProps = (0, $h57BE.default)(_ref7, $31f4445e1a7a95b7$var$_excluded2);
    return (0, $2ZUkg.jsx)("div", (0, $fBUaU.default)({}, $31f4445e1a7a95b7$var$getStyleProps((0, $k5N0O.default)((0, $k5N0O.default)({}, restProps), {}, {
        innerProps: innerProps,
        isRtl: isRtl,
        size: size
    }), "loadingIndicator", {
        indicator: true,
        "loading-indicator": true
    }), innerProps), (0, $2ZUkg.jsx)($31f4445e1a7a95b7$var$LoadingDot, {
        delay: 0,
        offset: isRtl
    }), (0, $2ZUkg.jsx)($31f4445e1a7a95b7$var$LoadingDot, {
        delay: 160,
        offset: true
    }), (0, $2ZUkg.jsx)($31f4445e1a7a95b7$var$LoadingDot, {
        delay: 320,
        offset: !isRtl
    }));
};
var $31f4445e1a7a95b7$export$4368d992c4eafac0 = function css(_ref, unstyled) {
    var isDisabled = _ref.isDisabled, isFocused = _ref.isFocused, _ref$theme = _ref.theme, colors = _ref$theme.colors, borderRadius = _ref$theme.borderRadius, spacing = _ref$theme.spacing;
    return (0, $k5N0O.default)({
        label: "control",
        alignItems: "center",
        cursor: "default",
        display: "flex",
        flexWrap: "wrap",
        justifyContent: "space-between",
        minHeight: spacing.controlHeight,
        outline: "0 !important",
        position: "relative",
        transition: "all 100ms"
    }, unstyled ? {} : {
        backgroundColor: isDisabled ? colors.neutral5 : colors.neutral0,
        borderColor: isDisabled ? colors.neutral10 : isFocused ? colors.primary : colors.neutral20,
        borderRadius: borderRadius,
        borderStyle: "solid",
        borderWidth: 1,
        boxShadow: isFocused ? "0 0 0 1px ".concat(colors.primary) : undefined,
        "&:hover": {
            borderColor: isFocused ? colors.primary : colors.neutral30
        }
    });
};
var $31f4445e1a7a95b7$var$Control = function Control(props) {
    var children = props.children, isDisabled = props.isDisabled, isFocused = props.isFocused, innerRef = props.innerRef, innerProps = props.innerProps, menuIsOpen = props.menuIsOpen;
    return (0, $2ZUkg.jsx)("div", (0, $fBUaU.default)({
        ref: innerRef
    }, $31f4445e1a7a95b7$var$getStyleProps(props, "control", {
        control: true,
        "control--is-disabled": isDisabled,
        "control--is-focused": isFocused,
        "control--menu-is-open": menuIsOpen
    }), innerProps, {
        "aria-disabled": isDisabled || undefined
    }), children);
};
var $31f4445e1a7a95b7$var$Control$1 = $31f4445e1a7a95b7$var$Control;
var $31f4445e1a7a95b7$var$_excluded$1 = [
    "data"
];
var $31f4445e1a7a95b7$export$39b482c5e57630a8 = function groupCSS(_ref, unstyled) {
    var spacing = _ref.theme.spacing;
    return unstyled ? {} : {
        paddingBottom: spacing.baseUnit * 2,
        paddingTop: spacing.baseUnit * 2
    };
};
var $31f4445e1a7a95b7$var$Group = function Group(props) {
    var children = props.children, cx = props.cx, getStyles = props.getStyles, getClassNames = props.getClassNames, Heading = props.Heading, headingProps = props.headingProps, innerProps = props.innerProps, label = props.label, theme = props.theme, selectProps = props.selectProps;
    return (0, $2ZUkg.jsx)("div", (0, $fBUaU.default)({}, $31f4445e1a7a95b7$var$getStyleProps(props, "group", {
        group: true
    }), innerProps), (0, $2ZUkg.jsx)(Heading, (0, $fBUaU.default)({}, headingProps, {
        selectProps: selectProps,
        theme: theme,
        getStyles: getStyles,
        getClassNames: getClassNames,
        cx: cx
    }), label), (0, $2ZUkg.jsx)("div", null, children));
};
var $31f4445e1a7a95b7$export$2d1720544b23b823 = function groupHeadingCSS(_ref2, unstyled) {
    var _ref2$theme = _ref2.theme, colors = _ref2$theme.colors, spacing = _ref2$theme.spacing;
    return (0, $k5N0O.default)({
        label: "group",
        cursor: "default",
        display: "block"
    }, unstyled ? {} : {
        color: colors.neutral40,
        fontSize: "75%",
        fontWeight: 500,
        marginBottom: "0.25em",
        paddingLeft: spacing.baseUnit * 3,
        paddingRight: spacing.baseUnit * 3,
        textTransform: "uppercase"
    });
};
var $31f4445e1a7a95b7$var$GroupHeading = function GroupHeading(props) {
    var _cleanCommonProps = $31f4445e1a7a95b7$var$cleanCommonProps(props);
    _cleanCommonProps.data;
    var innerProps = (0, $h57BE.default)(_cleanCommonProps, $31f4445e1a7a95b7$var$_excluded$1);
    return (0, $2ZUkg.jsx)("div", (0, $fBUaU.default)({}, $31f4445e1a7a95b7$var$getStyleProps(props, "groupHeading", {
        "group-heading": true
    }), innerProps));
};
var $31f4445e1a7a95b7$var$Group$1 = $31f4445e1a7a95b7$var$Group;
var $31f4445e1a7a95b7$var$_excluded = [
    "innerRef",
    "isDisabled",
    "isHidden",
    "inputClassName"
];
var $31f4445e1a7a95b7$export$35e795649ee09318 = function inputCSS(_ref, unstyled) {
    var isDisabled = _ref.isDisabled, value = _ref.value, _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return (0, $k5N0O.default)((0, $k5N0O.default)({
        visibility: isDisabled ? "hidden" : "visible",
        // force css to recompute when value change due to @emotion bug.
        // We can remove it whenever the bug is fixed.
        transform: value ? "translateZ(0)" : ""
    }, $31f4445e1a7a95b7$var$containerStyle), unstyled ? {} : {
        margin: spacing.baseUnit / 2,
        paddingBottom: spacing.baseUnit / 2,
        paddingTop: spacing.baseUnit / 2,
        color: colors.neutral80
    });
};
var $31f4445e1a7a95b7$var$spacingStyle = {
    gridArea: "1 / 2",
    font: "inherit",
    minWidth: "2px",
    border: 0,
    margin: 0,
    outline: 0,
    padding: 0
};
var $31f4445e1a7a95b7$var$containerStyle = {
    flex: "1 1 auto",
    display: "inline-grid",
    gridArea: "1 / 1 / 2 / 3",
    gridTemplateColumns: "0 min-content",
    "&:after": (0, $k5N0O.default)({
        content: 'attr(data-value) " "',
        visibility: "hidden",
        whiteSpace: "pre"
    }, $31f4445e1a7a95b7$var$spacingStyle)
};
var $31f4445e1a7a95b7$var$inputStyle = function inputStyle(isHidden) {
    return (0, $k5N0O.default)({
        label: "input",
        color: "inherit",
        background: 0,
        opacity: isHidden ? 0 : 1,
        width: "100%"
    }, $31f4445e1a7a95b7$var$spacingStyle);
};
var $31f4445e1a7a95b7$var$Input = function Input(props) {
    var cx = props.cx, value = props.value;
    var _cleanCommonProps = $31f4445e1a7a95b7$var$cleanCommonProps(props), innerRef = _cleanCommonProps.innerRef, isDisabled = _cleanCommonProps.isDisabled, isHidden = _cleanCommonProps.isHidden, inputClassName = _cleanCommonProps.inputClassName, innerProps = (0, $h57BE.default)(_cleanCommonProps, $31f4445e1a7a95b7$var$_excluded);
    return (0, $2ZUkg.jsx)("div", (0, $fBUaU.default)({}, $31f4445e1a7a95b7$var$getStyleProps(props, "input", {
        "input-container": true
    }), {
        "data-value": value || ""
    }), (0, $2ZUkg.jsx)("input", (0, $fBUaU.default)({
        className: cx({
            input: true
        }, inputClassName),
        ref: innerRef,
        style: $31f4445e1a7a95b7$var$inputStyle(isHidden),
        disabled: isDisabled
    }, innerProps)));
};
var $31f4445e1a7a95b7$var$Input$1 = $31f4445e1a7a95b7$var$Input;
var $31f4445e1a7a95b7$export$ffb5f4729a158638 = function multiValueCSS(_ref, unstyled) {
    var _ref$theme = _ref.theme, spacing = _ref$theme.spacing, borderRadius = _ref$theme.borderRadius, colors = _ref$theme.colors;
    return (0, $k5N0O.default)({
        label: "multiValue",
        display: "flex",
        minWidth: 0
    }, unstyled ? {} : {
        backgroundColor: colors.neutral10,
        borderRadius: borderRadius / 2,
        margin: spacing.baseUnit / 2
    });
};
var $31f4445e1a7a95b7$export$9e5f44173e64f162 = function multiValueLabelCSS(_ref2, unstyled) {
    var _ref2$theme = _ref2.theme, borderRadius = _ref2$theme.borderRadius, colors = _ref2$theme.colors, cropWithEllipsis = _ref2.cropWithEllipsis;
    return (0, $k5N0O.default)({
        overflow: "hidden",
        textOverflow: cropWithEllipsis || cropWithEllipsis === undefined ? "ellipsis" : undefined,
        whiteSpace: "nowrap"
    }, unstyled ? {} : {
        borderRadius: borderRadius / 2,
        color: colors.neutral80,
        fontSize: "85%",
        padding: 3,
        paddingLeft: 6
    });
};
var $31f4445e1a7a95b7$export$625550452a3fa3ec = function multiValueRemoveCSS(_ref3, unstyled) {
    var _ref3$theme = _ref3.theme, spacing = _ref3$theme.spacing, borderRadius = _ref3$theme.borderRadius, colors = _ref3$theme.colors, isFocused = _ref3.isFocused;
    return (0, $k5N0O.default)({
        alignItems: "center",
        display: "flex"
    }, unstyled ? {} : {
        borderRadius: borderRadius / 2,
        backgroundColor: isFocused ? colors.dangerLight : undefined,
        paddingLeft: spacing.baseUnit,
        paddingRight: spacing.baseUnit,
        ":hover": {
            backgroundColor: colors.dangerLight,
            color: colors.danger
        }
    });
};
var $31f4445e1a7a95b7$var$MultiValueGeneric = function MultiValueGeneric(_ref4) {
    var children = _ref4.children, innerProps = _ref4.innerProps;
    return (0, $2ZUkg.jsx)("div", innerProps, children);
};
var $31f4445e1a7a95b7$var$MultiValueContainer = $31f4445e1a7a95b7$var$MultiValueGeneric;
var $31f4445e1a7a95b7$var$MultiValueLabel = $31f4445e1a7a95b7$var$MultiValueGeneric;
function $31f4445e1a7a95b7$var$MultiValueRemove(_ref5) {
    var children = _ref5.children, innerProps = _ref5.innerProps;
    return (0, $2ZUkg.jsx)("div", (0, $fBUaU.default)({
        role: "button"
    }, innerProps), children || (0, $2ZUkg.jsx)($31f4445e1a7a95b7$var$CrossIcon, {
        size: 14
    }));
}
var $31f4445e1a7a95b7$var$MultiValue = function MultiValue(props) {
    var children = props.children, components = props.components, data = props.data, innerProps = props.innerProps, isDisabled = props.isDisabled, removeProps = props.removeProps, selectProps = props.selectProps;
    var Container = components.Container, Label = components.Label, Remove = components.Remove;
    return (0, $2ZUkg.jsx)(Container, {
        data: data,
        innerProps: (0, $k5N0O.default)((0, $k5N0O.default)({}, $31f4445e1a7a95b7$var$getStyleProps(props, "multiValue", {
            "multi-value": true,
            "multi-value--is-disabled": isDisabled
        })), innerProps),
        selectProps: selectProps
    }, (0, $2ZUkg.jsx)(Label, {
        data: data,
        innerProps: (0, $k5N0O.default)({}, $31f4445e1a7a95b7$var$getStyleProps(props, "multiValueLabel", {
            "multi-value__label": true
        })),
        selectProps: selectProps
    }, children), (0, $2ZUkg.jsx)(Remove, {
        data: data,
        innerProps: (0, $k5N0O.default)((0, $k5N0O.default)({}, $31f4445e1a7a95b7$var$getStyleProps(props, "multiValueRemove", {
            "multi-value__remove": true
        })), {}, {
            "aria-label": "Remove ".concat(children || "option")
        }, removeProps),
        selectProps: selectProps
    }));
};
var $31f4445e1a7a95b7$var$MultiValue$1 = $31f4445e1a7a95b7$var$MultiValue;
var $31f4445e1a7a95b7$export$90a7f3efeed30595 = function optionCSS(_ref, unstyled) {
    var isDisabled = _ref.isDisabled, isFocused = _ref.isFocused, isSelected = _ref.isSelected, _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return (0, $k5N0O.default)({
        label: "option",
        cursor: "default",
        display: "block",
        fontSize: "inherit",
        width: "100%",
        userSelect: "none",
        WebkitTapHighlightColor: "rgba(0, 0, 0, 0)"
    }, unstyled ? {} : {
        backgroundColor: isSelected ? colors.primary : isFocused ? colors.primary25 : "transparent",
        color: isDisabled ? colors.neutral20 : isSelected ? colors.neutral0 : "inherit",
        padding: "".concat(spacing.baseUnit * 2, "px ").concat(spacing.baseUnit * 3, "px"),
        // provide some affordance on touch devices
        ":active": {
            backgroundColor: !isDisabled ? isSelected ? colors.primary : colors.primary50 : undefined
        }
    });
};
var $31f4445e1a7a95b7$var$Option = function Option(props) {
    var children = props.children, isDisabled = props.isDisabled, isFocused = props.isFocused, isSelected = props.isSelected, innerRef = props.innerRef, innerProps = props.innerProps;
    return (0, $2ZUkg.jsx)("div", (0, $fBUaU.default)({}, $31f4445e1a7a95b7$var$getStyleProps(props, "option", {
        option: true,
        "option--is-disabled": isDisabled,
        "option--is-focused": isFocused,
        "option--is-selected": isSelected
    }), {
        ref: innerRef,
        "aria-disabled": isDisabled
    }, innerProps), children);
};
var $31f4445e1a7a95b7$var$Option$1 = $31f4445e1a7a95b7$var$Option;
var $31f4445e1a7a95b7$export$efccba1c4a2ef57b = function placeholderCSS(_ref, unstyled) {
    var _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return (0, $k5N0O.default)({
        label: "placeholder",
        gridArea: "1 / 1 / 2 / 3"
    }, unstyled ? {} : {
        color: colors.neutral50,
        marginLeft: spacing.baseUnit / 2,
        marginRight: spacing.baseUnit / 2
    });
};
var $31f4445e1a7a95b7$var$Placeholder = function Placeholder(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, $2ZUkg.jsx)("div", (0, $fBUaU.default)({}, $31f4445e1a7a95b7$var$getStyleProps(props, "placeholder", {
        placeholder: true
    }), innerProps), children);
};
var $31f4445e1a7a95b7$var$Placeholder$1 = $31f4445e1a7a95b7$var$Placeholder;
var $31f4445e1a7a95b7$export$d141bba7fdc215a3 = function css(_ref, unstyled) {
    var isDisabled = _ref.isDisabled, _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return (0, $k5N0O.default)({
        label: "singleValue",
        gridArea: "1 / 1 / 2 / 3",
        maxWidth: "100%",
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap"
    }, unstyled ? {} : {
        color: isDisabled ? colors.neutral40 : colors.neutral80,
        marginLeft: spacing.baseUnit / 2,
        marginRight: spacing.baseUnit / 2
    });
};
var $31f4445e1a7a95b7$var$SingleValue = function SingleValue(props) {
    var children = props.children, isDisabled = props.isDisabled, innerProps = props.innerProps;
    return (0, $2ZUkg.jsx)("div", (0, $fBUaU.default)({}, $31f4445e1a7a95b7$var$getStyleProps(props, "singleValue", {
        "single-value": true,
        "single-value--is-disabled": isDisabled
    }), innerProps), children);
};
var $31f4445e1a7a95b7$var$SingleValue$1 = $31f4445e1a7a95b7$var$SingleValue;
var $31f4445e1a7a95b7$export$db3b6bfb95261072 = {
    ClearIndicator: $31f4445e1a7a95b7$var$ClearIndicator,
    Control: $31f4445e1a7a95b7$var$Control$1,
    DropdownIndicator: $31f4445e1a7a95b7$var$DropdownIndicator,
    DownChevron: $31f4445e1a7a95b7$var$DownChevron,
    CrossIcon: $31f4445e1a7a95b7$var$CrossIcon,
    Group: $31f4445e1a7a95b7$var$Group$1,
    GroupHeading: $31f4445e1a7a95b7$var$GroupHeading,
    IndicatorsContainer: $31f4445e1a7a95b7$var$IndicatorsContainer,
    IndicatorSeparator: $31f4445e1a7a95b7$var$IndicatorSeparator,
    Input: $31f4445e1a7a95b7$var$Input$1,
    LoadingIndicator: $31f4445e1a7a95b7$var$LoadingIndicator,
    Menu: $31f4445e1a7a95b7$var$Menu$1,
    MenuList: $31f4445e1a7a95b7$var$MenuList,
    MenuPortal: $31f4445e1a7a95b7$var$MenuPortal,
    LoadingMessage: $31f4445e1a7a95b7$var$LoadingMessage,
    NoOptionsMessage: $31f4445e1a7a95b7$var$NoOptionsMessage,
    MultiValue: $31f4445e1a7a95b7$var$MultiValue$1,
    MultiValueContainer: $31f4445e1a7a95b7$var$MultiValueContainer,
    MultiValueLabel: $31f4445e1a7a95b7$var$MultiValueLabel,
    MultiValueRemove: $31f4445e1a7a95b7$var$MultiValueRemove,
    Option: $31f4445e1a7a95b7$var$Option$1,
    Placeholder: $31f4445e1a7a95b7$var$Placeholder$1,
    SelectContainer: $31f4445e1a7a95b7$var$SelectContainer,
    SingleValue: $31f4445e1a7a95b7$var$SingleValue$1,
    ValueContainer: $31f4445e1a7a95b7$var$ValueContainer
};
var $31f4445e1a7a95b7$export$d66501df72047452 = function defaultComponents(props) {
    return (0, $k5N0O.default)((0, $k5N0O.default)({}, $31f4445e1a7a95b7$export$db3b6bfb95261072), props.components);
};

});
parcelRegister("5kd3B", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3e08f2e494357ce8$export$2e2bcd8739ae039; });
function $3e08f2e494357ce8$export$2e2bcd8739ae039(e, t) {
    return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, {
        raw: {
            value: Object.freeze(t)
        }
    }));
}

});

parcelRegister("24DUy", function(module, exports) {

$parcel$export(module.exports, "autoUpdate", function () { return $8d1ccc98aa9166ca$export$deee3a793edee05f; });

var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");
parcelRequire("kSdhf");
var $ft7ke = parcelRequire("ft7ke");
var $kSdhf = parcelRequire("kSdhf");

var $ft7ke = parcelRequire("ft7ke");

var $1aw9F = parcelRequire("1aw9F");
function $8d1ccc98aa9166ca$var$getCssDimensions(element) {
    const css = (0, $1aw9F.getComputedStyle)(element);
    // In testing environments, the `width` and `height` properties are empty
    // strings for SVG elements, returning NaN. Fallback to `0` in this case.
    let width = parseFloat(css.width) || 0;
    let height = parseFloat(css.height) || 0;
    const hasOffset = (0, $1aw9F.isHTMLElement)(element);
    const offsetWidth = hasOffset ? element.offsetWidth : width;
    const offsetHeight = hasOffset ? element.offsetHeight : height;
    const shouldFallback = (0, $ft7ke.round)(width) !== offsetWidth || (0, $ft7ke.round)(height) !== offsetHeight;
    if (shouldFallback) {
        width = offsetWidth;
        height = offsetHeight;
    }
    return {
        width: width,
        height: height,
        $: shouldFallback
    };
}
function $8d1ccc98aa9166ca$var$unwrapElement(element) {
    return !(0, $1aw9F.isElement)(element) ? element.contextElement : element;
}
function $8d1ccc98aa9166ca$var$getScale(element) {
    const domElement = $8d1ccc98aa9166ca$var$unwrapElement(element);
    if (!(0, $1aw9F.isHTMLElement)(domElement)) return (0, $ft7ke.createCoords)(1);
    const rect = domElement.getBoundingClientRect();
    const { width: width, height: height, $: $ } = $8d1ccc98aa9166ca$var$getCssDimensions(domElement);
    let x = ($ ? (0, $ft7ke.round)(rect.width) : rect.width) / width;
    let y = ($ ? (0, $ft7ke.round)(rect.height) : rect.height) / height;
    // 0, NaN, or Infinity should always fallback to 1.
    if (!x || !Number.isFinite(x)) x = 1;
    if (!y || !Number.isFinite(y)) y = 1;
    return {
        x: x,
        y: y
    };
}
const $8d1ccc98aa9166ca$var$noOffsets = /*#__PURE__*/ (0, $ft7ke.createCoords)(0);
function $8d1ccc98aa9166ca$var$getVisualOffsets(element) {
    const win = (0, $1aw9F.getWindow)(element);
    if (!(0, $1aw9F.isWebKit)() || !win.visualViewport) return $8d1ccc98aa9166ca$var$noOffsets;
    return {
        x: win.visualViewport.offsetLeft,
        y: win.visualViewport.offsetTop
    };
}
function $8d1ccc98aa9166ca$var$shouldAddVisualOffsets(element, isFixed, floatingOffsetParent) {
    if (isFixed === void 0) isFixed = false;
    if (!floatingOffsetParent || isFixed && floatingOffsetParent !== (0, $1aw9F.getWindow)(element)) return false;
    return isFixed;
}
function $8d1ccc98aa9166ca$var$getBoundingClientRect(element, includeScale, isFixedStrategy, offsetParent) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    const clientRect = element.getBoundingClientRect();
    const domElement = $8d1ccc98aa9166ca$var$unwrapElement(element);
    let scale = (0, $ft7ke.createCoords)(1);
    if (includeScale) {
        if (offsetParent) {
            if ((0, $1aw9F.isElement)(offsetParent)) scale = $8d1ccc98aa9166ca$var$getScale(offsetParent);
        } else scale = $8d1ccc98aa9166ca$var$getScale(element);
    }
    const visualOffsets = $8d1ccc98aa9166ca$var$shouldAddVisualOffsets(domElement, isFixedStrategy, offsetParent) ? $8d1ccc98aa9166ca$var$getVisualOffsets(domElement) : (0, $ft7ke.createCoords)(0);
    let x = (clientRect.left + visualOffsets.x) / scale.x;
    let y = (clientRect.top + visualOffsets.y) / scale.y;
    let width = clientRect.width / scale.x;
    let height = clientRect.height / scale.y;
    if (domElement) {
        const win = (0, $1aw9F.getWindow)(domElement);
        const offsetWin = offsetParent && (0, $1aw9F.isElement)(offsetParent) ? (0, $1aw9F.getWindow)(offsetParent) : offsetParent;
        let currentIFrame = win.frameElement;
        while(currentIFrame && offsetParent && offsetWin !== win){
            const iframeScale = $8d1ccc98aa9166ca$var$getScale(currentIFrame);
            const iframeRect = currentIFrame.getBoundingClientRect();
            const css = (0, $1aw9F.getComputedStyle)(currentIFrame);
            const left = iframeRect.left + (currentIFrame.clientLeft + parseFloat(css.paddingLeft)) * iframeScale.x;
            const top = iframeRect.top + (currentIFrame.clientTop + parseFloat(css.paddingTop)) * iframeScale.y;
            x *= iframeScale.x;
            y *= iframeScale.y;
            width *= iframeScale.x;
            height *= iframeScale.y;
            x += left;
            y += top;
            currentIFrame = (0, $1aw9F.getWindow)(currentIFrame).frameElement;
        }
    }
    return (0, $ft7ke.rectToClientRect)({
        width: width,
        height: height,
        x: x,
        y: y
    });
}
function $8d1ccc98aa9166ca$var$convertOffsetParentRelativeRectToViewportRelativeRect(_ref) {
    let { rect: rect, offsetParent: offsetParent, strategy: strategy } = _ref;
    const isOffsetParentAnElement = (0, $1aw9F.isHTMLElement)(offsetParent);
    const documentElement = (0, $1aw9F.getDocumentElement)(offsetParent);
    if (offsetParent === documentElement) return rect;
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    let scale = (0, $ft7ke.createCoords)(1);
    const offsets = (0, $ft7ke.createCoords)(0);
    if (isOffsetParentAnElement || !isOffsetParentAnElement && strategy !== "fixed") {
        if ((0, $1aw9F.getNodeName)(offsetParent) !== "body" || (0, $1aw9F.isOverflowElement)(documentElement)) scroll = (0, $1aw9F.getNodeScroll)(offsetParent);
        if ((0, $1aw9F.isHTMLElement)(offsetParent)) {
            const offsetRect = $8d1ccc98aa9166ca$var$getBoundingClientRect(offsetParent);
            scale = $8d1ccc98aa9166ca$var$getScale(offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        }
    }
    return {
        width: rect.width * scale.x,
        height: rect.height * scale.y,
        x: rect.x * scale.x - scroll.scrollLeft * scale.x + offsets.x,
        y: rect.y * scale.y - scroll.scrollTop * scale.y + offsets.y
    };
}
function $8d1ccc98aa9166ca$var$getClientRects(element) {
    return Array.from(element.getClientRects());
}
function $8d1ccc98aa9166ca$var$getWindowScrollBarX(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    return $8d1ccc98aa9166ca$var$getBoundingClientRect((0, $1aw9F.getDocumentElement)(element)).left + (0, $1aw9F.getNodeScroll)(element).scrollLeft;
}
// Gets the entire size of the scrollable document area, even extending outside
// of the `<html>` and `<body>` rect bounds if horizontally scrollable.
function $8d1ccc98aa9166ca$var$getDocumentRect(element) {
    const html = (0, $1aw9F.getDocumentElement)(element);
    const scroll = (0, $1aw9F.getNodeScroll)(element);
    const body = element.ownerDocument.body;
    const width = (0, $ft7ke.max)(html.scrollWidth, html.clientWidth, body.scrollWidth, body.clientWidth);
    const height = (0, $ft7ke.max)(html.scrollHeight, html.clientHeight, body.scrollHeight, body.clientHeight);
    let x = -scroll.scrollLeft + $8d1ccc98aa9166ca$var$getWindowScrollBarX(element);
    const y = -scroll.scrollTop;
    if ((0, $1aw9F.getComputedStyle)(body).direction === "rtl") x += (0, $ft7ke.max)(html.clientWidth, body.clientWidth) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
function $8d1ccc98aa9166ca$var$getViewportRect(element, strategy) {
    const win = (0, $1aw9F.getWindow)(element);
    const html = (0, $1aw9F.getDocumentElement)(element);
    const visualViewport = win.visualViewport;
    let width = html.clientWidth;
    let height = html.clientHeight;
    let x = 0;
    let y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        const visualViewportBased = (0, $1aw9F.isWebKit)();
        if (!visualViewportBased || visualViewportBased && strategy === "fixed") {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
// Returns the inner client rect, subtracting scrollbars if present.
function $8d1ccc98aa9166ca$var$getInnerBoundingClientRect(element, strategy) {
    const clientRect = $8d1ccc98aa9166ca$var$getBoundingClientRect(element, true, strategy === "fixed");
    const top = clientRect.top + element.clientTop;
    const left = clientRect.left + element.clientLeft;
    const scale = (0, $1aw9F.isHTMLElement)(element) ? $8d1ccc98aa9166ca$var$getScale(element) : (0, $ft7ke.createCoords)(1);
    const width = element.clientWidth * scale.x;
    const height = element.clientHeight * scale.y;
    const x = left * scale.x;
    const y = top * scale.y;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
function $8d1ccc98aa9166ca$var$getClientRectFromClippingAncestor(element, clippingAncestor, strategy) {
    let rect;
    if (clippingAncestor === "viewport") rect = $8d1ccc98aa9166ca$var$getViewportRect(element, strategy);
    else if (clippingAncestor === "document") rect = $8d1ccc98aa9166ca$var$getDocumentRect((0, $1aw9F.getDocumentElement)(element));
    else if ((0, $1aw9F.isElement)(clippingAncestor)) rect = $8d1ccc98aa9166ca$var$getInnerBoundingClientRect(clippingAncestor, strategy);
    else {
        const visualOffsets = $8d1ccc98aa9166ca$var$getVisualOffsets(element);
        rect = (0, $6iHNw._)((0, $7Knp0._)({}, clippingAncestor), {
            x: clippingAncestor.x - visualOffsets.x,
            y: clippingAncestor.y - visualOffsets.y
        });
    }
    return (0, $ft7ke.rectToClientRect)(rect);
}
function $8d1ccc98aa9166ca$var$hasFixedPositionAncestor(element, stopNode) {
    const parentNode = (0, $1aw9F.getParentNode)(element);
    if (parentNode === stopNode || !(0, $1aw9F.isElement)(parentNode) || (0, $1aw9F.isLastTraversableNode)(parentNode)) return false;
    return (0, $1aw9F.getComputedStyle)(parentNode).position === "fixed" || $8d1ccc98aa9166ca$var$hasFixedPositionAncestor(parentNode, stopNode);
}
// A "clipping ancestor" is an `overflow` element with the characteristic of
// clipping (or hiding) child elements. This returns all clipping ancestors
// of the given element up the tree.
function $8d1ccc98aa9166ca$var$getClippingElementAncestors(element, cache) {
    const cachedResult = cache.get(element);
    if (cachedResult) return cachedResult;
    let result = (0, $1aw9F.getOverflowAncestors)(element, [], false).filter((el)=>(0, $1aw9F.isElement)(el) && (0, $1aw9F.getNodeName)(el) !== "body");
    let currentContainingBlockComputedStyle = null;
    const elementIsFixed = (0, $1aw9F.getComputedStyle)(element).position === "fixed";
    let currentNode = elementIsFixed ? (0, $1aw9F.getParentNode)(element) : element;
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    while((0, $1aw9F.isElement)(currentNode) && !(0, $1aw9F.isLastTraversableNode)(currentNode)){
        const computedStyle = (0, $1aw9F.getComputedStyle)(currentNode);
        const currentNodeIsContaining = (0, $1aw9F.isContainingBlock)(currentNode);
        if (!currentNodeIsContaining && computedStyle.position === "fixed") currentContainingBlockComputedStyle = null;
        const shouldDropCurrentNode = elementIsFixed ? !currentNodeIsContaining && !currentContainingBlockComputedStyle : !currentNodeIsContaining && computedStyle.position === "static" && !!currentContainingBlockComputedStyle && [
            "absolute",
            "fixed"
        ].includes(currentContainingBlockComputedStyle.position) || (0, $1aw9F.isOverflowElement)(currentNode) && !currentNodeIsContaining && $8d1ccc98aa9166ca$var$hasFixedPositionAncestor(element, currentNode);
        if (shouldDropCurrentNode) // Drop non-containing blocks.
        result = result.filter((ancestor)=>ancestor !== currentNode);
        else // Record last containing block for next iteration.
        currentContainingBlockComputedStyle = computedStyle;
        currentNode = (0, $1aw9F.getParentNode)(currentNode);
    }
    cache.set(element, result);
    return result;
}
// Gets the maximum area that the element is visible in due to any number of
// clipping ancestors.
function $8d1ccc98aa9166ca$var$getClippingRect(_ref) {
    let { element: element, boundary: boundary, rootBoundary: rootBoundary, strategy: strategy } = _ref;
    const elementClippingAncestors = boundary === "clippingAncestors" ? $8d1ccc98aa9166ca$var$getClippingElementAncestors(element, this._c) : [].concat(boundary);
    const clippingAncestors = [
        ...elementClippingAncestors,
        rootBoundary
    ];
    const firstClippingAncestor = clippingAncestors[0];
    const clippingRect = clippingAncestors.reduce((accRect, clippingAncestor)=>{
        const rect = $8d1ccc98aa9166ca$var$getClientRectFromClippingAncestor(element, clippingAncestor, strategy);
        accRect.top = (0, $ft7ke.max)(rect.top, accRect.top);
        accRect.right = (0, $ft7ke.min)(rect.right, accRect.right);
        accRect.bottom = (0, $ft7ke.min)(rect.bottom, accRect.bottom);
        accRect.left = (0, $ft7ke.max)(rect.left, accRect.left);
        return accRect;
    }, $8d1ccc98aa9166ca$var$getClientRectFromClippingAncestor(element, firstClippingAncestor, strategy));
    return {
        width: clippingRect.right - clippingRect.left,
        height: clippingRect.bottom - clippingRect.top,
        x: clippingRect.left,
        y: clippingRect.top
    };
}
function $8d1ccc98aa9166ca$var$getDimensions(element) {
    return $8d1ccc98aa9166ca$var$getCssDimensions(element);
}
function $8d1ccc98aa9166ca$var$getRectRelativeToOffsetParent(element, offsetParent, strategy) {
    const isOffsetParentAnElement = (0, $1aw9F.isHTMLElement)(offsetParent);
    const documentElement = (0, $1aw9F.getDocumentElement)(offsetParent);
    const isFixed = strategy === "fixed";
    const rect = $8d1ccc98aa9166ca$var$getBoundingClientRect(element, true, isFixed, offsetParent);
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    const offsets = (0, $ft7ke.createCoords)(0);
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $1aw9F.getNodeName)(offsetParent) !== "body" || (0, $1aw9F.isOverflowElement)(documentElement)) scroll = (0, $1aw9F.getNodeScroll)(offsetParent);
        if (isOffsetParentAnElement) {
            const offsetRect = $8d1ccc98aa9166ca$var$getBoundingClientRect(offsetParent, true, isFixed, offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        } else if (documentElement) offsets.x = $8d1ccc98aa9166ca$var$getWindowScrollBarX(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}
function $8d1ccc98aa9166ca$var$getTrueOffsetParent(element, polyfill) {
    if (!(0, $1aw9F.isHTMLElement)(element) || (0, $1aw9F.getComputedStyle)(element).position === "fixed") return null;
    if (polyfill) return polyfill(element);
    return element.offsetParent;
}
// Gets the closest ancestor positioned element. Handles some edge cases,
// such as table ancestors and cross browser bugs.
function $8d1ccc98aa9166ca$var$getOffsetParent(element, polyfill) {
    const window = (0, $1aw9F.getWindow)(element);
    if (!(0, $1aw9F.isHTMLElement)(element)) return window;
    let offsetParent = $8d1ccc98aa9166ca$var$getTrueOffsetParent(element, polyfill);
    while(offsetParent && (0, $1aw9F.isTableElement)(offsetParent) && (0, $1aw9F.getComputedStyle)(offsetParent).position === "static")offsetParent = $8d1ccc98aa9166ca$var$getTrueOffsetParent(offsetParent, polyfill);
    if (offsetParent && ((0, $1aw9F.getNodeName)(offsetParent) === "html" || (0, $1aw9F.getNodeName)(offsetParent) === "body" && (0, $1aw9F.getComputedStyle)(offsetParent).position === "static" && !(0, $1aw9F.isContainingBlock)(offsetParent))) return window;
    return offsetParent || (0, $1aw9F.getContainingBlock)(element) || window;
}
const $8d1ccc98aa9166ca$var$getElementRects = async function(_ref) {
    let { reference: reference, floating: floating, strategy: strategy } = _ref;
    const getOffsetParentFn = this.getOffsetParent || $8d1ccc98aa9166ca$var$getOffsetParent;
    const getDimensionsFn = this.getDimensions;
    return {
        reference: $8d1ccc98aa9166ca$var$getRectRelativeToOffsetParent(reference, await getOffsetParentFn(floating), strategy),
        floating: (0, $7Knp0._)({
            x: 0,
            y: 0
        }, await getDimensionsFn(floating))
    };
};
function $8d1ccc98aa9166ca$var$isRTL(element) {
    return (0, $1aw9F.getComputedStyle)(element).direction === "rtl";
}
const $8d1ccc98aa9166ca$export$722a64dea1b767dc = {
    convertOffsetParentRelativeRectToViewportRelativeRect: $8d1ccc98aa9166ca$var$convertOffsetParentRelativeRectToViewportRelativeRect,
    getDocumentElement: $1aw9F.getDocumentElement,
    getClippingRect: $8d1ccc98aa9166ca$var$getClippingRect,
    getOffsetParent: $8d1ccc98aa9166ca$var$getOffsetParent,
    getElementRects: $8d1ccc98aa9166ca$var$getElementRects,
    getClientRects: $8d1ccc98aa9166ca$var$getClientRects,
    getDimensions: $8d1ccc98aa9166ca$var$getDimensions,
    getScale: $8d1ccc98aa9166ca$var$getScale,
    isElement: $1aw9F.isElement,
    isRTL: $8d1ccc98aa9166ca$var$isRTL
};
// https://samthor.au/2021/observing-dom/
function $8d1ccc98aa9166ca$var$observeMove(element, onMove) {
    let io = null;
    let timeoutId;
    const root = (0, $1aw9F.getDocumentElement)(element);
    function cleanup() {
        clearTimeout(timeoutId);
        io && io.disconnect();
        io = null;
    }
    function refresh(skip, threshold) {
        if (skip === void 0) skip = false;
        if (threshold === void 0) threshold = 1;
        cleanup();
        const { left: left, top: top, width: width, height: height } = element.getBoundingClientRect();
        if (!skip) onMove();
        if (!width || !height) return;
        const insetTop = (0, $ft7ke.floor)(top);
        const insetRight = (0, $ft7ke.floor)(root.clientWidth - (left + width));
        const insetBottom = (0, $ft7ke.floor)(root.clientHeight - (top + height));
        const insetLeft = (0, $ft7ke.floor)(left);
        const rootMargin = -insetTop + "px " + -insetRight + "px " + -insetBottom + "px " + -insetLeft + "px";
        const options = {
            rootMargin: rootMargin,
            threshold: (0, $ft7ke.max)(0, (0, $ft7ke.min)(1, threshold)) || 1
        };
        let isFirstUpdate = true;
        function handleObserve(entries) {
            const ratio = entries[0].intersectionRatio;
            if (ratio !== threshold) {
                if (!isFirstUpdate) return refresh();
                if (!ratio) timeoutId = setTimeout(()=>{
                    refresh(false, 1e-7);
                }, 100);
                else refresh(false, ratio);
            }
            isFirstUpdate = false;
        }
        // Older browsers don't support a `document` as the root and will throw an
        // error.
        try {
            io = new IntersectionObserver(handleObserve, (0, $6iHNw._)((0, $7Knp0._)({}, options), {
                // Handle <iframe>s
                root: root.ownerDocument
            }));
        } catch (e) {
            io = new IntersectionObserver(handleObserve, options);
        }
        io.observe(element);
    }
    refresh(true);
    return cleanup;
}
/**
 * Automatically updates the position of the floating element when necessary.
 * Should only be called when the floating element is mounted on the DOM or
 * visible on the screen.
 * @returns cleanup function that should be invoked when the floating element is
 * removed from the DOM or hidden from the screen.
 * @see https://floating-ui.com/docs/autoUpdate
 */ function $8d1ccc98aa9166ca$export$deee3a793edee05f(reference, floating, update, options) {
    if (options === void 0) options = {};
    const { ancestorScroll: ancestorScroll = true, ancestorResize: ancestorResize = true, elementResize: elementResize = typeof ResizeObserver === "function", layoutShift: layoutShift = typeof IntersectionObserver === "function", animationFrame: animationFrame = false } = options;
    const referenceEl = $8d1ccc98aa9166ca$var$unwrapElement(reference);
    const ancestors = ancestorScroll || ancestorResize ? [
        ...referenceEl ? (0, $1aw9F.getOverflowAncestors)(referenceEl) : [],
        ...(0, $1aw9F.getOverflowAncestors)(floating)
    ] : [];
    ancestors.forEach((ancestor)=>{
        ancestorScroll && ancestor.addEventListener("scroll", update, {
            passive: true
        });
        ancestorResize && ancestor.addEventListener("resize", update);
    });
    const cleanupIo = referenceEl && layoutShift ? $8d1ccc98aa9166ca$var$observeMove(referenceEl, update) : null;
    let reobserveFrame = -1;
    let resizeObserver = null;
    if (elementResize) {
        resizeObserver = new ResizeObserver((_ref)=>{
            let [firstEntry] = _ref;
            if (firstEntry && firstEntry.target === referenceEl && resizeObserver) {
                // Prevent update loops when using the `size` middleware.
                // https://github.com/floating-ui/floating-ui/issues/1740
                resizeObserver.unobserve(floating);
                cancelAnimationFrame(reobserveFrame);
                reobserveFrame = requestAnimationFrame(()=>{
                    resizeObserver && resizeObserver.observe(floating);
                });
            }
            update();
        });
        if (referenceEl && !animationFrame) resizeObserver.observe(referenceEl);
        resizeObserver.observe(floating);
    }
    let frameId;
    let prevRefRect = animationFrame ? $8d1ccc98aa9166ca$var$getBoundingClientRect(reference) : null;
    if (animationFrame) frameLoop();
    function frameLoop() {
        const nextRefRect = $8d1ccc98aa9166ca$var$getBoundingClientRect(reference);
        if (prevRefRect && (nextRefRect.x !== prevRefRect.x || nextRefRect.y !== prevRefRect.y || nextRefRect.width !== prevRefRect.width || nextRefRect.height !== prevRefRect.height)) update();
        prevRefRect = nextRefRect;
        frameId = requestAnimationFrame(frameLoop);
    }
    update();
    return ()=>{
        ancestors.forEach((ancestor)=>{
            ancestorScroll && ancestor.removeEventListener("scroll", update);
            ancestorResize && ancestor.removeEventListener("resize", update);
        });
        cleanupIo && cleanupIo();
        resizeObserver && resizeObserver.disconnect();
        resizeObserver = null;
        if (animationFrame) cancelAnimationFrame(frameId);
    };
}
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a reference element when it is given a certain CSS positioning
 * strategy.
 */ const $8d1ccc98aa9166ca$export$48a53dcb22e581d0 = (reference, floating, options)=>{
    // This caches the expensive `getClippingElementAncestors` function so that
    // multiple lifecycle resets re-use the same result. It only lives for a
    // single call. If other functions become expensive, we can add them as well.
    const cache = new Map();
    const mergedOptions = (0, $7Knp0._)({
        platform: $8d1ccc98aa9166ca$export$722a64dea1b767dc
    }, options);
    const platformWithCache = (0, $6iHNw._)((0, $7Knp0._)({}, mergedOptions.platform), {
        _c: cache
    });
    return (0, $kSdhf.computePosition)(reference, floating, (0, $6iHNw._)((0, $7Knp0._)({}, mergedOptions), {
        platform: platformWithCache
    }));
};

});
parcelRegister("kSdhf", function(module, exports) {

$parcel$export(module.exports, "computePosition", function () { return $9a5214747241b192$export$48a53dcb22e581d0; });
$parcel$export(module.exports, "rectToClientRect", function () { return (parcelRequire("ft7ke")).rectToClientRect; });

var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $akGnX = parcelRequire("akGnX");

var $ft7ke = parcelRequire("ft7ke");
function $9a5214747241b192$var$computeCoordsFromPlacement(_ref, placement, rtl) {
    let { reference: reference, floating: floating } = _ref;
    const sideAxis = (0, $ft7ke.getSideAxis)(placement);
    const alignmentAxis = (0, $ft7ke.getAlignmentAxis)(placement);
    const alignLength = (0, $ft7ke.getAxisLength)(alignmentAxis);
    const side = (0, $ft7ke.getSide)(placement);
    const isVertical = sideAxis === "y";
    const commonX = reference.x + reference.width / 2 - floating.width / 2;
    const commonY = reference.y + reference.height / 2 - floating.height / 2;
    const commonAlign = reference[alignLength] / 2 - floating[alignLength] / 2;
    let coords;
    switch(side){
        case "top":
            coords = {
                x: commonX,
                y: reference.y - floating.height
            };
            break;
        case "bottom":
            coords = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case "right":
            coords = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case "left":
            coords = {
                x: reference.x - floating.width,
                y: commonY
            };
            break;
        default:
            coords = {
                x: reference.x,
                y: reference.y
            };
    }
    switch((0, $ft7ke.getAlignment)(placement)){
        case "start":
            coords[alignmentAxis] -= commonAlign * (rtl && isVertical ? -1 : 1);
            break;
        case "end":
            coords[alignmentAxis] += commonAlign * (rtl && isVertical ? -1 : 1);
            break;
    }
    return coords;
}
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a reference element when it is given a certain positioning strategy.
 *
 * This export does not have any `platform` interface logic. You will need to
 * write one for the platform you are using Floating UI with.
 */ const $9a5214747241b192$export$48a53dcb22e581d0 = async (reference, floating, config)=>{
    const { placement: placement = "bottom", strategy: strategy = "absolute", middleware: middleware = [], platform: platform } = config;
    const validMiddleware = middleware.filter(Boolean);
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(floating));
    let rects = await platform.getElementRects({
        reference: reference,
        floating: floating,
        strategy: strategy
    });
    let { x: x, y: y } = $9a5214747241b192$var$computeCoordsFromPlacement(rects, placement, rtl);
    let statefulPlacement = placement;
    let middlewareData = {};
    let resetCount = 0;
    for(let i = 0; i < validMiddleware.length; i++){
        const { name: name, fn: fn } = validMiddleware[i];
        const { x: nextX, y: nextY, data: data, reset: reset } = await fn({
            x: x,
            y: y,
            initialPlacement: placement,
            placement: statefulPlacement,
            strategy: strategy,
            middlewareData: middlewareData,
            rects: rects,
            platform: platform,
            elements: {
                reference: reference,
                floating: floating
            }
        });
        x = nextX != null ? nextX : x;
        y = nextY != null ? nextY : y;
        middlewareData = (0, $6iHNw._)((0, $7Knp0._)({}, middlewareData), {
            [name]: (0, $7Knp0._)({}, middlewareData[name], data)
        });
        if (reset && resetCount <= 50) {
            resetCount++;
            if (typeof reset === "object") {
                if (reset.placement) statefulPlacement = reset.placement;
                if (reset.rects) rects = reset.rects === true ? await platform.getElementRects({
                    reference: reference,
                    floating: floating,
                    strategy: strategy
                }) : reset.rects;
                ({ x: x, y: y } = $9a5214747241b192$var$computeCoordsFromPlacement(rects, statefulPlacement, rtl));
            }
            i = -1;
            continue;
        }
    }
    return {
        x: x,
        y: y,
        placement: statefulPlacement,
        strategy: strategy,
        middlewareData: middlewareData
    };
};
/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */ async function $9a5214747241b192$export$37b6bde19b108ecc(state, options) {
    var _await$platform$isEle;
    if (options === void 0) options = {};
    const { x: x, y: y, platform: platform, rects: rects, elements: elements, strategy: strategy } = state;
    const { boundary: boundary = "clippingAncestors", rootBoundary: rootBoundary = "viewport", elementContext: elementContext = "floating", altBoundary: altBoundary = false, padding: padding = 0 } = (0, $ft7ke.evaluate)(options, state);
    const paddingObject = (0, $ft7ke.getPaddingObject)(padding);
    const altContext = elementContext === "floating" ? "reference" : "floating";
    const element = elements[altBoundary ? altContext : elementContext];
    const clippingClientRect = (0, $ft7ke.rectToClientRect)(await platform.getClippingRect({
        element: ((_await$platform$isEle = await (platform.isElement == null ? void 0 : platform.isElement(element))) != null ? _await$platform$isEle : true) ? element : element.contextElement || await (platform.getDocumentElement == null ? void 0 : platform.getDocumentElement(elements.floating)),
        boundary: boundary,
        rootBoundary: rootBoundary,
        strategy: strategy
    }));
    const rect = elementContext === "floating" ? (0, $6iHNw._)((0, $7Knp0._)({}, rects.floating), {
        x: x,
        y: y
    }) : rects.reference;
    const offsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(elements.floating));
    const offsetScale = await (platform.isElement == null ? void 0 : platform.isElement(offsetParent)) ? await (platform.getScale == null ? void 0 : platform.getScale(offsetParent)) || {
        x: 1,
        y: 1
    } : {
        x: 1,
        y: 1
    };
    const elementClientRect = (0, $ft7ke.rectToClientRect)(platform.convertOffsetParentRelativeRectToViewportRelativeRect ? await platform.convertOffsetParentRelativeRectToViewportRelativeRect({
        rect: rect,
        offsetParent: offsetParent,
        strategy: strategy
    }) : rect);
    return {
        top: (clippingClientRect.top - elementClientRect.top + paddingObject.top) / offsetScale.y,
        bottom: (elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom) / offsetScale.y,
        left: (clippingClientRect.left - elementClientRect.left + paddingObject.left) / offsetScale.x,
        right: (elementClientRect.right - clippingClientRect.right + paddingObject.right) / offsetScale.x
    };
}
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */ const $9a5214747241b192$export$f2120bbfa5450bd2 = (options)=>({
        name: "arrow",
        options: options,
        async fn (state) {
            const { x: x, y: y, placement: placement, rects: rects, platform: platform, elements: elements, middlewareData: middlewareData } = state;
            // Since `element` is required, we don't Partial<> the type.
            const { element: element, padding: padding = 0 } = (0, $ft7ke.evaluate)(options, state) || {};
            if (element == null) return {};
            const paddingObject = (0, $ft7ke.getPaddingObject)(padding);
            const coords = {
                x: x,
                y: y
            };
            const axis = (0, $ft7ke.getAlignmentAxis)(placement);
            const length = (0, $ft7ke.getAxisLength)(axis);
            const arrowDimensions = await platform.getDimensions(element);
            const isYAxis = axis === "y";
            const minProp = isYAxis ? "top" : "left";
            const maxProp = isYAxis ? "bottom" : "right";
            const clientProp = isYAxis ? "clientHeight" : "clientWidth";
            const endDiff = rects.reference[length] + rects.reference[axis] - coords[axis] - rects.floating[length];
            const startDiff = coords[axis] - rects.reference[axis];
            const arrowOffsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(element));
            let clientSize = arrowOffsetParent ? arrowOffsetParent[clientProp] : 0;
            // DOM platform can return `window` as the `offsetParent`.
            if (!clientSize || !await (platform.isElement == null ? void 0 : platform.isElement(arrowOffsetParent))) clientSize = elements.floating[clientProp] || rects.floating[length];
            const centerToReference = endDiff / 2 - startDiff / 2;
            // If the padding is large enough that it causes the arrow to no longer be
            // centered, modify the padding so that it is centered.
            const largestPossiblePadding = clientSize / 2 - arrowDimensions[length] / 2 - 1;
            const minPadding = (0, $ft7ke.min)(paddingObject[minProp], largestPossiblePadding);
            const maxPadding = (0, $ft7ke.min)(paddingObject[maxProp], largestPossiblePadding);
            // Make sure the arrow doesn't overflow the floating element if the center
            // point is outside the floating element's bounds.
            const min$1 = minPadding;
            const max = clientSize - arrowDimensions[length] - maxPadding;
            const center = clientSize / 2 - arrowDimensions[length] / 2 + centerToReference;
            const offset = (0, $ft7ke.clamp)(min$1, center, max);
            // If the reference is small enough that the arrow's padding causes it to
            // to point to nothing for an aligned placement, adjust the offset of the
            // floating element itself. To ensure `shift()` continues to take action,
            // a single reset is performed when this is true.
            const shouldAddOffset = !middlewareData.arrow && (0, $ft7ke.getAlignment)(placement) != null && center != offset && rects.reference[length] / 2 - (center < min$1 ? minPadding : maxPadding) - arrowDimensions[length] / 2 < 0;
            const alignmentOffset = shouldAddOffset ? center < min$1 ? center - min$1 : center - max : 0;
            return {
                [axis]: coords[axis] + alignmentOffset,
                data: (0, $7Knp0._)({
                    [axis]: offset,
                    centerOffset: center - offset - alignmentOffset
                }, shouldAddOffset && {
                    alignmentOffset: alignmentOffset
                }),
                reset: shouldAddOffset
            };
        }
    });
function $9a5214747241b192$var$getPlacementList(alignment, autoAlignment, allowedPlacements) {
    const allowedPlacementsSortedByAlignment = alignment ? [
        ...allowedPlacements.filter((placement)=>(0, $ft7ke.getAlignment)(placement) === alignment),
        ...allowedPlacements.filter((placement)=>(0, $ft7ke.getAlignment)(placement) !== alignment)
    ] : allowedPlacements.filter((placement)=>(0, $ft7ke.getSide)(placement) === placement);
    return allowedPlacementsSortedByAlignment.filter((placement)=>{
        if (alignment) return (0, $ft7ke.getAlignment)(placement) === alignment || (autoAlignment ? (0, $ft7ke.getOppositeAlignmentPlacement)(placement) !== placement : false);
        return true;
    });
}
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const $9a5214747241b192$export$91fb6ecbd551914 = function(options) {
    if (options === void 0) options = {};
    return {
        name: "autoPlacement",
        options: options,
        async fn (state) {
            var _middlewareData$autoP, _middlewareData$autoP2, _placementsThatFitOnE;
            const { rects: rects, middlewareData: middlewareData, placement: placement, platform: platform, elements: elements } = state;
            const _evaluate = (0, $ft7ke.evaluate)(options, state), { crossAxis: crossAxis = false, alignment: alignment, allowedPlacements: allowedPlacements = (0, $ft7ke.placements), autoAlignment: autoAlignment = true } = _evaluate, detectOverflowOptions = (0, $akGnX._)(_evaluate, [
                "crossAxis",
                "alignment",
                "allowedPlacements",
                "autoAlignment"
            ]);
            const placements$1 = alignment !== undefined || allowedPlacements === (0, $ft7ke.placements) ? $9a5214747241b192$var$getPlacementList(alignment || null, autoAlignment, allowedPlacements) : allowedPlacements;
            const overflow = await $9a5214747241b192$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const currentIndex = ((_middlewareData$autoP = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP.index) || 0;
            const currentPlacement = placements$1[currentIndex];
            if (currentPlacement == null) return {};
            const alignmentSides = (0, $ft7ke.getAlignmentSides)(currentPlacement, rects, await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)));
            // Make `computeCoords` start from the right place.
            if (placement !== currentPlacement) return {
                reset: {
                    placement: placements$1[0]
                }
            };
            const currentOverflows = [
                overflow[(0, $ft7ke.getSide)(currentPlacement)],
                overflow[alignmentSides[0]],
                overflow[alignmentSides[1]]
            ];
            const allOverflows = [
                ...((_middlewareData$autoP2 = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP2.overflows) || [],
                {
                    placement: currentPlacement,
                    overflows: currentOverflows
                }
            ];
            const nextPlacement = placements$1[currentIndex + 1];
            // There are more placements to check.
            if (nextPlacement) return {
                data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                },
                reset: {
                    placement: nextPlacement
                }
            };
            const placementsSortedByMostSpace = allOverflows.map((d)=>{
                const alignment = (0, $ft7ke.getAlignment)(d.placement);
                return [
                    d.placement,
                    alignment && crossAxis ? // Check along the mainAxis and main crossAxis side.
                    d.overflows.slice(0, 2).reduce((acc, v)=>acc + v, 0) : // Check only the mainAxis.
                    d.overflows[0],
                    d.overflows
                ];
            }).sort((a, b)=>a[1] - b[1]);
            const placementsThatFitOnEachSide = placementsSortedByMostSpace.filter((d)=>d[2].slice(0, // Aligned placements should not check their opposite crossAxis
                // side.
                (0, $ft7ke.getAlignment)(d[0]) ? 2 : 3).every((v)=>v <= 0));
            const resetPlacement = ((_placementsThatFitOnE = placementsThatFitOnEachSide[0]) == null ? void 0 : _placementsThatFitOnE[0]) || placementsSortedByMostSpace[0][0];
            if (resetPlacement !== placement) return {
                data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                },
                reset: {
                    placement: resetPlacement
                }
            };
            return {};
        }
    };
};
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const $9a5214747241b192$export$8a83211c878a3f1f = function(options) {
    if (options === void 0) options = {};
    return {
        name: "flip",
        options: options,
        async fn (state) {
            var _middlewareData$arrow, _middlewareData$flip;
            const { placement: placement, middlewareData: middlewareData, rects: rects, initialPlacement: initialPlacement, platform: platform, elements: elements } = state;
            const _evaluate = (0, $ft7ke.evaluate)(options, state), { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true, fallbackPlacements: specifiedFallbackPlacements, fallbackStrategy: fallbackStrategy = "bestFit", fallbackAxisSideDirection: fallbackAxisSideDirection = "none", flipAlignment: flipAlignment = true } = _evaluate, detectOverflowOptions = (0, $akGnX._)(_evaluate, [
                "mainAxis",
                "crossAxis",
                "fallbackPlacements",
                "fallbackStrategy",
                "fallbackAxisSideDirection",
                "flipAlignment"
            ]);
            // If a reset by the arrow was caused due to an alignment offset being
            // added, we should skip any logic now since `flip()` has already done its
            // work.
            // https://github.com/floating-ui/floating-ui/issues/2549#issuecomment-1719601643
            if ((_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
            const side = (0, $ft7ke.getSide)(placement);
            const isBasePlacement = (0, $ft7ke.getSide)(initialPlacement) === initialPlacement;
            const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
            const fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipAlignment ? [
                (0, $ft7ke.getOppositePlacement)(initialPlacement)
            ] : (0, $ft7ke.getExpandedPlacements)(initialPlacement));
            if (!specifiedFallbackPlacements && fallbackAxisSideDirection !== "none") fallbackPlacements.push(...(0, $ft7ke.getOppositeAxisPlacements)(initialPlacement, flipAlignment, fallbackAxisSideDirection, rtl));
            const placements = [
                initialPlacement,
                ...fallbackPlacements
            ];
            const overflow = await $9a5214747241b192$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const overflows = [];
            let overflowsData = ((_middlewareData$flip = middlewareData.flip) == null ? void 0 : _middlewareData$flip.overflows) || [];
            if (checkMainAxis) overflows.push(overflow[side]);
            if (checkCrossAxis) {
                const sides = (0, $ft7ke.getAlignmentSides)(placement, rects, rtl);
                overflows.push(overflow[sides[0]], overflow[sides[1]]);
            }
            overflowsData = [
                ...overflowsData,
                {
                    placement: placement,
                    overflows: overflows
                }
            ];
            // One or more sides is overflowing.
            if (!overflows.every((side)=>side <= 0)) {
                var _middlewareData$flip2, _overflowsData$filter;
                const nextIndex = (((_middlewareData$flip2 = middlewareData.flip) == null ? void 0 : _middlewareData$flip2.index) || 0) + 1;
                const nextPlacement = placements[nextIndex];
                if (nextPlacement) // Try next placement and re-run the lifecycle.
                return {
                    data: {
                        index: nextIndex,
                        overflows: overflowsData
                    },
                    reset: {
                        placement: nextPlacement
                    }
                };
                // First, find the candidates that fit on the mainAxis side of overflow,
                // then find the placement that fits the best on the main crossAxis side.
                let resetPlacement = (_overflowsData$filter = overflowsData.filter((d)=>d.overflows[0] <= 0).sort((a, b)=>a.overflows[1] - b.overflows[1])[0]) == null ? void 0 : _overflowsData$filter.placement;
                // Otherwise fallback.
                if (!resetPlacement) switch(fallbackStrategy){
                    case "bestFit":
                        {
                            var _overflowsData$map$so;
                            const placement = (_overflowsData$map$so = overflowsData.map((d)=>[
                                    d.placement,
                                    d.overflows.filter((overflow)=>overflow > 0).reduce((acc, overflow)=>acc + overflow, 0)
                                ]).sort((a, b)=>a[1] - b[1])[0]) == null ? void 0 : _overflowsData$map$so[0];
                            if (placement) resetPlacement = placement;
                            break;
                        }
                    case "initialPlacement":
                        resetPlacement = initialPlacement;
                        break;
                }
                if (placement !== resetPlacement) return {
                    reset: {
                        placement: resetPlacement
                    }
                };
            }
            return {};
        }
    };
};
function $9a5214747241b192$var$getSideOffsets(overflow, rect) {
    return {
        top: overflow.top - rect.height,
        right: overflow.right - rect.width,
        bottom: overflow.bottom - rect.height,
        left: overflow.left - rect.width
    };
}
function $9a5214747241b192$var$isAnySideFullyClipped(overflow) {
    return (0, $ft7ke.sides).some((side)=>overflow[side] >= 0);
}
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const $9a5214747241b192$export$fe8985bb6374093c = function(options) {
    if (options === void 0) options = {};
    return {
        name: "hide",
        options: options,
        async fn (state) {
            const { rects: rects } = state;
            const _evaluate = (0, $ft7ke.evaluate)(options, state), { strategy: strategy = "referenceHidden" } = _evaluate, detectOverflowOptions = (0, $akGnX._)(_evaluate, [
                "strategy"
            ]);
            switch(strategy){
                case "referenceHidden":
                    {
                        const overflow = await $9a5214747241b192$export$37b6bde19b108ecc(state, (0, $6iHNw._)((0, $7Knp0._)({}, detectOverflowOptions), {
                            elementContext: "reference"
                        }));
                        const offsets = $9a5214747241b192$var$getSideOffsets(overflow, rects.reference);
                        return {
                            data: {
                                referenceHiddenOffsets: offsets,
                                referenceHidden: $9a5214747241b192$var$isAnySideFullyClipped(offsets)
                            }
                        };
                    }
                case "escaped":
                    {
                        const overflow = await $9a5214747241b192$export$37b6bde19b108ecc(state, (0, $6iHNw._)((0, $7Knp0._)({}, detectOverflowOptions), {
                            altBoundary: true
                        }));
                        const offsets = $9a5214747241b192$var$getSideOffsets(overflow, rects.floating);
                        return {
                            data: {
                                escapedOffsets: offsets,
                                escaped: $9a5214747241b192$var$isAnySideFullyClipped(offsets)
                            }
                        };
                    }
                default:
                    return {};
            }
        }
    };
};
function $9a5214747241b192$var$getBoundingRect(rects) {
    const minX = (0, $ft7ke.min)(...rects.map((rect)=>rect.left));
    const minY = (0, $ft7ke.min)(...rects.map((rect)=>rect.top));
    const maxX = (0, $ft7ke.max)(...rects.map((rect)=>rect.right));
    const maxY = (0, $ft7ke.max)(...rects.map((rect)=>rect.bottom));
    return {
        x: minX,
        y: minY,
        width: maxX - minX,
        height: maxY - minY
    };
}
function $9a5214747241b192$var$getRectsByLine(rects) {
    const sortedRects = rects.slice().sort((a, b)=>a.y - b.y);
    const groups = [];
    let prevRect = null;
    for(let i = 0; i < sortedRects.length; i++){
        const rect = sortedRects[i];
        if (!prevRect || rect.y - prevRect.y > prevRect.height / 2) groups.push([
            rect
        ]);
        else groups[groups.length - 1].push(rect);
        prevRect = rect;
    }
    return groups.map((rect)=>(0, $ft7ke.rectToClientRect)($9a5214747241b192$var$getBoundingRect(rect)));
}
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const $9a5214747241b192$export$18c8ad048e32c7d5 = function(options) {
    if (options === void 0) options = {};
    return {
        name: "inline",
        options: options,
        async fn (state) {
            const { placement: placement, elements: elements, rects: rects, platform: platform, strategy: strategy } = state;
            // A MouseEvent's client{X,Y} coords can be up to 2 pixels off a
            // ClientRect's bounds, despite the event listener being triggered. A
            // padding of 2 seems to handle this issue.
            const { padding: padding = 2, x: x, y: y } = (0, $ft7ke.evaluate)(options, state);
            const nativeClientRects = Array.from(await (platform.getClientRects == null ? void 0 : platform.getClientRects(elements.reference)) || []);
            const clientRects = $9a5214747241b192$var$getRectsByLine(nativeClientRects);
            const fallback = (0, $ft7ke.rectToClientRect)($9a5214747241b192$var$getBoundingRect(nativeClientRects));
            const paddingObject = (0, $ft7ke.getPaddingObject)(padding);
            function getBoundingClientRect() {
                // There are two rects and they are disjoined.
                if (clientRects.length === 2 && clientRects[0].left > clientRects[1].right && x != null && y != null) // Find the first rect in which the point is fully inside.
                return clientRects.find((rect)=>x > rect.left - paddingObject.left && x < rect.right + paddingObject.right && y > rect.top - paddingObject.top && y < rect.bottom + paddingObject.bottom) || fallback;
                // There are 2 or more connected rects.
                if (clientRects.length >= 2) {
                    if ((0, $ft7ke.getSideAxis)(placement) === "y") {
                        const firstRect = clientRects[0];
                        const lastRect = clientRects[clientRects.length - 1];
                        const isTop = (0, $ft7ke.getSide)(placement) === "top";
                        const top = firstRect.top;
                        const bottom = lastRect.bottom;
                        const left = isTop ? firstRect.left : lastRect.left;
                        const right = isTop ? firstRect.right : lastRect.right;
                        const width = right - left;
                        const height = bottom - top;
                        return {
                            top: top,
                            bottom: bottom,
                            left: left,
                            right: right,
                            width: width,
                            height: height,
                            x: left,
                            y: top
                        };
                    }
                    const isLeftSide = (0, $ft7ke.getSide)(placement) === "left";
                    const maxRight = (0, $ft7ke.max)(...clientRects.map((rect)=>rect.right));
                    const minLeft = (0, $ft7ke.min)(...clientRects.map((rect)=>rect.left));
                    const measureRects = clientRects.filter((rect)=>isLeftSide ? rect.left === minLeft : rect.right === maxRight);
                    const top = measureRects[0].top;
                    const bottom = measureRects[measureRects.length - 1].bottom;
                    const left = minLeft;
                    const right = maxRight;
                    const width = right - left;
                    const height = bottom - top;
                    return {
                        top: top,
                        bottom: bottom,
                        left: left,
                        right: right,
                        width: width,
                        height: height,
                        x: left,
                        y: top
                    };
                }
                return fallback;
            }
            const resetRects = await platform.getElementRects({
                reference: {
                    getBoundingClientRect: getBoundingClientRect
                },
                floating: elements.floating,
                strategy: strategy
            });
            if (rects.reference.x !== resetRects.reference.x || rects.reference.y !== resetRects.reference.y || rects.reference.width !== resetRects.reference.width || rects.reference.height !== resetRects.reference.height) return {
                reset: {
                    rects: resetRects
                }
            };
            return {};
        }
    };
};
// For type backwards-compatibility, the `OffsetOptions` type was also
// Derivable.
async function $9a5214747241b192$var$convertValueToCoords(state, options) {
    const { placement: placement, platform: platform, elements: elements } = state;
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
    const side = (0, $ft7ke.getSide)(placement);
    const alignment = (0, $ft7ke.getAlignment)(placement);
    const isVertical = (0, $ft7ke.getSideAxis)(placement) === "y";
    const mainAxisMulti = [
        "left",
        "top"
    ].includes(side) ? -1 : 1;
    const crossAxisMulti = rtl && isVertical ? -1 : 1;
    const rawValue = (0, $ft7ke.evaluate)(options, state);
    // eslint-disable-next-line prefer-const
    let { mainAxis: mainAxis, crossAxis: crossAxis, alignmentAxis: alignmentAxis } = typeof rawValue === "number" ? {
        mainAxis: rawValue,
        crossAxis: 0,
        alignmentAxis: null
    } : (0, $7Knp0._)({
        mainAxis: 0,
        crossAxis: 0,
        alignmentAxis: null
    }, rawValue);
    if (alignment && typeof alignmentAxis === "number") crossAxis = alignment === "end" ? alignmentAxis * -1 : alignmentAxis;
    return isVertical ? {
        x: crossAxis * crossAxisMulti,
        y: mainAxis * mainAxisMulti
    } : {
        x: mainAxis * mainAxisMulti,
        y: crossAxis * crossAxisMulti
    };
}
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const $9a5214747241b192$export$cc800923e997bb8 = function(options) {
    if (options === void 0) options = 0;
    return {
        name: "offset",
        options: options,
        async fn (state) {
            const { x: x, y: y } = state;
            const diffCoords = await $9a5214747241b192$var$convertValueToCoords(state, options);
            return {
                x: x + diffCoords.x,
                y: y + diffCoords.y,
                data: diffCoords
            };
        }
    };
};
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const $9a5214747241b192$export$fba63a578e423eb = function(options) {
    if (options === void 0) options = {};
    return {
        name: "shift",
        options: options,
        async fn (state) {
            const { x: x, y: y, placement: placement } = state;
            const _evaluate = (0, $ft7ke.evaluate)(options, state), { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = false, limiter: limiter = {
                fn: (_ref)=>{
                    let { x: x, y: y } = _ref;
                    return {
                        x: x,
                        y: y
                    };
                }
            } } = _evaluate, detectOverflowOptions = (0, $akGnX._)(_evaluate, [
                "mainAxis",
                "crossAxis",
                "limiter"
            ]);
            const coords = {
                x: x,
                y: y
            };
            const overflow = await $9a5214747241b192$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const crossAxis = (0, $ft7ke.getSideAxis)((0, $ft7ke.getSide)(placement));
            const mainAxis = (0, $ft7ke.getOppositeAxis)(crossAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            if (checkMainAxis) {
                const minSide = mainAxis === "y" ? "top" : "left";
                const maxSide = mainAxis === "y" ? "bottom" : "right";
                const min = mainAxisCoord + overflow[minSide];
                const max = mainAxisCoord - overflow[maxSide];
                mainAxisCoord = (0, $ft7ke.clamp)(min, mainAxisCoord, max);
            }
            if (checkCrossAxis) {
                const minSide = crossAxis === "y" ? "top" : "left";
                const maxSide = crossAxis === "y" ? "bottom" : "right";
                const min = crossAxisCoord + overflow[minSide];
                const max = crossAxisCoord - overflow[maxSide];
                crossAxisCoord = (0, $ft7ke.clamp)(min, crossAxisCoord, max);
            }
            const limitedCoords = limiter.fn((0, $6iHNw._)((0, $7Knp0._)({}, state), {
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            }));
            return (0, $6iHNw._)((0, $7Knp0._)({}, limitedCoords), {
                data: {
                    x: limitedCoords.x - x,
                    y: limitedCoords.y - y
                }
            });
        }
    };
};
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const $9a5214747241b192$export$7bf07e38f3dc4b69 = function(options) {
    if (options === void 0) options = {};
    return {
        options: options,
        fn (state) {
            const { x: x, y: y, placement: placement, rects: rects, middlewareData: middlewareData } = state;
            const { offset: offset = 0, mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true } = (0, $ft7ke.evaluate)(options, state);
            const coords = {
                x: x,
                y: y
            };
            const crossAxis = (0, $ft7ke.getSideAxis)(placement);
            const mainAxis = (0, $ft7ke.getOppositeAxis)(crossAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            const rawOffset = (0, $ft7ke.evaluate)(offset, state);
            const computedOffset = typeof rawOffset === "number" ? {
                mainAxis: rawOffset,
                crossAxis: 0
            } : (0, $7Knp0._)({
                mainAxis: 0,
                crossAxis: 0
            }, rawOffset);
            if (checkMainAxis) {
                const len = mainAxis === "y" ? "height" : "width";
                const limitMin = rects.reference[mainAxis] - rects.floating[len] + computedOffset.mainAxis;
                const limitMax = rects.reference[mainAxis] + rects.reference[len] - computedOffset.mainAxis;
                if (mainAxisCoord < limitMin) mainAxisCoord = limitMin;
                else if (mainAxisCoord > limitMax) mainAxisCoord = limitMax;
            }
            if (checkCrossAxis) {
                var _middlewareData$offse, _middlewareData$offse2;
                const len = mainAxis === "y" ? "width" : "height";
                const isOriginSide = [
                    "top",
                    "left"
                ].includes((0, $ft7ke.getSide)(placement));
                const limitMin = rects.reference[crossAxis] - rects.floating[len] + (isOriginSide ? ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse[crossAxis]) || 0 : 0) + (isOriginSide ? 0 : computedOffset.crossAxis);
                const limitMax = rects.reference[crossAxis] + rects.reference[len] + (isOriginSide ? 0 : ((_middlewareData$offse2 = middlewareData.offset) == null ? void 0 : _middlewareData$offse2[crossAxis]) || 0) - (isOriginSide ? computedOffset.crossAxis : 0);
                if (crossAxisCoord < limitMin) crossAxisCoord = limitMin;
                else if (crossAxisCoord > limitMax) crossAxisCoord = limitMax;
            }
            return {
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            };
        }
    };
};
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const $9a5214747241b192$export$346677f925de839c = function(options) {
    if (options === void 0) options = {};
    return {
        name: "size",
        options: options,
        async fn (state) {
            const { placement: placement, rects: rects, platform: platform, elements: elements } = state;
            const _evaluate = (0, $ft7ke.evaluate)(options, state), { apply: apply = ()=>{} } = _evaluate, detectOverflowOptions = (0, $akGnX._)(_evaluate, [
                "apply"
            ]);
            const overflow = await $9a5214747241b192$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const side = (0, $ft7ke.getSide)(placement);
            const alignment = (0, $ft7ke.getAlignment)(placement);
            const isYAxis = (0, $ft7ke.getSideAxis)(placement) === "y";
            const { width: width, height: height } = rects.floating;
            let heightSide;
            let widthSide;
            if (side === "top" || side === "bottom") {
                heightSide = side;
                widthSide = alignment === (await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)) ? "start" : "end") ? "left" : "right";
            } else {
                widthSide = side;
                heightSide = alignment === "end" ? "top" : "bottom";
            }
            const overflowAvailableHeight = height - overflow[heightSide];
            const overflowAvailableWidth = width - overflow[widthSide];
            const noShift = !state.middlewareData.shift;
            let availableHeight = overflowAvailableHeight;
            let availableWidth = overflowAvailableWidth;
            if (isYAxis) {
                const maximumClippingWidth = width - overflow.left - overflow.right;
                availableWidth = alignment || noShift ? (0, $ft7ke.min)(overflowAvailableWidth, maximumClippingWidth) : maximumClippingWidth;
            } else {
                const maximumClippingHeight = height - overflow.top - overflow.bottom;
                availableHeight = alignment || noShift ? (0, $ft7ke.min)(overflowAvailableHeight, maximumClippingHeight) : maximumClippingHeight;
            }
            if (noShift && !alignment) {
                const xMin = (0, $ft7ke.max)(overflow.left, 0);
                const xMax = (0, $ft7ke.max)(overflow.right, 0);
                const yMin = (0, $ft7ke.max)(overflow.top, 0);
                const yMax = (0, $ft7ke.max)(overflow.bottom, 0);
                if (isYAxis) availableWidth = width - 2 * (xMin !== 0 || xMax !== 0 ? xMin + xMax : (0, $ft7ke.max)(overflow.left, overflow.right));
                else availableHeight = height - 2 * (yMin !== 0 || yMax !== 0 ? yMin + yMax : (0, $ft7ke.max)(overflow.top, overflow.bottom));
            }
            await apply((0, $6iHNw._)((0, $7Knp0._)({}, state), {
                availableWidth: availableWidth,
                availableHeight: availableHeight
            }));
            const nextDimensions = await platform.getDimensions(elements.floating);
            if (width !== nextDimensions.width || height !== nextDimensions.height) return {
                reset: {
                    rects: true
                }
            };
            return {};
        }
    };
};

});
parcelRegister("ft7ke", function(module, exports) {

$parcel$export(module.exports, "sides", function () { return $a5cddb2008cdcd5d$export$832b6fa47fa053d2; });
$parcel$export(module.exports, "placements", function () { return $a5cddb2008cdcd5d$export$803cd8101b6c182b; });
$parcel$export(module.exports, "min", function () { return $a5cddb2008cdcd5d$export$96ec731ed4dcb222; });
$parcel$export(module.exports, "max", function () { return $a5cddb2008cdcd5d$export$8960430cfd85939f; });
$parcel$export(module.exports, "round", function () { return $a5cddb2008cdcd5d$export$2077e0241d6afd3c; });
$parcel$export(module.exports, "floor", function () { return $a5cddb2008cdcd5d$export$a3fe094919f356fd; });
$parcel$export(module.exports, "createCoords", function () { return $a5cddb2008cdcd5d$export$a397704b5e280835; });
$parcel$export(module.exports, "clamp", function () { return $a5cddb2008cdcd5d$export$7d15b64cf5a3a4c4; });
$parcel$export(module.exports, "evaluate", function () { return $a5cddb2008cdcd5d$export$fef61f332f2c0afc; });
$parcel$export(module.exports, "getSide", function () { return $a5cddb2008cdcd5d$export$3c915306cb7fc97a; });
$parcel$export(module.exports, "getAlignment", function () { return $a5cddb2008cdcd5d$export$f0989780f32bfcda; });
$parcel$export(module.exports, "getOppositeAxis", function () { return $a5cddb2008cdcd5d$export$8a000a963141ac32; });
$parcel$export(module.exports, "getAxisLength", function () { return $a5cddb2008cdcd5d$export$320bd9d53520c68a; });
$parcel$export(module.exports, "getSideAxis", function () { return $a5cddb2008cdcd5d$export$f28e8f882010718a; });
$parcel$export(module.exports, "getAlignmentAxis", function () { return $a5cddb2008cdcd5d$export$2b57e0052a6d6d4c; });
$parcel$export(module.exports, "getAlignmentSides", function () { return $a5cddb2008cdcd5d$export$be42861551f17911; });
$parcel$export(module.exports, "getOppositePlacement", function () { return $a5cddb2008cdcd5d$export$9c5e28bad23365fa; });
$parcel$export(module.exports, "getExpandedPlacements", function () { return $a5cddb2008cdcd5d$export$496432a3699e50b1; });
$parcel$export(module.exports, "getOppositeAlignmentPlacement", function () { return $a5cddb2008cdcd5d$export$2b182c584985588b; });
$parcel$export(module.exports, "getOppositeAxisPlacements", function () { return $a5cddb2008cdcd5d$export$a9b6fb18fd92c3ec; });
$parcel$export(module.exports, "getPaddingObject", function () { return $a5cddb2008cdcd5d$export$598c291c29bc2e71; });
$parcel$export(module.exports, "rectToClientRect", function () { return $a5cddb2008cdcd5d$export$ee05aea0aeecbad4; });

var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");
const $a5cddb2008cdcd5d$export$832b6fa47fa053d2 = [
    "top",
    "right",
    "bottom",
    "left"
];
const $a5cddb2008cdcd5d$export$27b07d8a310ed8b5 = [
    "start",
    "end"
];
const $a5cddb2008cdcd5d$export$803cd8101b6c182b = /*#__PURE__*/ $a5cddb2008cdcd5d$export$832b6fa47fa053d2.reduce((acc, side)=>acc.concat(side, side + "-" + $a5cddb2008cdcd5d$export$27b07d8a310ed8b5[0], side + "-" + $a5cddb2008cdcd5d$export$27b07d8a310ed8b5[1]), []);
const $a5cddb2008cdcd5d$export$96ec731ed4dcb222 = Math.min;
const $a5cddb2008cdcd5d$export$8960430cfd85939f = Math.max;
const $a5cddb2008cdcd5d$export$2077e0241d6afd3c = Math.round;
const $a5cddb2008cdcd5d$export$a3fe094919f356fd = Math.floor;
const $a5cddb2008cdcd5d$export$a397704b5e280835 = (v)=>({
        x: v,
        y: v
    });
const $a5cddb2008cdcd5d$var$oppositeSideMap = {
    left: "right",
    right: "left",
    bottom: "top",
    top: "bottom"
};
const $a5cddb2008cdcd5d$var$oppositeAlignmentMap = {
    start: "end",
    end: "start"
};
function $a5cddb2008cdcd5d$export$7d15b64cf5a3a4c4(start, value, end) {
    return $a5cddb2008cdcd5d$export$8960430cfd85939f(start, $a5cddb2008cdcd5d$export$96ec731ed4dcb222(value, end));
}
function $a5cddb2008cdcd5d$export$fef61f332f2c0afc(value, param) {
    return typeof value === "function" ? value(param) : value;
}
function $a5cddb2008cdcd5d$export$3c915306cb7fc97a(placement) {
    return placement.split("-")[0];
}
function $a5cddb2008cdcd5d$export$f0989780f32bfcda(placement) {
    return placement.split("-")[1];
}
function $a5cddb2008cdcd5d$export$8a000a963141ac32(axis) {
    return axis === "x" ? "y" : "x";
}
function $a5cddb2008cdcd5d$export$320bd9d53520c68a(axis) {
    return axis === "y" ? "height" : "width";
}
function $a5cddb2008cdcd5d$export$f28e8f882010718a(placement) {
    return [
        "top",
        "bottom"
    ].includes($a5cddb2008cdcd5d$export$3c915306cb7fc97a(placement)) ? "y" : "x";
}
function $a5cddb2008cdcd5d$export$2b57e0052a6d6d4c(placement) {
    return $a5cddb2008cdcd5d$export$8a000a963141ac32($a5cddb2008cdcd5d$export$f28e8f882010718a(placement));
}
function $a5cddb2008cdcd5d$export$be42861551f17911(placement, rects, rtl) {
    if (rtl === void 0) rtl = false;
    const alignment = $a5cddb2008cdcd5d$export$f0989780f32bfcda(placement);
    const alignmentAxis = $a5cddb2008cdcd5d$export$2b57e0052a6d6d4c(placement);
    const length = $a5cddb2008cdcd5d$export$320bd9d53520c68a(alignmentAxis);
    let mainAlignmentSide = alignmentAxis === "x" ? alignment === (rtl ? "end" : "start") ? "right" : "left" : alignment === "start" ? "bottom" : "top";
    if (rects.reference[length] > rects.floating[length]) mainAlignmentSide = $a5cddb2008cdcd5d$export$9c5e28bad23365fa(mainAlignmentSide);
    return [
        mainAlignmentSide,
        $a5cddb2008cdcd5d$export$9c5e28bad23365fa(mainAlignmentSide)
    ];
}
function $a5cddb2008cdcd5d$export$496432a3699e50b1(placement) {
    const oppositePlacement = $a5cddb2008cdcd5d$export$9c5e28bad23365fa(placement);
    return [
        $a5cddb2008cdcd5d$export$2b182c584985588b(placement),
        oppositePlacement,
        $a5cddb2008cdcd5d$export$2b182c584985588b(oppositePlacement)
    ];
}
function $a5cddb2008cdcd5d$export$2b182c584985588b(placement) {
    return placement.replace(/start|end/g, (alignment)=>$a5cddb2008cdcd5d$var$oppositeAlignmentMap[alignment]);
}
function $a5cddb2008cdcd5d$var$getSideList(side, isStart, rtl) {
    const lr = [
        "left",
        "right"
    ];
    const rl = [
        "right",
        "left"
    ];
    const tb = [
        "top",
        "bottom"
    ];
    const bt = [
        "bottom",
        "top"
    ];
    switch(side){
        case "top":
        case "bottom":
            if (rtl) return isStart ? rl : lr;
            return isStart ? lr : rl;
        case "left":
        case "right":
            return isStart ? tb : bt;
        default:
            return [];
    }
}
function $a5cddb2008cdcd5d$export$a9b6fb18fd92c3ec(placement, flipAlignment, direction, rtl) {
    const alignment = $a5cddb2008cdcd5d$export$f0989780f32bfcda(placement);
    let list = $a5cddb2008cdcd5d$var$getSideList($a5cddb2008cdcd5d$export$3c915306cb7fc97a(placement), direction === "start", rtl);
    if (alignment) {
        list = list.map((side)=>side + "-" + alignment);
        if (flipAlignment) list = list.concat(list.map($a5cddb2008cdcd5d$export$2b182c584985588b));
    }
    return list;
}
function $a5cddb2008cdcd5d$export$9c5e28bad23365fa(placement) {
    return placement.replace(/left|right|bottom|top/g, (side)=>$a5cddb2008cdcd5d$var$oppositeSideMap[side]);
}
function $a5cddb2008cdcd5d$export$1c66dbf1a9e34223(padding) {
    return (0, $7Knp0._)({
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    }, padding);
}
function $a5cddb2008cdcd5d$export$598c291c29bc2e71(padding) {
    return typeof padding !== "number" ? $a5cddb2008cdcd5d$export$1c66dbf1a9e34223(padding) : {
        top: padding,
        right: padding,
        bottom: padding,
        left: padding
    };
}
function $a5cddb2008cdcd5d$export$ee05aea0aeecbad4(rect) {
    return (0, $6iHNw._)((0, $7Knp0._)({}, rect), {
        top: rect.y,
        left: rect.x,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    });
}

});


parcelRegister("1aw9F", function(module, exports) {

$parcel$export(module.exports, "getNodeName", function () { return $e7725b143600c9c2$export$651544f548703224; });
$parcel$export(module.exports, "getWindow", function () { return $e7725b143600c9c2$export$38b2d434cce3ea22; });
$parcel$export(module.exports, "getDocumentElement", function () { return $e7725b143600c9c2$export$e495491855dc5418; });
$parcel$export(module.exports, "isElement", function () { return $e7725b143600c9c2$export$45a5e7f76e0caa8d; });
$parcel$export(module.exports, "isHTMLElement", function () { return $e7725b143600c9c2$export$1b3bfaa9684536aa; });
$parcel$export(module.exports, "isOverflowElement", function () { return $e7725b143600c9c2$export$989e911fa9af580a; });
$parcel$export(module.exports, "getComputedStyle", function () { return $e7725b143600c9c2$export$3735103072e4a80; });
$parcel$export(module.exports, "isTableElement", function () { return $e7725b143600c9c2$export$71535ffaa902797f; });
$parcel$export(module.exports, "isContainingBlock", function () { return $e7725b143600c9c2$export$d6c4e8150c35fed1; });
$parcel$export(module.exports, "isWebKit", function () { return $e7725b143600c9c2$export$78551043582a6a98; });
$parcel$export(module.exports, "getContainingBlock", function () { return $e7725b143600c9c2$export$940d8225183e1404; });
$parcel$export(module.exports, "getParentNode", function () { return $e7725b143600c9c2$export$4e12058fc4d51d56; });
$parcel$export(module.exports, "isLastTraversableNode", function () { return $e7725b143600c9c2$export$d1162fb0b6d4cd51; });
$parcel$export(module.exports, "getNodeScroll", function () { return $e7725b143600c9c2$export$dc8fc79fa2800137; });
$parcel$export(module.exports, "getOverflowAncestors", function () { return $e7725b143600c9c2$export$3b57c1601291186b; });
function $e7725b143600c9c2$export$651544f548703224(node) {
    if ($e7725b143600c9c2$export$8ee0fc9ee280b4ee(node)) return (node.nodeName || "").toLowerCase();
    // Mocked nodes in testing environments may not be instances of Node. By
    // returning `#document` an infinite loop won't occur.
    // https://github.com/floating-ui/floating-ui/issues/2317
    return "#document";
}
function $e7725b143600c9c2$export$38b2d434cce3ea22(node) {
    var _node$ownerDocument;
    return (node == null ? void 0 : (_node$ownerDocument = node.ownerDocument) == null ? void 0 : _node$ownerDocument.defaultView) || window;
}
function $e7725b143600c9c2$export$e495491855dc5418(node) {
    var _ref;
    return (_ref = ($e7725b143600c9c2$export$8ee0fc9ee280b4ee(node) ? node.ownerDocument : node.document) || window.document) == null ? void 0 : _ref.documentElement;
}
function $e7725b143600c9c2$export$8ee0fc9ee280b4ee(value) {
    return value instanceof Node || value instanceof $e7725b143600c9c2$export$38b2d434cce3ea22(value).Node;
}
function $e7725b143600c9c2$export$45a5e7f76e0caa8d(value) {
    return value instanceof Element || value instanceof $e7725b143600c9c2$export$38b2d434cce3ea22(value).Element;
}
function $e7725b143600c9c2$export$1b3bfaa9684536aa(value) {
    return value instanceof HTMLElement || value instanceof $e7725b143600c9c2$export$38b2d434cce3ea22(value).HTMLElement;
}
function $e7725b143600c9c2$export$af51f0f06c0f328a(value) {
    // Browsers without `ShadowRoot` support.
    if (typeof ShadowRoot === "undefined") return false;
    return value instanceof ShadowRoot || value instanceof $e7725b143600c9c2$export$38b2d434cce3ea22(value).ShadowRoot;
}
function $e7725b143600c9c2$export$989e911fa9af580a(element) {
    const { overflow: overflow, overflowX: overflowX, overflowY: overflowY, display: display } = $e7725b143600c9c2$export$3735103072e4a80(element);
    return /auto|scroll|overlay|hidden|clip/.test(overflow + overflowY + overflowX) && ![
        "inline",
        "contents"
    ].includes(display);
}
function $e7725b143600c9c2$export$71535ffaa902797f(element) {
    return [
        "table",
        "td",
        "th"
    ].includes($e7725b143600c9c2$export$651544f548703224(element));
}
function $e7725b143600c9c2$export$d6c4e8150c35fed1(element) {
    const webkit = $e7725b143600c9c2$export$78551043582a6a98();
    const css = $e7725b143600c9c2$export$3735103072e4a80(element);
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    return css.transform !== "none" || css.perspective !== "none" || (css.containerType ? css.containerType !== "normal" : false) || !webkit && (css.backdropFilter ? css.backdropFilter !== "none" : false) || !webkit && (css.filter ? css.filter !== "none" : false) || [
        "transform",
        "perspective",
        "filter"
    ].some((value)=>(css.willChange || "").includes(value)) || [
        "paint",
        "layout",
        "strict",
        "content"
    ].some((value)=>(css.contain || "").includes(value));
}
function $e7725b143600c9c2$export$940d8225183e1404(element) {
    let currentNode = $e7725b143600c9c2$export$4e12058fc4d51d56(element);
    while($e7725b143600c9c2$export$1b3bfaa9684536aa(currentNode) && !$e7725b143600c9c2$export$d1162fb0b6d4cd51(currentNode)){
        if ($e7725b143600c9c2$export$d6c4e8150c35fed1(currentNode)) return currentNode;
        else currentNode = $e7725b143600c9c2$export$4e12058fc4d51d56(currentNode);
    }
    return null;
}
function $e7725b143600c9c2$export$78551043582a6a98() {
    if (typeof CSS === "undefined" || !CSS.supports) return false;
    return CSS.supports("-webkit-backdrop-filter", "none");
}
function $e7725b143600c9c2$export$d1162fb0b6d4cd51(node) {
    return [
        "html",
        "body",
        "#document"
    ].includes($e7725b143600c9c2$export$651544f548703224(node));
}
function $e7725b143600c9c2$export$3735103072e4a80(element) {
    return $e7725b143600c9c2$export$38b2d434cce3ea22(element).getComputedStyle(element);
}
function $e7725b143600c9c2$export$dc8fc79fa2800137(element) {
    if ($e7725b143600c9c2$export$45a5e7f76e0caa8d(element)) return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
    return {
        scrollLeft: element.pageXOffset,
        scrollTop: element.pageYOffset
    };
}
function $e7725b143600c9c2$export$4e12058fc4d51d56(node) {
    if ($e7725b143600c9c2$export$651544f548703224(node) === "html") return node;
    const result = // Step into the shadow DOM of the parent of a slotted node.
    node.assignedSlot || // DOM Element detected.
    node.parentNode || // ShadowRoot detected.
    $e7725b143600c9c2$export$af51f0f06c0f328a(node) && node.host || // Fallback.
    $e7725b143600c9c2$export$e495491855dc5418(node);
    return $e7725b143600c9c2$export$af51f0f06c0f328a(result) ? result.host : result;
}
function $e7725b143600c9c2$export$7cd01a57c8ca906c(node) {
    const parentNode = $e7725b143600c9c2$export$4e12058fc4d51d56(node);
    if ($e7725b143600c9c2$export$d1162fb0b6d4cd51(parentNode)) return node.ownerDocument ? node.ownerDocument.body : node.body;
    if ($e7725b143600c9c2$export$1b3bfaa9684536aa(parentNode) && $e7725b143600c9c2$export$989e911fa9af580a(parentNode)) return parentNode;
    return $e7725b143600c9c2$export$7cd01a57c8ca906c(parentNode);
}
function $e7725b143600c9c2$export$3b57c1601291186b(node, list, traverseIframes) {
    var _node$ownerDocument2;
    if (list === void 0) list = [];
    if (traverseIframes === void 0) traverseIframes = true;
    const scrollableAncestor = $e7725b143600c9c2$export$7cd01a57c8ca906c(node);
    const isBody = scrollableAncestor === ((_node$ownerDocument2 = node.ownerDocument) == null ? void 0 : _node$ownerDocument2.body);
    const win = $e7725b143600c9c2$export$38b2d434cce3ea22(scrollableAncestor);
    if (isBody) return list.concat(win, win.visualViewport || [], $e7725b143600c9c2$export$989e911fa9af580a(scrollableAncestor) ? scrollableAncestor : [], win.frameElement && traverseIframes ? $e7725b143600c9c2$export$3b57c1601291186b(win.frameElement) : []);
    return list.concat(scrollableAncestor, $e7725b143600c9c2$export$3b57c1601291186b(scrollableAncestor, [], traverseIframes));
}

});


parcelRegister("3fOxZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $25e9fb6a7fb483de$export$2e2bcd8739ae039; });

var $iSvIT = parcelRequire("iSvIT");
var $25e9fb6a7fb483de$var$index = (0, $iSvIT.useLayoutEffect);
var $25e9fb6a7fb483de$export$2e2bcd8739ae039 = $25e9fb6a7fb483de$var$index;

});










//# sourceMappingURL=personalization-container.536be62f.js.map
